(function (g, f) {
    if ("object" == typeof exports && "object" == typeof module) {
      module.exports = f();
    } else if ("function" == typeof define && define.amd) {
      define("agChartsLocale", [], f);
    } else if ("object" == typeof exports) {
      exports["agChartsLocale"] = f();
    } else {
      g["agChartsLocale"] = f();
    }
  }(this, () => {
var exports = {};
var module = { exports };
if (typeof require === 'undefined') {
    function require(name) {
        
        throw new Error('Unknown module: ' + name);
    }
}
        
"use strict";

// packages/ag-charts-locale/dist/package/main.cjs.js
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var main_exports = {};
__export(main_exports, {
  AG_CHARTS_LOCALE_AR_EG: () => AG_CHARTS_LOCALE_AR_EG,
  AG_CHARTS_LOCALE_BG_BG: () => AG_CHARTS_LOCALE_BG_BG,
  AG_CHARTS_LOCALE_CS_CZ: () => AG_CHARTS_LOCALE_CS_CZ,
  AG_CHARTS_LOCALE_DA_DK: () => AG_CHARTS_LOCALE_DA_DK,
  AG_CHARTS_LOCALE_DE_DE: () => AG_CHARTS_LOCALE_DE_DE,
  AG_CHARTS_LOCALE_EL_GR: () => AG_CHARTS_LOCALE_EL_GR,
  AG_CHARTS_LOCALE_EN_US: () => AG_CHARTS_LOCALE_EN_US,
  AG_CHARTS_LOCALE_ES_ES: () => AG_CHARTS_LOCALE_ES_ES,
  AG_CHARTS_LOCALE_FA_IR: () => AG_CHARTS_LOCALE_FA_IR,
  AG_CHARTS_LOCALE_FI_FI: () => AG_CHARTS_LOCALE_FI_FI,
  AG_CHARTS_LOCALE_FR_FR: () => AG_CHARTS_LOCALE_FR_FR,
  AG_CHARTS_LOCALE_HE_IL: () => AG_CHARTS_LOCALE_HE_IL,
  AG_CHARTS_LOCALE_HR_HR: () => AG_CHARTS_LOCALE_HR_HR,
  AG_CHARTS_LOCALE_HU_HU: () => AG_CHARTS_LOCALE_HU_HU,
  AG_CHARTS_LOCALE_IT_IT: () => AG_CHARTS_LOCALE_IT_IT,
  AG_CHARTS_LOCALE_JA_JP: () => AG_CHARTS_LOCALE_JA_JP,
  AG_CHARTS_LOCALE_KO_KR: () => AG_CHARTS_LOCALE_KO_KR,
  AG_CHARTS_LOCALE_NB_NO: () => AG_CHARTS_LOCALE_NB_NO,
  AG_CHARTS_LOCALE_NL_NL: () => AG_CHARTS_LOCALE_NL_NL,
  AG_CHARTS_LOCALE_PL_PL: () => AG_CHARTS_LOCALE_PL_PL,
  AG_CHARTS_LOCALE_PT_BR: () => AG_CHARTS_LOCALE_PT_BR,
  AG_CHARTS_LOCALE_PT_PT: () => AG_CHARTS_LOCALE_PT_PT,
  AG_CHARTS_LOCALE_RO_RO: () => AG_CHARTS_LOCALE_RO_RO,
  AG_CHARTS_LOCALE_SK_SK: () => AG_CHARTS_LOCALE_SK_SK,
  AG_CHARTS_LOCALE_SV_SE: () => AG_CHARTS_LOCALE_SV_SE,
  AG_CHARTS_LOCALE_TR_TR: () => AG_CHARTS_LOCALE_TR_TR,
  AG_CHARTS_LOCALE_UK_UA: () => AG_CHARTS_LOCALE_UK_UA,
  AG_CHARTS_LOCALE_UR_PK: () => AG_CHARTS_LOCALE_UR_PK,
  AG_CHARTS_LOCALE_VI_VN: () => AG_CHARTS_LOCALE_VI_VN,
  AG_CHARTS_LOCALE_ZH_CN: () => AG_CHARTS_LOCALE_ZH_CN,
  AG_CHARTS_LOCALE_ZH_HK: () => AG_CHARTS_LOCALE_ZH_HK,
  AG_CHARTS_LOCALE_ZH_TW: () => AG_CHARTS_LOCALE_ZH_TW
});
module.exports = __toCommonJS(main_exports);
var AG_CHARTS_LOCALE_AR_EG = {
  ariaAnnounceChart: "\u0645\u062E\u0637\u0637\u060C ${seriesCount}[number] \u0633\u0644\u0633\u0644\u0629",
  ariaAnnounceFlowProportionLink: "\u0631\u0627\u0628\u0637 ${index} \u0645\u0646 ${count}\u060C \u0645\u0646 ${from} \u0625\u0644\u0649 ${to}\u060C ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u0627\u0644\u0639\u0642\u062F\u0629 ${index} \u0645\u0646 ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u0645\u062E\u0637\u0637 \u0627\u0644\u0645\u0642\u064A\u0627\u0633\u060C ${caption}",
  ariaAnnounceHierarchyChart: "\u0645\u062E\u0637\u0637 \u0647\u0631\u0645\u064A\u060C ${caption}",
  ariaAnnounceHierarchyDatum: "\u0627\u0644\u0645\u0633\u062A\u0648\u0649 ${level}[number]\u060C ${count}[number] \u0623\u0637\u0641\u0627\u0644\u060C ${description}",
  ariaAnnounceHoverDatum: "${datum} \u0627\u0644\u0645\u0648\u062C\u0648\u062F \u0639\u0644\u0649",
  ariaDescriptionLegendItem: "\u0627\u0636\u063A\u0637 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u0627\u0641\u0629 \u0623\u0648 \u0627\u0644\u0625\u062F\u062E\u0627\u0644 \u0644\u0644\u062A\u0628\u062F\u064A\u0644 \u0628\u064A\u0646 \u0627\u0644\u0631\u0624\u064A\u0629",
  ariaLabelAddHorizontalLine: "\u0625\u0636\u0627\u0641\u0629 \u062E\u0637 \u0623\u0641\u0642\u064A",
  ariaLabelAnnotationOptionsToolbar: "\u062E\u064A\u0627\u0631\u0627\u062A \u0627\u0644\u062A\u0639\u0644\u064A\u0642",
  ariaLabelAnnotationSettingsDialog: "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0639\u0644\u064A\u0642 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A",
  ariaLabelColorPicker: "\u0645\u0646\u062A\u0642\u064A \u0627\u0644\u0623\u0644\u0648\u0627\u0646",
  ariaLabelFinancialCharts: "\u0627\u0644\u0631\u0633\u0648\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u064A\u0629 \u0627\u0644\u0645\u0627\u0644\u064A\u0629",
  ariaLabelLegend: "\u0627\u0644\u0623\u0633\u0637\u0648\u0631\u0629",
  ariaLabelLegendItem: "${label}\u060C \u0639\u0646\u0635\u0631 \u0627\u0644\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062A\u0641\u0633\u064A\u0631\u064A \u0631\u0642\u0645 ${index}[number] \u0645\u0646 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u0639\u0646\u0635\u0631 \u063A\u064A\u0631 \u0645\u0639\u0631\u0648\u0641 \u0641\u064A \u0627\u0644\u0623\u0633\u0637\u0648\u0631\u0629",
  ariaLabelLegendPageNext: "\u0635\u0641\u062D\u0629 \u0627\u0644\u0631\u0645\u0648\u0632 \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629 \u0627\u0644\u062A\u0627\u0644\u064A\u0629",
  ariaLabelLegendPagePrevious: "\u0635\u0641\u062D\u0629 \u0627\u0644\u0623\u0633\u0637\u0648\u0631\u0629 \u0627\u0644\u0633\u0627\u0628\u0642\u0629",
  ariaLabelLegendPagination: "\u062A\u0643\u0631\u0627\u0631 \u0627\u0644\u0623\u0633\u0637\u0648\u0631\u0629",
  ariaLabelNavigator: "\u0627\u0644\u0645\u064F\u062A\u064E\u0646\u064E\u0642\u0650\u0651\u0644",
  ariaLabelNavigatorMaximum: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649",
  ariaLabelNavigatorMinimum: "\u0627\u0644\u062D\u062F \u0627\u0644\u0623\u062F\u0646\u0649",
  ariaLabelNavigatorRange: "\u0627\u0644\u0645\u062F\u0649",
  ariaLabelRangesToolbar: "\u0627\u0644\u0646\u0637\u0627\u0642\u0627\u062A",
  ariaLabelSettingsTabBar: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
  ariaLabelZoomToolbar: "\u062A\u0643\u0628\u064A\u0631",
  ariaValuePanRange: "${min}[percent0to2dp] \u0625\u0644\u0649 ${max}[percent0to2dp]",
  contextMenuDownload: "\u062A\u0646\u0632\u064A\u0644",
  contextMenuPanToCursor: "\u062A\u062D\u0631\u064A\u0643 \u0625\u0644\u0649 \u0647\u0646\u0627",
  contextMenuToggleOtherSeries: "\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0633\u0644\u0627\u0633\u0644 \u0627\u0644\u0623\u062E\u0631\u0649",
  contextMenuToggleSeriesVisibility: "\u062A\u0628\u062F\u064A\u0644 \u0627\u0644\u0631\u0624\u064A\u0629",
  contextMenuZoomToCursor: "\u0627\u0644\u062A\u0643\u0628\u064A\u0631 \u0625\u0644\u0649 \u0647\u0646\u0627",
  dialogHeaderChannel: "\u0627\u0644\u0642\u0646\u0627\u0629",
  dialogHeaderDatePriceRange: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0633\u0639\u0631",
  dialogHeaderDateRange: "\u0627\u0644\u0646\u0637\u0627\u0642 \u0627\u0644\u0632\u0645\u0646\u064A",
  dialogHeaderFibonacciRange: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0635\u062D\u064A\u062D \u0641\u064A\u0628\u0648\u0646\u0627\u062A\u0634\u064A",
  dialogHeaderLine: "\u2018\u062E\u0637\u2019",
  dialogHeaderPriceRange: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0633\u0639\u0631",
  dialogHeaderText: "\u0646\u0635",
  dialogInputAlign: "\u062A\u0648\u062C\u064A\u0647",
  dialogInputColorPicker: "\u0627\u0644\u0644\u0648\u0646",
  dialogInputColorPickerAltText: "\u0644\u0648\u0646 \u0627\u0644\u0646\u0635",
  dialogInputExtendAbove: "\u062A\u0645\u062F\u064A\u062F \u0625\u0644\u0649 \u0627\u0644\u0623\u0639\u0644\u0649",
  dialogInputExtendBelow: "\u0645\u062F \u0627\u0644\u062A\u0645\u062F\u064A\u062F \u0644\u0644\u0623\u0633\u0641\u0644",
  dialogInputExtendChannelEnd: "\u062A\u0645\u062F\u064A\u062F \u0646\u0647\u0627\u064A\u0629 \u0627\u0644\u0642\u0646\u0627\u0629",
  dialogInputExtendChannelStart: "\u062A\u0645\u062F\u064A\u062F \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0642\u0646\u0627\u0629",
  dialogInputExtendLeft: "\u062A\u0645\u062F\u064A\u062F \u0625\u0644\u0649 \u0627\u0644\u064A\u0633\u0627\u0631",
  dialogInputExtendLineEnd: "Extend line end",
  dialogInputExtendLineStart: "\u062A\u0645\u062F\u064A\u062F \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u062E\u0637",
  dialogInputExtendRight: "\u062A\u0648\u0633\u064A\u0639 \u0644\u0644\u064A\u0645\u064A\u0646",
  dialogInputFibonacciBands: "\u0627\u0644\u0623\u0634\u0631\u0637\u0629",
  dialogInputFibonacciBandsAltText: "\u0623\u0634\u0631\u0637\u0629 \u0641\u064A\u0628\u0648\u0646\u0627\u062A\u0634\u064A",
  dialogInputFillColorPicker: "\u062A\u0639\u0628\u0626\u0629",
  dialogInputFillColorPickerAltText: "\u0644\u0648\u0646 \u0627\u0644\u062A\u0639\u0628\u0626\u0629",
  dialogInputFontSize: "\u062D\u062C\u0645",
  dialogInputFontSizeAltText: "\u062D\u062C\u0645 \u0627\u0644\u062E\u0637",
  dialogInputLineStyle: "\u0634\u0631\u0637\u0629",
  dialogInputPosition: "\u0627\u0644\u0645\u0648\u0636\u0639",
  dialogInputReverse: "\u0639\u0643\u0633",
  dialogInputShowFill: "\u0625\u0638\u0647\u0627\u0631 \u0627\u0644\u0645\u0644\u0621",
  dialogInputStrokeWidth: "\u0648\u064E\u0632\u0646",
  dialogInputStrokeWidthAltText: "\u0648\u064E\u0632\u0646 \u0627\u0644\u062E\u0637",
  iconAltTextAlignCenter: "\u0645\u0631\u0643\u0632",
  iconAltTextAlignLeft: "\u064A\u0633\u0627\u0631",
  iconAltTextAlignRight: "\u064A\u0645\u064A\u0646",
  iconAltTextClose: "\u0625\u063A\u0644\u0627\u0642",
  iconAltTextLineStyleDashed: "\u0627\u0644\u0645\u062A\u0642\u0637\u0639 \u0627\u0644\u0637\u0648\u064A\u0644",
  iconAltTextLineStyleDotted: "\u0645\u064F\u062E\u0637\u0637 \u0645\u062A\u0642\u0637\u0639",
  iconAltTextLineStyleSolid: "\u0635\u0644\u0628",
  iconAltTextPositionBottom: "\u0627\u0644\u0623\u0633\u0641\u0644",
  iconAltTextPositionCenter: "\u0645\u0631\u0643\u0632",
  iconAltTextPositionTop: "\u0623\u0639\u0644\u0649",
  inputTextareaPlaceholder: "\u0623\u0636\u0641 \u0646\u0635",
  measurerDateRangeBars: "${value}[number] \u0623\u0634\u0631\u0637\u0629",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u0627\u0644\u062D\u062C\u0645 ${value}",
  overlayLoadingData: "\u062C\u0627\u0631\u064D \u062A\u062D\u0645\u064A\u0644 \u0627\u0644\u0628\u064A\u0627\u0646\u0627\u062A...",
  overlayNoData: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0628\u064A\u0627\u0646\u0627\u062A \u0644\u0639\u0631\u0636\u0647\u0627",
  overlayNoVisibleSeries: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0633\u0644\u0633\u0644\u0629 \u0645\u0631\u0626\u064A\u0629",
  overlayUnsupportedBrowser: "\u0625\u0635\u062F\u0627\u0631 \u0627\u0644\u0645\u062A\u0635\u0641\u062D \u063A\u064A\u0631 \u0645\u062A\u0648\u0627\u0641\u0642. \u064A\u0631\u062C\u0649 \u062A\u0631\u0642\u064A\u0629 \u0627\u0644\u0645\u062A\u0635\u0641\u062D.",
  seriesHistogramTooltipCount: "${yName} (\u0627\u0644\u0639\u062F\u062F)",
  seriesHistogramTooltipFrequency: "\u0627\u0644\u062A\u0643\u0631\u0627\u0631",
  seriesHistogramTooltipMean: "${yName} (\u0627\u0644\u0645\u062A\u0648\u0633\u0637)",
  seriesHistogramTooltipSum: "${yName} (\u0627\u0644\u0645\u062C\u0645\u0648\u0639)",
  toolbarAnnotationsArrow: "\u0633\u0647\u0645",
  toolbarAnnotationsArrowDown: "\u0633\u0647\u0645 \u0644\u0623\u0633\u0641\u0644",
  toolbarAnnotationsArrowUp: "\u0633\u0647\u0645 \u0644\u0623\u0639\u0644\u0649",
  toolbarAnnotationsCallout: "\u062A\u0639\u0644\u064A\u0642",
  toolbarAnnotationsClearAll: "\u0627\u0645\u0633\u062D \u0627\u0644\u0643\u0644",
  toolbarAnnotationsComment: "\u062A\u0639\u0644\u064A\u0642",
  toolbarAnnotationsDatePriceRange: "\u0627\u0644\u062A\u0627\u0631\u064A\u062E \u0648\u0627\u0644\u0633\u0639\u0631",
  toolbarAnnotationsDateRange: "\u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  toolbarAnnotationsDelete: "\u062D\u0630\u0641",
  toolbarAnnotationsDisjointChannel: "\u0642\u0646\u0627\u0629 \u0645\u0646\u0641\u0635\u0644\u0629",
  toolbarAnnotationsDragHandle: "\u0633\u062D\u0628 \u0634\u0631\u064A\u0637 \u0627\u0644\u0623\u062F\u0648\u0627\u062A",
  toolbarAnnotationsFibonacciAnnotations: "\u0641\u064A\u0628\u0648\u0646\u0627\u062A\u0634\u064A",
  toolbarAnnotationsFibonacciRetracement: "\u0627\u0631\u062A\u062F\u0627\u062F \u0641\u064A\u0628",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0627\u0644\u0641\u064A\u0628\u0648\u0646\u0627\u062A\u0634\u064A \u0627\u0644\u0645\u0633\u062A\u0646\u062F \u0625\u0644\u0649 \u0627\u0644\u0627\u062A\u062C\u0627\u0647",
  toolbarAnnotationsFillColor: "\u0644\u0648\u0646 \u0627\u0644\u062A\u0639\u0628\u0626\u0629",
  toolbarAnnotationsHorizontalLine: "\u062E\u0637 \u0623\u0641\u0642\u064A",
  toolbarAnnotationsLineAnnotations: "\u062E\u0637\u0648\u0637 \u0627\u0644\u0627\u062A\u062C\u0627\u0647",
  toolbarAnnotationsLineColor: "\u0644\u0648\u0646 \u0627\u0644\u062E\u0637",
  toolbarAnnotationsLineStrokeWidth: "\u0639\u0631\u0636 \u062E\u0637 \u0627\u0644\u0631\u0633\u0645",
  toolbarAnnotationsLineStyle: "\u0646\u0648\u0639 \u0627\u0644\u062E\u0637",
  toolbarAnnotationsLock: "\u0642\u0641\u0644",
  toolbarAnnotationsMeasurerAnnotations: "\u0627\u0644\u0642\u064A\u0627\u0633\u0627\u062A",
  toolbarAnnotationsNote: "\u0645\u0644\u0627\u062D\u0638\u0629",
  toolbarAnnotationsParallelChannel: "\u0642\u0646\u0627\u0629 \u0645\u062A\u0648\u0627\u0632\u064A\u0629",
  toolbarAnnotationsPriceRange: "\u0646\u0637\u0627\u0642 \u0627\u0644\u0633\u0639\u0631",
  toolbarAnnotationsQuickDatePriceRange: "\u0642\u064A\u0627\u0633",
  toolbarAnnotationsSettings: "\u0627\u0644\u0625\u0639\u062F\u0627\u062F\u0627\u062A",
  toolbarAnnotationsShapeAnnotations: "\u0627\u0644\u0623\u0633\u0647\u0645",
  toolbarAnnotationsText: "\u0646\u0635",
  toolbarAnnotationsTextAnnotations: "\u0627\u0644\u0643\u062A\u0627\u0628\u0627\u062A \u0627\u0644\u062A\u0648\u0636\u064A\u062D\u064A\u0629",
  toolbarAnnotationsTextColor: "\u0644\u0648\u0646 \u0627\u0644\u0646\u0635",
  toolbarAnnotationsTextSize: "\u062D\u062C\u0645 \u0627\u0644\u0646\u0635",
  toolbarAnnotationsTrendLine: "\u062E\u0637 \u0627\u0644\u0627\u062A\u062C\u0627\u0647",
  toolbarAnnotationsUnlock: "\u0627\u0641\u062A\u062D \u0627\u0644\u0642\u0641\u0644",
  toolbarAnnotationsVerticalLine: "\u0627\u0644\u062E\u0637 \u0627\u0644\u0639\u0645\u0648\u062F\u064A",
  toolbarRange1Month: "1\u0634",
  toolbarRange1MonthAria: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
  toolbarRange1Year: "\u0633\u0646\u0629",
  toolbarRange1YearAria: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
  toolbarRange3Months: "\u0663 \u0634\u0647\u0648\u0631",
  toolbarRange3MonthsAria: "\u0663 \u0634\u0647\u0648\u0631",
  toolbarRange6Months: "\u0666\u0634",
  toolbarRange6MonthsAria: "\u0666 \u0634\u0647\u0648\u0631",
  toolbarRangeAll: "\u0627\u0644\u0643\u0644",
  toolbarRangeAllAria: "\u0627\u0644\u0643\u0644",
  toolbarRangeYearToDate: "\u0627\u0644\u0633\u0646\u0629 \u062D\u062A\u0649 \u062A\u0627\u0631\u064A\u062E\u0647",
  toolbarRangeYearToDateAria: "\u0645\u0646\u0630 \u0628\u062F\u0627\u064A\u0629 \u0627\u0644\u0633\u0646\u0629",
  toolbarSeriesTypeCandles: "\u0627\u0644\u0634\u0645\u0648\u0639",
  toolbarSeriesTypeDropdown: "\u0646\u0648\u0639 \u0627\u0644\u0631\u0633\u0645 \u0627\u0644\u0628\u064A\u0627\u0646\u064A",
  toolbarSeriesTypeHighLow: "\u0645\u0631\u062A\u0641\u0639 \u0645\u0646\u062E\u0641\u0636",
  toolbarSeriesTypeHLC: "\u0625\u062A\u0634 \u0625\u0644 \u0633\u064A",
  toolbarSeriesTypeHollowCandles: "\u0627\u0644\u0634\u0645\u0648\u0639 \u0627\u0644\u0645\u062C\u0648\u0641\u0629",
  toolbarSeriesTypeLine: "\u062E\u0637",
  toolbarSeriesTypeLineWithMarkers: "\u062E\u0637 \u0645\u0639 \u0639\u0644\u0627\u0645\u0627\u062A",
  toolbarSeriesTypeOHLC: "\u0623\u0648 \u0625\u062A\u0634 \u0625\u0644 \u0633\u064A",
  toolbarSeriesTypeStepLine: "\u062E\u0637\u0648\u0629 \u0627\u0644\u0633\u0637\u0631",
  toolbarZoomPanEnd: "\u0627\u0644\u062A\u062C\u0648\u0644 \u0625\u0644\u0649 \u0627\u0644\u0646\u0647\u0627\u064A\u0629",
  toolbarZoomPanLeft: "\u062A\u062D\u0631\u064A\u0643 \u0644\u0644\u064A\u0633\u0627\u0631",
  toolbarZoomPanRight: "\u062A\u062D\u0631\u064A\u0643 \u0644\u0644\u064A\u0645\u064A\u0646",
  toolbarZoomPanStart: "\u0627\u0644\u062A\u062D\u0631\u064A\u0643 \u0625\u0644\u0649 \u0627\u0644\u0628\u062F\u0627\u064A\u0629",
  toolbarZoomReset: "\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0627\u0644\u062A\u0643\u0628\u064A\u0631",
  toolbarZoomZoomIn: "\u062A\u0643\u0628\u064A\u0631",
  toolbarZoomZoomOut: "\u062A\u0635\u063A\u064A\u0631",
  tooltipPaginationStatus: "${index}[number] \u0645\u0646 ${count}[number]"
};
var AG_CHARTS_LOCALE_BG_BG = {
  ariaAnnounceChart: "\u0434\u0438\u0430\u0433\u0440\u0430\u043C\u0430, ${seriesCount}[number] \u0441\u0435\u0440\u0438\u0438",
  ariaAnnounceFlowProportionLink: "\u0432\u0440\u044A\u0437\u043A\u0430 ${index} \u043E\u0442 ${count}, \u043E\u0442 ${from} \u0434\u043E ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u0432\u044A\u0437\u0435\u043B ${index} \u043E\u0442 ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u0433\u0440\u0430\u0444\u0438\u043A\u0430 \u0442\u0438\u043F \u043C\u0430\u043D\u043E\u043C\u0435\u0442\u044A\u0440, ${caption}",
  ariaAnnounceHierarchyChart: "\u0439\u0435\u0440\u0430\u0440\u0445\u0438\u0447\u043D\u0430 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u0430, ${caption}",
  ariaAnnounceHierarchyDatum: "\u043D\u0438\u0432\u043E ${level}[number], ${count}[number] \u0434\u0435\u0446\u0430, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u041D\u0430\u0442\u0438\u0441\u043D\u0435\u0442\u0435 Space \u0438\u043B\u0438 Enter, \u0437\u0430 \u0434\u0430 \u043F\u0440\u0435\u0432\u043A\u043B\u044E\u0447\u0438\u0442\u0435 \u0432\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u0442\u0430",
  ariaLabelAddHorizontalLine: "\u0414\u043E\u0431\u0430\u0432\u044F\u043D\u0435 \u043D\u0430 \u0445\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u043D\u0430 \u043B\u0438\u043D\u0438\u044F",
  ariaLabelAnnotationOptionsToolbar: "\u041E\u043F\u0446\u0438\u0438 \u0437\u0430 \u0430\u043D\u043E\u0442\u0430\u0446\u0438\u044F",
  ariaLabelAnnotationSettingsDialog: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 \u0430\u043D\u043E\u0442\u0430\u0446\u0438\u0438",
  ariaLabelColorPicker: "\u0426\u0432\u0435\u0442\u043E\u0432\u0430 \u043F\u0430\u043B\u0438\u0442\u0440\u0430",
  ariaLabelFinancialCharts: "\u0424\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u0438 \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u0438",
  ariaLabelLegend: "\u041B\u0435\u0433\u0435\u043D\u0434\u0430",
  ariaLabelLegendItem: "${label}, \u0415\u043B\u0435\u043C\u0435\u043D\u0442 \u043D\u0430 \u043B\u0435\u0433\u0435\u043D\u0434\u0430\u0442\u0430 ${index}[number] \u043E\u0442 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u0435\u043D \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u0432 \u043B\u0435\u0433\u0435\u043D\u0434\u0430\u0442\u0430",
  ariaLabelLegendPageNext: "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0430 \u043B\u0435\u0433\u0435\u043D\u0434\u0430\u0442\u0430",
  ariaLabelLegendPagePrevious: "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430 \u043D\u0430 \u043B\u0435\u0433\u0435\u043D\u0434\u0430\u0442\u0430",
  ariaLabelLegendPagination: "\u041F\u0430\u0433\u0438\u043D\u0430\u0446\u0438\u044F \u043D\u0430 \u043B\u0435\u0433\u0435\u043D\u0434\u0430\u0442\u0430",
  ariaLabelNavigator: "\u041D\u0430\u0432\u0438\u0433\u0430\u0442\u043E\u0440",
  ariaLabelNavigatorMaximum: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
  ariaLabelNavigatorMinimum: "\u041C\u0438\u043D\u0438\u043C\u0443\u043C",
  ariaLabelNavigatorRange: "\u041E\u0431\u0445\u0432\u0430\u0442",
  ariaLabelRangesToolbar: "\u041E\u0431\u0445\u0432\u0430\u0442\u0438",
  ariaLabelSettingsTabBar: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  ariaLabelZoomToolbar: "\u041C\u0430\u0449\u0430\u0431\u0438\u0440\u0430\u043D\u0435",
  ariaValuePanRange: "${min}[percent0to2dp] \u0434\u043E ${max}[percent0to2dp]",
  contextMenuDownload: "\u0418\u0437\u0442\u0435\u0433\u043B\u044F\u043D\u0435",
  contextMenuPanToCursor: "\u041F\u0440\u0435\u043C\u0435\u0441\u0442\u0438 \u0442\u0443\u043A",
  contextMenuToggleOtherSeries: "\u041F\u0440\u0435\u0432\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435 \u043D\u0430 \u0434\u0440\u0443\u0433\u0438 \u0441\u0435\u0440\u0438\u0438",
  contextMenuToggleSeriesVisibility: "\u041F\u0440\u0435\u0432\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435 \u043D\u0430 \u0432\u0438\u0434\u0438\u043C\u043E\u0441\u0442\u0442\u0430",
  contextMenuZoomToCursor: "\u0423\u0432\u0435\u043B\u0438\u0447\u0438 \u0434\u043E \u0442\u0443\u043A",
  dialogHeaderChannel: "\u041A\u0430\u043D\u0430\u043B",
  dialogHeaderDatePriceRange: "\u0414\u0430\u0442\u0430 \u0438 \u0426\u0435\u043D\u0430",
  dialogHeaderDateRange: "\u041F\u0435\u0440\u0438\u043E\u0434 \u043D\u0430 \u0434\u0430\u0442\u0438",
  dialogHeaderFibonacciRange: "\u0424\u0438\u0431 \u0440\u0435\u0442\u0440\u0435\u0439\u0441\u043C\u0435\u043D\u0442",
  dialogHeaderLine: "\u041B\u0438\u043D\u0438\u044F",
  dialogHeaderPriceRange: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u043D\u0430 \u0446\u0435\u043D\u0438\u0442\u0435",
  dialogHeaderText: "\u0422\u0435\u043A\u0441\u0442",
  dialogInputAlign: "\u041F\u043E\u0434\u0440\u0430\u0432\u043D\u044F\u0432\u0430\u043D\u0435",
  dialogInputColorPicker: "\u0426\u0432\u044F\u0442",
  dialogInputColorPickerAltText: "\u0426\u0432\u044F\u0442 \u043D\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
  dialogInputExtendAbove: "\u0420\u0430\u0437\u0448\u0438\u0440\u0438 \u043D\u0430\u0433\u043E\u0440\u0435",
  dialogInputExtendBelow: "\u0420\u0430\u0437\u0448\u0438\u0440\u0438 \u043E\u0442\u0434\u043E\u043B\u0443",
  dialogInputExtendChannelEnd: "\u0423\u0434\u044A\u043B\u0436\u0435\u0442\u0435 \u043A\u0440\u0430\u044F \u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u0430",
  dialogInputExtendChannelStart: "\u0420\u0430\u0437\u0448\u0438\u0440\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u0442\u043E \u043D\u0430 \u043A\u0430\u043D\u0430\u043B\u0430",
  dialogInputExtendLeft: "\u0423\u0434\u044A\u043B\u0436\u0438 \u043D\u0430\u043B\u044F\u0432\u043E",
  dialogInputExtendLineEnd: "\u0423\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043A\u0440\u0430\u044F \u043D\u0430 \u043B\u0438\u043D\u0438\u044F\u0442\u0430",
  dialogInputExtendLineStart: "\u0423\u0434\u044A\u043B\u0436\u0430\u0432\u0430\u043D\u0435 \u043D\u0430 \u043D\u0430\u0447\u0430\u043B\u043E\u0442\u043E \u043D\u0430 \u043B\u0438\u043D\u0438\u044F\u0442\u0430",
  dialogInputExtendRight: "\u0420\u0430\u0437\u0433\u044A\u043D\u0438 \u043D\u0430\u0434\u044F\u0441\u043D\u043E",
  dialogInputFibonacciBands: "\u041B\u0435\u043D\u0442\u0438",
  dialogInputFibonacciBandsAltText: "\u0424\u0438\u0431\u043E\u043D\u0430\u0447\u0438 \u043B\u0435\u043D\u0442\u0438",
  dialogInputFillColorPicker: "\u0417\u0430\u043F\u044A\u043B\u0432\u0430\u043D\u0435",
  dialogInputFillColorPickerAltText: "\u0426\u0432\u044F\u0442 \u043D\u0430 \u0437\u0430\u043F\u044A\u043B\u0432\u0430\u043D\u0435",
  dialogInputFontSize: "\u0420\u0430\u0437\u043C\u0435\u0440",
  dialogInputFontSizeAltText: "\u0420\u0430\u0437\u043C\u0435\u0440 \u043D\u0430 \u0448\u0440\u0438\u0444\u0442\u0430",
  dialogInputLineStyle: "\u0422\u0438\u0440\u0435",
  dialogInputPosition: "\u041F\u043E\u0437\u0438\u0446\u0438\u044F",
  dialogInputReverse: "\u041E\u0431\u0440\u044A\u0449\u0430\u043D\u0435",
  dialogInputShowFill: "\u041F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435 \u043D\u0430 \u0437\u0430\u043F\u044A\u043B\u0432\u0430\u043D\u0435",
  dialogInputStrokeWidth: "\u0422\u0435\u0433\u043B\u043E",
  dialogInputStrokeWidthAltText: "\u0428\u0438\u0440\u0438\u043D\u0430 \u043D\u0430 \u043B\u0438\u043D\u0438\u044F\u0442\u0430",
  iconAltTextAlignCenter: "\u0426\u0435\u043D\u0442\u044A\u0440",
  iconAltTextAlignLeft: "\u041B\u044F\u0432\u043E",
  iconAltTextAlignRight: "\u0414\u044F\u0441\u043D\u043E",
  iconAltTextClose: "\u0417\u0430\u0442\u0432\u043E\u0440\u0438",
  iconAltTextLineStyleDashed: "\u0414\u044A\u043B\u0433\u0430 \u043F\u0443\u043D\u043A\u0442\u0438\u0440\u0430\u043D\u0430 \u043B\u0438\u043D\u0438\u044F",
  iconAltTextLineStyleDotted: "\u0421 \u043A\u044A\u0441\u0438 \u0442\u0438\u0440\u0435\u0442\u0430",
  iconAltTextLineStyleSolid: "\u041F\u043B\u044A\u0442\u043D\u0430",
  iconAltTextPositionBottom: "\u0414\u043E\u043B\u0443",
  iconAltTextPositionCenter: "\u0426\u0435\u043D\u0442\u044A\u0440",
  iconAltTextPositionTop: "\u0413\u043E\u0440\u0435",
  inputTextareaPlaceholder: "\u0414\u043E\u0431\u0430\u0432\u0438 \u0442\u0435\u043A\u0441\u0442",
  measurerDateRangeBars: "${value}[number] \u043B\u0435\u043D\u0442\u0438",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "\u201E${value}[number]'",
  measurerVolume: "\u041E\u0431\u0435\u043C ${value}",
  overlayLoadingData: "\u0417\u0430\u0440\u0435\u0436\u0434\u0430\u043D\u0435 \u043D\u0430 \u0434\u0430\u043D\u043D\u0438...",
  overlayNoData: "\u041D\u044F\u043C\u0430 \u0434\u0430\u043D\u043D\u0438 \u0437\u0430 \u043F\u043E\u043A\u0430\u0437\u0432\u0430\u043D\u0435",
  overlayNoVisibleSeries: "\u041D\u044F\u043C\u0430 \u0432\u0438\u0434\u0438\u043C\u0430 \u0441\u0435\u0440\u0438\u044F",
  overlayUnsupportedBrowser: "\u041D\u0435\u0441\u044A\u0432\u043C\u0435\u0441\u0442\u0438\u043C\u0430 \u0432\u0435\u0440\u0441\u0438\u044F \u043D\u0430 \u0431\u0440\u0430\u0443\u0437\u044A\u0440\u0430. \u041C\u043E\u043B\u044F, \u0430\u043A\u0442\u0443\u0430\u043B\u0438\u0437\u0438\u0440\u0430\u0439\u0442\u0435 \u0441\u0432\u043E\u044F \u0431\u0440\u0430\u0443\u0437\u044A\u0440.",
  seriesHistogramTooltipCount: "${yName} (\u0431\u0440\u043E\u0439)",
  seriesHistogramTooltipFrequency: "\u0427\u0435\u0441\u0442\u043E\u0442\u0430",
  seriesHistogramTooltipMean: "${yName} (\u0441\u0440\u0435\u0434\u043D\u043E)",
  seriesHistogramTooltipSum: "${yName} (\u0441\u0443\u043C\u0430)",
  toolbarAnnotationsArrow: "\u0421\u0442\u0440\u0435\u043B\u0430",
  toolbarAnnotationsArrowDown: "\u0421\u0442\u0440\u0435\u043B\u043A\u0430 \u043D\u0430\u0434\u043E\u043B\u0443",
  toolbarAnnotationsArrowUp: "\u0421\u0442\u0440\u0435\u043B\u043A\u0430 \u043D\u0430\u0433\u043E\u0440\u0435",
  toolbarAnnotationsCallout: "\u0410\u043D\u043E\u0442\u0430\u0446\u0438\u044F",
  toolbarAnnotationsClearAll: "\u0418\u0437\u0447\u0438\u0441\u0442\u0438 \u0432\u0441\u0438\u0447\u043A\u043E",
  toolbarAnnotationsComment: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
  toolbarAnnotationsDatePriceRange: "\u0414\u0430\u0442\u0430 \u0438 \u0426\u0435\u043D\u0430",
  toolbarAnnotationsDateRange: "\u0414\u0430\u0442\u0430 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
  toolbarAnnotationsDelete: "\u0418\u0437\u0442\u0440\u0438\u0439",
  toolbarAnnotationsDisjointChannel: "\u041D\u0435\u0441\u0432\u044A\u0440\u0437\u0430\u043D \u043A\u0430\u043D\u0430\u043B",
  toolbarAnnotationsDragHandle: "\u041F\u043B\u044A\u0437\u043D\u0435\u0442\u0435 \u043B\u0435\u043D\u0442\u0430\u0442\u0430 \u0441 \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438",
  toolbarAnnotationsFibonacciAnnotations: "\u0424\u0438\u0431\u043E\u043D\u0430\u0447\u0438",
  toolbarAnnotationsFibonacciRetracement: "\u0424\u0438\u0431 \u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0438\u0435",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0424\u0438\u0431 \u0442\u0440\u0435\u043D\u0434\u043E\u0432\u043E \u0431\u0430\u0437\u0438\u0440\u0430\u043D\u043E",
  toolbarAnnotationsFillColor: "\u0426\u0432\u044F\u0442 \u043D\u0430 \u0437\u0430\u043F\u044A\u043B\u0432\u0430\u043D\u0435",
  toolbarAnnotationsHorizontalLine: "\u0425\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u043D\u0430 \u043B\u0438\u043D\u0438\u044F",
  toolbarAnnotationsLineAnnotations: "\u0422\u0435\u043D\u0434\u0435\u043D\u0446\u0438\u0438",
  toolbarAnnotationsLineColor: "\u0426\u0432\u044F\u0442 \u043D\u0430 \u043B\u0438\u043D\u0438\u044F\u0442\u0430",
  toolbarAnnotationsLineStrokeWidth: "\u0428\u0438\u0440\u0438\u043D\u0430 \u043D\u0430 \u043B\u0438\u043D\u0438\u044F\u0442\u0430",
  toolbarAnnotationsLineStyle: "\u0421\u0442\u0438\u043B \u043D\u0430 \u043B\u0438\u043D\u0438\u044F\u0442\u0430",
  toolbarAnnotationsLock: "\u0417\u0430\u043A\u043B\u044E\u0447\u0432\u0430\u043D\u0435",
  toolbarAnnotationsMeasurerAnnotations: "\u0418\u0437\u043C\u0435\u0440\u0432\u0430\u0442\u0435\u043B\u0438",
  toolbarAnnotationsNote: "\u0417\u0430\u0431\u0435\u043B\u0435\u0436\u043A\u0430",
  toolbarAnnotationsParallelChannel: "\u041F\u0430\u0440\u0430\u043B\u0435\u043B\u0435\u043D \u043A\u0430\u043D\u0430\u043B",
  toolbarAnnotationsPriceRange: "\u0426\u0435\u043D\u043E\u0432\u0438 \u0434\u0438\u0430\u043F\u0430\u0437\u043E\u043D",
  toolbarAnnotationsQuickDatePriceRange: "\u0418\u0437\u043C\u0435\u0440\u0432\u0430\u043D\u0435",
  toolbarAnnotationsSettings: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438",
  toolbarAnnotationsShapeAnnotations: "\u0421\u0442\u0440\u0435\u043B\u0438",
  toolbarAnnotationsText: "\u0422\u0435\u043A\u0441\u0442",
  toolbarAnnotationsTextAnnotations: "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0438 \u0430\u043D\u043E\u0442\u0430\u0446\u0438\u0438",
  toolbarAnnotationsTextColor: "\u0426\u0432\u044F\u0442 \u043D\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
  toolbarAnnotationsTextSize: "\u0420\u0430\u0437\u043C\u0435\u0440 \u043D\u0430 \u0442\u0435\u043A\u0441\u0442\u0430",
  toolbarAnnotationsTrendLine: "\u0422\u0440\u0435\u043D\u0434 \u043B\u0438\u043D\u0438\u044F",
  toolbarAnnotationsUnlock: "\u041E\u0442\u043A\u043B\u044E\u0447\u0438",
  toolbarAnnotationsVerticalLine: "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u043D\u0430 \u043B\u0438\u043D\u0438\u044F",
  toolbarRange1Month: "1\u041C",
  toolbarRange1MonthAria: "1 \u043C\u0435\u0441\u0435\u0446",
  toolbarRange1Year: "1\u0413",
  toolbarRange1YearAria: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
  toolbarRange3Months: "3 \u043C\u0435\u0441.",
  toolbarRange3MonthsAria: "3 \u043C\u0435\u0441\u0435\u0446\u0430",
  toolbarRange6Months: "6\u041C",
  toolbarRange6MonthsAria: "6 \u043C\u0435\u0441\u0435\u0446\u0430",
  toolbarRangeAll: "\u0412\u0441\u0438\u0447\u043A\u0438",
  toolbarRangeAllAria: "\u0412\u0441\u0438\u0447\u043A\u0438",
  toolbarRangeYearToDate: "\u041E\u0442 \u043D\u0430\u0447\u0430\u043B\u043E\u0442\u043E \u043D\u0430 \u0433\u043E\u0434\u0438\u043D\u0430\u0442\u0430",
  toolbarRangeYearToDateAria: "\u0413\u043E\u0434\u0438\u043D\u0430\u0442\u0430 \u0434\u043E \u0434\u043D\u0435\u0448\u043D\u0430 \u0434\u0430\u0442\u0430",
  toolbarSeriesTypeCandles: "\u0421\u0432\u0435\u0449\u0438",
  toolbarSeriesTypeDropdown: "\u0422\u0438\u043F \u0434\u0438\u0430\u0433\u0440\u0430\u043C\u0430",
  toolbarSeriesTypeHighLow: "\u0412\u0438\u0441\u043E\u043A\u043E \u041D\u0438\u0441\u043A\u043E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u041F\u0440\u0430\u0437\u043D\u0438 \u0421\u0432\u0435\u0449\u0438",
  toolbarSeriesTypeLine: "\u041B\u0438\u043D\u0438\u044F",
  toolbarSeriesTypeLineWithMarkers: "\u041B\u0438\u043D\u0438\u044F \u0441 \u043C\u0430\u0440\u043A\u0435\u0440\u0438",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u0421\u0442\u044A\u043F\u043A\u043E\u0432\u043E \u043E\u0447\u0435\u0440\u0442\u0430\u0432\u0430\u043D\u0435",
  toolbarZoomPanEnd: "\u041F\u0440\u0435\u043C\u0435\u0441\u0442\u0432\u0430\u043D\u0435 \u0434\u043E \u043A\u0440\u0430\u044F",
  toolbarZoomPanLeft: "\u041F\u0440\u0435\u043C\u0435\u0441\u0442\u0432\u0430\u043D\u0435 \u043D\u0430\u043B\u044F\u0432\u043E",
  toolbarZoomPanRight: "\u041F\u0440\u0435\u043C\u0435\u0441\u0442\u0432\u0430\u043D\u0435 \u043D\u0430\u0434\u044F\u0441\u043D\u043E",
  toolbarZoomPanStart: "\u041F\u0440\u0438\u0434\u0432\u0438\u0436\u0432\u0430\u043D\u0435 \u0434\u043E \u043D\u0430\u0447\u0430\u043B\u043E\u0442\u043E",
  toolbarZoomReset: "\u041D\u0443\u043B\u0438\u0440\u0430\u043D\u0435 \u043D\u0430 \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u0435\u0442\u043E",
  toolbarZoomZoomIn: "\u041F\u0440\u0438\u0431\u043B\u0438\u0436\u0430\u0432\u0430\u043D\u0435",
  toolbarZoomZoomOut: "\u041D\u0430\u043C\u0430\u043B\u044F\u0432\u0430\u043D\u0435 \u043D\u0430 \u043C\u0430\u0449\u0430\u0431\u0430",
  tooltipPaginationStatus: "${index}[number] \u043E\u0442 ${count}[number]"
};
var AG_CHARTS_LOCALE_CS_CZ = {
  ariaAnnounceChart: "graf, ${seriesCount}[number] s\xE9ri\xED",
  ariaAnnounceFlowProportionLink: "odkaz ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "uzel ${index} z ${count}, ${description}",
  ariaAnnounceGaugeChart: "graf m\u011B\u0159idla, ${caption}",
  ariaAnnounceHierarchyChart: "hierarchick\xFD graf, ${caption}",
  ariaAnnounceHierarchyDatum: "\xFArove\u0148 ${level}[number], ${count}[number] d\u011Bti, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Stiskn\u011Bte mezern\xEDk nebo Enter pro p\u0159epnut\xED viditelnosti",
  ariaLabelAddHorizontalLine: "P\u0159idat vodorovnou \u010D\xE1ru",
  ariaLabelAnnotationOptionsToolbar: "Mo\u017Enosti anotace",
  ariaLabelAnnotationSettingsDialog: "Nastaven\xED anotace",
  ariaLabelColorPicker: "V\xFDb\u011Br barev",
  ariaLabelFinancialCharts: "Finan\u010Dn\xED grafy",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, polo\u017Eka legendy ${index}[number] z ${count}[number]",
  ariaLabelLegendItemUnknown: "Nezn\xE1m\xE1 polo\u017Eka legendy",
  ariaLabelLegendPageNext: "Dal\u0161\xED str\xE1nka legendy",
  ariaLabelLegendPagePrevious: "P\u0159edchoz\xED str\xE1nka legendy",
  ariaLabelLegendPagination: "Str\xE1nkov\xE1n\xED legendy",
  ariaLabelNavigator: "Navig\xE1tor",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minim\xE1ln\xED",
  ariaLabelNavigatorRange: "Rozsah",
  ariaLabelRangesToolbar: "Rozsahy",
  ariaLabelSettingsTabBar: "Nastaven\xED",
  ariaLabelZoomToolbar: "P\u0159ibl\xED\u017Eit",
  ariaValuePanRange: "${min}[percent0to2dp] a\u017E ${max}[percent0to2dp]",
  contextMenuDownload: "St\xE1hnout",
  contextMenuPanToCursor: "Posunout sem",
  contextMenuToggleOtherSeries: "P\u0159epnout ostatn\xED s\xE9rie",
  contextMenuToggleSeriesVisibility: "P\u0159epnout viditelnost",
  contextMenuZoomToCursor: "P\u0159ibl\xED\u017Eit sem",
  dialogHeaderChannel: "Kan\xE1l",
  dialogHeaderDatePriceRange: "Datum a cena",
  dialogHeaderDateRange: "\u010Casov\xE9 obdob\xED",
  dialogHeaderFibonacciRange: "Fib Retracement",
  dialogHeaderLine: "\u010C\xE1ra",
  dialogHeaderPriceRange: "Cenov\xE9 rozmez\xED",
  dialogHeaderText: "Text",
  dialogInputAlign: "Zarovnat",
  dialogInputColorPicker: "Barva",
  dialogInputColorPickerAltText: "Barva textu",
  dialogInputExtendAbove: "Roz\u0161\xED\u0159it nad",
  dialogInputExtendBelow: "Roz\u0161\xED\u0159it dol\u016F",
  dialogInputExtendChannelEnd: "Roz\u0161\xED\u0159it konec kan\xE1lu",
  dialogInputExtendChannelStart: "Roz\u0161\xED\u0159it za\u010D\xE1tek kan\xE1lu",
  dialogInputExtendLeft: "Rozt\xE1hnout doleva",
  dialogInputExtendLineEnd: "Prodlu\u017Ete konec \u0159\xE1dku",
  dialogInputExtendLineStart: "Roz\u0161\xED\u0159it za\u010D\xE1tek \u010D\xE1ry",
  dialogInputExtendRight: "Roz\u0161\xED\u0159it doprava",
  dialogInputFibonacciBands: "P\xE1sma",
  dialogInputFibonacciBandsAltText: "Fibonacci p\xE1sma",
  dialogInputFillColorPicker: "V\xFDpl\u0148",
  dialogInputFillColorPickerAltText: "Barva v\xFDpln\u011B",
  dialogInputFontSize: "Velikost",
  dialogInputFontSizeAltText: "Velikost p\xEDsma",
  dialogInputLineStyle: "\u010C\xE1rkovan\xE1 \u010D\xE1ra",
  dialogInputPosition: "Um\xEDst\u011Bn\xED",
  dialogInputReverse: "Obr\xE1tit",
  dialogInputShowFill: "Zobrazit v\xFDpl\u0148",
  dialogInputStrokeWidth: "Tlou\u0161\u0165ka",
  dialogInputStrokeWidthAltText: "Tlou\u0161\u0165ka \u010D\xE1ry",
  iconAltTextAlignCenter: "Zarovnat doprost\u0159ed",
  iconAltTextAlignLeft: "Vlevo",
  iconAltTextAlignRight: "Vpravo",
  iconAltTextClose: "Zav\u0159\xEDt",
  iconAltTextLineStyleDashed: "Dlouh\xE9 poml\u010Dky",
  iconAltTextLineStyleDotted: "Kr\xE1tk\xE9 \u010D\xE1rkovan\xE9",
  iconAltTextLineStyleSolid: "Pln\xE1",
  iconAltTextPositionBottom: "Dole",
  iconAltTextPositionCenter: "St\u0159ed",
  iconAltTextPositionTop: "Nahoru",
  inputTextareaPlaceholder: "P\u0159idat text",
  measurerDateRangeBars: "${value}[number] pruhy",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Objem ${value}",
  overlayLoadingData: "Na\u010D\xEDt\xE1n\xED dat...",
  overlayNoData: "\u017D\xE1dn\xE1 data k zobrazen\xED",
  overlayNoVisibleSeries: "\u017D\xE1dn\xE1 viditeln\xE1 s\xE9rie",
  overlayUnsupportedBrowser: "Nepodporovan\xE1 verze prohl\xED\u017Ee\u010De. Pros\xEDm, aktualizujte si prohl\xED\u017Ee\u010D.",
  seriesHistogramTooltipCount: "${yName} (po\u010Det)",
  seriesHistogramTooltipFrequency: "Frekvence",
  seriesHistogramTooltipMean: "${yName} (pr\u016Fm\u011Br)",
  seriesHistogramTooltipSum: "${yName} (sou\u010Det)",
  toolbarAnnotationsArrow: "\u0160ipka",
  toolbarAnnotationsArrowDown: "\u0160ipka dol\u016F",
  toolbarAnnotationsArrowUp: "\u0160ipka nahoru",
  toolbarAnnotationsCallout: "Pozn\xE1mka pod \u010Darou",
  toolbarAnnotationsClearAll: "Vymazat v\u0161e",
  toolbarAnnotationsComment: "Koment\xE1\u0159",
  toolbarAnnotationsDatePriceRange: "Datum a cena",
  toolbarAnnotationsDateRange: "\u010Casov\xFD rozsah",
  toolbarAnnotationsDelete: "Smazat",
  toolbarAnnotationsDisjointChannel: "Odd\u011Blen\xFD kan\xE1l",
  toolbarAnnotationsDragHandle: "P\u0159et\xE1hn\u011Bte panel n\xE1stroj\u016F",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "V\xFDpo\u010Det Fibonacciho korekc\xED",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Nez\xE1visl\xFD na \u010Case",
  toolbarAnnotationsFillColor: "Barva v\xFDpln\u011B",
  toolbarAnnotationsHorizontalLine: "Horizont\xE1ln\xED \u010D\xE1ra",
  toolbarAnnotationsLineAnnotations: "Trendy linie",
  toolbarAnnotationsLineColor: "Barva \u010D\xE1ry",
  toolbarAnnotationsLineStrokeWidth: "\u0160\xED\u0159ka tahu \u010D\xE1ry",
  toolbarAnnotationsLineStyle: "Styl \u010D\xE1ry",
  toolbarAnnotationsLock: "Zamknout",
  toolbarAnnotationsMeasurerAnnotations: "M\u011B\u0159i\u010De",
  toolbarAnnotationsNote: "Pozn\xE1mka",
  toolbarAnnotationsParallelChannel: "Paraleln\xED kan\xE1l",
  toolbarAnnotationsPriceRange: "Cenov\xE9 rozp\u011Bt\xED",
  toolbarAnnotationsQuickDatePriceRange: "M\u011B\u0159it",
  toolbarAnnotationsSettings: "Nastaven\xED",
  toolbarAnnotationsShapeAnnotations: "\u0160ipky",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textov\xE9 pozn\xE1mky",
  toolbarAnnotationsTextColor: "Barva textu",
  toolbarAnnotationsTextSize: "Velikost textu",
  toolbarAnnotationsTrendLine: "Trend Line",
  toolbarAnnotationsUnlock: "Odemknout",
  toolbarAnnotationsVerticalLine: "Vertik\xE1ln\xED \u010D\xE1ra",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\u011Bs\xEDc",
  toolbarRange1Year: "1R",
  toolbarRange1YearAria: "1 rok",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 m\u011Bs\xEDce",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\u011Bs\xEDc\u016F",
  toolbarRangeAll: "V\u0161e",
  toolbarRangeAllAria: "V\u0161e",
  toolbarRangeYearToDate: "Rok do dne\u0161n\xEDho dne",
  toolbarRangeYearToDateAria: "Od za\u010D\xE1tku roku",
  toolbarSeriesTypeCandles: "Sv\xED\u010Dky",
  toolbarSeriesTypeDropdown: "Typ grafu",
  toolbarSeriesTypeHighLow: "V\xFD\u0161ka N\xEDzk\xE1",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Pr\u016Fsvitn\xE9 sv\xED\u010Dky",
  toolbarSeriesTypeLine: "\u010C\xE1ra",
  toolbarSeriesTypeLineWithMarkers: "\u010C\xE1ra s markery",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Krokov\xE1 \u010C\xE1ra",
  toolbarZoomPanEnd: "Posunout na konec",
  toolbarZoomPanLeft: "Posunout vlevo",
  toolbarZoomPanRight: "Posunout doprava",
  toolbarZoomPanStart: "Posunout na za\u010D\xE1tek",
  toolbarZoomReset: "Obnovit zoom",
  toolbarZoomZoomIn: "P\u0159ibl\xED\u017Eit",
  toolbarZoomZoomOut: "Odd\xE1lit",
  tooltipPaginationStatus: "${index}[number] z ${count}[number]"
};
var AG_CHARTS_LOCALE_DA_DK = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] serier",
  ariaAnnounceFlowProportionLink: "link ${index} af ${count}, fra ${from} til ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "node ${index} af ${count}, ${description}",
  ariaAnnounceGaugeChart: "m\xE5lerdiagram, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkisk diagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niveau ${level}[number], ${count}[number] b\xF8rn, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Tryk p\xE5 mellemrumstasten eller Enter for at skifte synlighed",
  ariaLabelAddHorizontalLine: "Tilf\xF8j vandret linje",
  ariaLabelAnnotationOptionsToolbar: "Annotationmuligheder",
  ariaLabelAnnotationSettingsDialog: "Anm\xE6rkningsindstillinger",
  ariaLabelColorPicker: "Farvev\xE6lger",
  ariaLabelFinancialCharts: "Finansielle diagrammer",
  ariaLabelLegend: "Forklaring",
  ariaLabelLegendItem: "${label}, Legend element ${index}[number] af ${count}[number]",
  ariaLabelLegendItemUnknown: "Ukendt element i legenden",
  ariaLabelLegendPageNext: "N\xE6ste legendeside",
  ariaLabelLegendPagePrevious: "Forrige legenda-side",
  ariaLabelLegendPagination: "Legend paginering",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "R\xE6kkevidde",
  ariaLabelRangesToolbar: "Omr\xE5der",
  ariaLabelSettingsTabBar: "Indstillinger",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] til ${max}[percent0to2dp]",
  contextMenuDownload: "Download",
  contextMenuPanToCursor: "Panorer hertil",
  contextMenuToggleOtherSeries: "Skift Andre Serier",
  contextMenuToggleSeriesVisibility: "Skift synlighed",
  contextMenuZoomToCursor: "Zoom til her",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Dato og Pris",
  dialogHeaderDateRange: "Datointerval",
  dialogHeaderFibonacciRange: "Fib Tilbagef\xF8rsel",
  dialogHeaderLine: "Linje",
  dialogHeaderPriceRange: "Prisinterval",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Justering",
  dialogInputColorPicker: "Farve",
  dialogInputColorPickerAltText: "Tekstfarve",
  dialogInputExtendAbove: "Udvid over",
  dialogInputExtendBelow: "Forl\xE6ng nedenfor",
  dialogInputExtendChannelEnd: "Forl\xE6ng kanalende",
  dialogInputExtendChannelStart: "Forl\xE6ng kanalstart",
  dialogInputExtendLeft: "Udvid til venstre",
  dialogInputExtendLineEnd: "Forl\xE6ng linjens ende",
  dialogInputExtendLineStart: "Forl\xE6ng linjestart",
  dialogInputExtendRight: "Udvid til h\xF8jre",
  dialogInputFibonacciBands: "B\xE5nd",
  dialogInputFibonacciBandsAltText: "Fibonacci-b\xE5nd",
  dialogInputFillColorPicker: "Udfyld",
  dialogInputFillColorPickerAltText: "Fyldfarve",
  dialogInputFontSize: "St\xF8rrelse",
  dialogInputFontSizeAltText: "Skrifttypest\xF8rrelse",
  dialogInputLineStyle: "Streg",
  dialogInputPosition: "Position",
  dialogInputReverse: "Omvendt",
  dialogInputShowFill: "Vis udfyldning",
  dialogInputStrokeWidth: "V\xE6gt",
  dialogInputStrokeWidthAltText: "Linjev\xE6gt",
  iconAltTextAlignCenter: "Centr\xE9r",
  iconAltTextAlignLeft: "Venstre",
  iconAltTextAlignRight: "H\xF8jre",
  iconAltTextClose: "Luk",
  iconAltTextLineStyleDashed: "Lang-stiplet",
  iconAltTextLineStyleDotted: "Kort-stiplet",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Bund",
  iconAltTextPositionCenter: "Centreret",
  iconAltTextPositionTop: "Top",
  inputTextareaPlaceholder: "Tilf\xF8j tekst",
  measurerDateRangeBars: "${value}[number] bj\xE6lker",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Indl\xE6ser data...",
  overlayNoData: "Ingen data at vise",
  overlayNoVisibleSeries: "Ingen synlige serier",
  overlayUnsupportedBrowser: "Uforenelig browserversion. Opdater venligst din browser.",
  seriesHistogramTooltipCount: "${yName} (antal)",
  seriesHistogramTooltipFrequency: "Frekvens",
  seriesHistogramTooltipMean: "${yName} (gennemsnit)",
  seriesHistogramTooltipSum: "${yName} (sum)",
  toolbarAnnotationsArrow: "Pil",
  toolbarAnnotationsArrowDown: "Pil ned",
  toolbarAnnotationsArrowUp: "Pil Op",
  toolbarAnnotationsCallout: "Opkald",
  toolbarAnnotationsClearAll: "Ryd alle",
  toolbarAnnotationsComment: "Kommentar",
  toolbarAnnotationsDatePriceRange: "Dato og Pris",
  toolbarAnnotationsDateRange: "Datointerval",
  toolbarAnnotationsDelete: "Slet",
  toolbarAnnotationsDisjointChannel: "Adskilt Kanal",
  toolbarAnnotationsDragHandle: "Tr\xE6k v\xE6rkt\xF8jslinje",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Tilbagef\xF8rsel",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib-trendbaseret",
  toolbarAnnotationsFillColor: "Fyldfarve",
  toolbarAnnotationsHorizontalLine: "Vandret linje",
  toolbarAnnotationsLineAnnotations: "Trendlinjer",
  toolbarAnnotationsLineColor: "Linjefarve",
  toolbarAnnotationsLineStrokeWidth: "Linje penselbredde",
  toolbarAnnotationsLineStyle: "Linjestil",
  toolbarAnnotationsLock: "L\xE5s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE5lere",
  toolbarAnnotationsNote: "Noter",
  toolbarAnnotationsParallelChannel: "Parallel kanal",
  toolbarAnnotationsPriceRange: "Prisklasse",
  toolbarAnnotationsQuickDatePriceRange: "M\xE5l",
  toolbarAnnotationsSettings: "Indstillinger",
  toolbarAnnotationsShapeAnnotations: "Pile",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstantm\xE6rkninger",
  toolbarAnnotationsTextColor: "Tekstfarve",
  toolbarAnnotationsTextSize: "Tekstst\xF8rrelse",
  toolbarAnnotationsTrendLine: "Trendlinje",
  toolbarAnnotationsUnlock: "L\xE5s op",
  toolbarAnnotationsVerticalLine: "Lodret linje",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xE5ned",
  toolbarRange1Year: "1\xC5r",
  toolbarRange1YearAria: "1 \xE5r",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 m\xE5neder",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\xE5neder",
  toolbarRangeAll: "Alle",
  toolbarRangeAllAria: "Alle",
  toolbarRangeYearToDate: "\xC5TD",
  toolbarRangeYearToDateAria: "\xC5r til dato",
  toolbarSeriesTypeCandles: "Stearinlys",
  toolbarSeriesTypeDropdown: "Diagramtype",
  toolbarSeriesTypeHighLow: "H\xF8j Lav",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hule Stearinlys",
  toolbarSeriesTypeLine: "Linje",
  toolbarSeriesTypeLineWithMarkers: "Linje med mark\xF8rer",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Trin Linje",
  toolbarZoomPanEnd: "Pan til slutningen",
  toolbarZoomPanLeft: "Panorer til venstre",
  toolbarZoomPanRight: "Panor\xE9r til h\xF8jre",
  toolbarZoomPanStart: "Pan til starten",
  toolbarZoomReset: "Nulstil zoom",
  toolbarZoomZoomIn: "Zoom ind",
  toolbarZoomZoomOut: "Zoom ud",
  tooltipPaginationStatus: "${index}[number] af ${count}[number]"
};
var AG_CHARTS_LOCALE_DE_DE = {
  ariaAnnounceChart: "Diagramm, ${seriesCount}[number] Reihen",
  ariaAnnounceFlowProportionLink: "Link ${index} von ${count}, von ${from} bis ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "Knoten ${index} von ${count}, ${description}",
  ariaAnnounceGaugeChart: "Tachometerdiagramm, ${caption}",
  ariaAnnounceHierarchyChart: "Hierarchiediagramm, ${caption}",
  ariaAnnounceHierarchyDatum: "Ebene ${level}[number], ${count}[number] Kinder, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Dr\xFCcken Sie die Leertaste oder die Eingabetaste, um die Sichtbarkeit umzuschalten",
  ariaLabelAddHorizontalLine: "Horizontale Linie hinzuf\xFCgen",
  ariaLabelAnnotationOptionsToolbar: "Anmerkungsoptionen",
  ariaLabelAnnotationSettingsDialog: "Annotationseinstellungen",
  ariaLabelColorPicker: "Farbw\xE4hler",
  ariaLabelFinancialCharts: "Finanzdiagramme",
  ariaLabelLegend: "Legende",
  ariaLabelLegendItem: "${label}, Legendenpunkt ${index}[number] von ${count}[number]",
  ariaLabelLegendItemUnknown: "Unbekanntes Legenden Element",
  ariaLabelLegendPageNext: "N\xE4chste Legenden-Seite",
  ariaLabelLegendPagePrevious: "Vorherige Legenden-Seite",
  ariaLabelLegendPagination: "Legenden-Seitenumbruch",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Mindestwert",
  ariaLabelNavigatorRange: "Bereich",
  ariaLabelRangesToolbar: "Bereiche",
  ariaLabelSettingsTabBar: "Einstellungen",
  ariaLabelZoomToolbar: "Vergr\xF6\xDFern",
  ariaValuePanRange: "${min}[percent0to2dp] bis ${max}[percent0to2dp]",
  contextMenuDownload: "Herunterladen",
  contextMenuPanToCursor: "Hierher schwenken",
  contextMenuToggleOtherSeries: "Andere Serien umschalten",
  contextMenuToggleSeriesVisibility: "Sichtbarkeit umschalten",
  contextMenuZoomToCursor: "Hierher zoomen",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Datum und Preis",
  dialogHeaderDateRange: "Datumsbereich",
  dialogHeaderFibonacciRange: "Fib R\xFCcksetzung",
  dialogHeaderLine: "Linie",
  dialogHeaderPriceRange: "Preisspanne",
  dialogHeaderText: "Text",
  dialogInputAlign: "Ausrichten",
  dialogInputColorPicker: "Farbe",
  dialogInputColorPickerAltText: "Textfarbe",
  dialogInputExtendAbove: "Nach oben erweitern",
  dialogInputExtendBelow: "Nach unten erweitern",
  dialogInputExtendChannelEnd: "Kanalende erweitern",
  dialogInputExtendChannelStart: "Kanalanfang erweitern",
  dialogInputExtendLeft: "Nach links erweitern",
  dialogInputExtendLineEnd: "Linienende verl\xE4ngern",
  dialogInputExtendLineStart: "Linienanfang verl\xE4ngern",
  dialogInputExtendRight: "Nach rechts verl\xE4ngern",
  dialogInputFibonacciBands: "B\xE4nder",
  dialogInputFibonacciBandsAltText: "Fibonacci-B\xE4nder",
  dialogInputFillColorPicker: "F\xFCllen",
  dialogInputFillColorPickerAltText: "F\xFCllfarbe",
  dialogInputFontSize: "Gr\xF6\xDFe",
  dialogInputFontSizeAltText: "Schriftgr\xF6\xDFe",
  dialogInputLineStyle: "Gestrichelt",
  dialogInputPosition: "Position",
  dialogInputReverse: "Umkehren",
  dialogInputShowFill: "F\xFCllung anzeigen",
  dialogInputStrokeWidth: "Linienbreite",
  dialogInputStrokeWidthAltText: "Linienst\xE4rke",
  iconAltTextAlignCenter: "Zentrum",
  iconAltTextAlignLeft: "Links",
  iconAltTextAlignRight: "Rechts",
  iconAltTextClose: "Schlie\xDFen",
  iconAltTextLineStyleDashed: "Lang gestrichelt",
  iconAltTextLineStyleDotted: "Kurz gestrichelt",
  iconAltTextLineStyleSolid: "Durchgezogen",
  iconAltTextPositionBottom: "Unten",
  iconAltTextPositionCenter: "Mitte",
  iconAltTextPositionTop: "Oben",
  inputTextareaPlaceholder: "Text hinzuf\xFCgen",
  measurerDateRangeBars: "${value}[number] Balken",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volumen ${value}",
  overlayLoadingData: "Daten werden geladen...",
  overlayNoData: "Keine Daten zum Anzeigen",
  overlayNoVisibleSeries: "Keine sichtbaren Serien",
  overlayUnsupportedBrowser: "Inkompatible Browserversion. Bitte aktualisieren Sie Ihren Browser.",
  seriesHistogramTooltipCount: "${yName} (Anzahl)",
  seriesHistogramTooltipFrequency: "H\xE4ufigkeit",
  seriesHistogramTooltipMean: "${yName} (Mittelwert)",
  seriesHistogramTooltipSum: "${yName} (Summe)",
  toolbarAnnotationsArrow: "Pfeil",
  toolbarAnnotationsArrowDown: "Pfeil nach unten",
  toolbarAnnotationsArrowUp: "Pfeil nach oben",
  toolbarAnnotationsCallout: "Hinweis",
  toolbarAnnotationsClearAll: "Alles l\xF6schen",
  toolbarAnnotationsComment: "Kommentar",
  toolbarAnnotationsDatePriceRange: "Datum und Preis",
  toolbarAnnotationsDateRange: "Datumsbereich",
  toolbarAnnotationsDelete: "L\xF6schen",
  toolbarAnnotationsDisjointChannel: "Getrennter Kanal",
  toolbarAnnotationsDragHandle: "Werkzeugleiste ziehen",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib-Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib retracement basierend auf Trend",
  toolbarAnnotationsFillColor: "F\xFCllfarbe",
  toolbarAnnotationsHorizontalLine: "Horizontale Linie",
  toolbarAnnotationsLineAnnotations: "Trendlinien",
  toolbarAnnotationsLineColor: "Linienfarbe",
  toolbarAnnotationsLineStrokeWidth: "Linienstrichbreite",
  toolbarAnnotationsLineStyle: "Linienstil",
  toolbarAnnotationsLock: "Sperren",
  toolbarAnnotationsMeasurerAnnotations: "Messger\xE4te",
  toolbarAnnotationsNote: "Hinweis",
  toolbarAnnotationsParallelChannel: "Paralleler Kanal",
  toolbarAnnotationsPriceRange: "Preisspanne",
  toolbarAnnotationsQuickDatePriceRange: "Messen",
  toolbarAnnotationsSettings: "Einstellungen",
  toolbarAnnotationsShapeAnnotations: "Pfeile",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textanmerkungen",
  toolbarAnnotationsTextColor: "Textfarbe",
  toolbarAnnotationsTextSize: "Textgr\xF6\xDFe",
  toolbarAnnotationsTrendLine: "Trendlinie",
  toolbarAnnotationsUnlock: "Freischalten",
  toolbarAnnotationsVerticalLine: "Vertikale Linie",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 Monat",
  toolbarRange1Year: "1J",
  toolbarRange1YearAria: "1 Jahr",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 Monate",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 Monate",
  toolbarRangeAll: "Alle",
  toolbarRangeAllAria: "Alle",
  toolbarRangeYearToDate: "Seit Jahresbeginn",
  toolbarRangeYearToDateAria: "Jahr bis Datum",
  toolbarSeriesTypeCandles: "Kerzen",
  toolbarSeriesTypeDropdown: "Diagrammtyp",
  toolbarSeriesTypeHighLow: "Hoch Tief",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hohle Kerzen",
  toolbarSeriesTypeLine: "Linie",
  toolbarSeriesTypeLineWithMarkers: "Linie mit Markierungen",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Stufenlinie",
  toolbarZoomPanEnd: "Zum Ende verschieben",
  toolbarZoomPanLeft: "Nach links verschieben",
  toolbarZoomPanRight: "Nach rechts schwenken",
  toolbarZoomPanStart: "Zum Anfang schwenken",
  toolbarZoomReset: "Zoom zur\xFCcksetzen",
  toolbarZoomZoomIn: "Vergr\xF6\xDFern",
  toolbarZoomZoomOut: "Verkleinern",
  tooltipPaginationStatus: "${index}[number] von ${count}[number]"
};
var AG_CHARTS_LOCALE_EL_GR = {
  ariaAnnounceChart: "\u03B4\u03B9\u03AC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1, ${seriesCount}[number] \u03C3\u03B5\u03B9\u03C1\u03AD\u03C2",
  ariaAnnounceFlowProportionLink: "\u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03BC\u03BF\u03C2 ${index} \u03B1\u03C0\u03CC ${count}, \u03B1\u03C0\u03CC ${from} \u03C0\u03C1\u03BF\u03C2 ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u03BA\u03CC\u03BC\u03B2\u03BF\u03C2 ${index} \u03B1\u03C0\u03CC ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u03B4\u03B9\u03AC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03B4\u03B5\u03AF\u03BA\u03C4\u03B7, ${caption}",
  ariaAnnounceHierarchyChart: "\u03B4\u03B9\u03AC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03B9\u03B5\u03C1\u03B1\u03C1\u03C7\u03AF\u03B1\u03C2, ${caption}",
  ariaAnnounceHierarchyDatum: "\u03B5\u03C0\u03AF\u03C0\u03B5\u03B4\u03BF ${level}[number], ${count}[number] \u03C0\u03B1\u03B9\u03B4\u03B9\u03AC, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u03A0\u03B1\u03C4\u03AE\u03C3\u03C4\u03B5 Space \u03AE Enter \u03B3\u03B9\u03B1 \u03B5\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03BF\u03C1\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
  ariaLabelAddHorizontalLine: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u039F\u03C1\u03B9\u03B6\u03CC\u03BD\u03C4\u03B9\u03B1\u03C2 \u0393\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2",
  ariaLabelAnnotationOptionsToolbar: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AD\u03C2 \u03C3\u03C7\u03BF\u03BB\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
  ariaLabelAnnotationSettingsDialog: "\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2 \u03A3\u03C7\u03BF\u03BB\u03B9\u03B1\u03C3\u03BC\u03BF\u03CD",
  ariaLabelColorPicker: "\u0395\u03C0\u03B9\u03BB\u03BF\u03B3\u03AE \u03C7\u03C1\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2",
  ariaLabelFinancialCharts: "\u03A7\u03C1\u03B7\u03BC\u03B1\u03C4\u03BF\u03BF\u03B9\u03BA\u03BF\u03BD\u03BF\u03BC\u03B9\u03BA\u03AC \u03B3\u03C1\u03B1\u03C6\u03AE\u03BC\u03B1\u03C4\u03B1",
  ariaLabelLegend: "\u03A5\u03C0\u03CC\u03BC\u03BD\u03B7\u03BC\u03B1",
  ariaLabelLegendItem: "${label}, \u03A3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03C5\u03C0\u03CC\u03BC\u03BD\u03B7\u03BC\u03B1 ${index}[number] \u03B1\u03C0\u03CC ${count}[number]",
  ariaLabelLegendItemUnknown: "\u0386\u03B3\u03BD\u03C9\u03C3\u03C4\u03BF \u03C3\u03C4\u03BF\u03B9\u03C7\u03B5\u03AF\u03BF \u03C5\u03C0\u03CC\u03BC\u03BD\u03B7\u03BC\u03B1",
  ariaLabelLegendPageNext: "\u0395\u03C0\u03CC\u03BC\u03B5\u03BD\u03B7 \u03A3\u03B5\u03BB\u03AF\u03B4\u03B1 \u0398\u03C1\u03CD\u03BB\u03BF\u03C5",
  ariaLabelLegendPagePrevious: "\u03A0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7 \u03A3\u03B5\u03BB\u03AF\u03B4\u03B1 \u0398\u03C1\u03CD\u03BB\u03BF\u03C5",
  ariaLabelLegendPagination: "\u03A3\u03B5\u03BB\u03B9\u03B4\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7 \u03A5\u03C0\u03CC\u03BC\u03BD\u03B7\u03BC\u03B1",
  ariaLabelNavigator: "\u03A0\u03BB\u03BF\u03B7\u03B3\u03CC\u03C2",
  ariaLabelNavigatorMaximum: "\u039C\u03AD\u03B3\u03B9\u03C3\u03C4\u03BF",
  ariaLabelNavigatorMinimum: "\u0395\u03BB\u03AC\u03C7\u03B9\u03C3\u03C4\u03BF",
  ariaLabelNavigatorRange: "\u0395\u03CD\u03C1\u03BF\u03C2",
  ariaLabelRangesToolbar: "\u0395\u03CD\u03C1\u03B7",
  ariaLabelSettingsTabBar: "\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2",
  ariaLabelZoomToolbar: "\u0396\u03BF\u03C5\u03BC",
  ariaValuePanRange: "${min}[percent0to2dp] \u03AD\u03C9\u03C2 ${max}[percent0to2dp]",
  contextMenuDownload: "\u039B\u03AE\u03C8\u03B7",
  contextMenuPanToCursor: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03B5\u03B4\u03CE",
  contextMenuToggleOtherSeries: "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u03AC\u03BB\u03BB\u03C9\u03BD \u03C3\u03B5\u03B9\u03C1\u03CE\u03BD",
  contextMenuToggleSeriesVisibility: "\u0395\u03BD\u03B1\u03BB\u03BB\u03B1\u03B3\u03AE \u039F\u03C1\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2",
  contextMenuZoomToCursor: "\u0396\u03BF\u03C5\u03BC \u03B5\u03B4\u03CE",
  dialogHeaderChannel: "\u039A\u03B1\u03BD\u03AC\u03BB\u03B9",
  dialogHeaderDatePriceRange: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03A4\u03B9\u03BC\u03AE",
  dialogHeaderDateRange: "\u0395\u03CD\u03C1\u03BF\u03C2 \u03B7\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD",
  dialogHeaderFibonacciRange: "\u0395\u03C0\u03AF\u03C0\u03B5\u03B4\u03B1 Fibonacci",
  dialogHeaderLine: "\u0393\u03C1\u03B1\u03BC\u03BC\u03AE",
  dialogHeaderPriceRange: "\u0395\u03CD\u03C1\u03BF\u03C2 \u03A4\u03B9\u03BC\u03CE\u03BD",
  dialogHeaderText: "\u039A\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF",
  dialogInputAlign: "\u0395\u03C5\u03B8\u03C5\u03B3\u03C1\u03AC\u03BC\u03BC\u03B9\u03C3\u03B7",
  dialogInputColorPicker: "\u03A7\u03C1\u03CE\u03BC\u03B1",
  dialogInputColorPickerAltText: "\u03A7\u03C1\u03CE\u03BC\u03B1 \u039A\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
  dialogInputExtendAbove: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03C0\u03AC\u03BD\u03C9",
  dialogInputExtendBelow: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03BA\u03AC\u03C4\u03C9",
  dialogInputExtendChannelEnd: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03C4\u03AD\u03BB\u03BF\u03C5\u03C2 \u03BA\u03B1\u03BD\u03B1\u03BB\u03B9\u03BF\u03CD",
  dialogInputExtendChannelStart: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2 \u03BA\u03B1\u03BD\u03B1\u03BB\u03B9\u03BF\u03CD",
  dialogInputExtendLeft: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03C0\u03C1\u03BF\u03C2 \u03C4\u03B1 \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AC",
  dialogInputExtendLineEnd: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03AC\u03BA\u03C1\u03B7\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2",
  dialogInputExtendLineStart: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03AD\u03BD\u03B1\u03C1\u03BE\u03B7\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2",
  dialogInputExtendRight: "\u0395\u03C0\u03AD\u03BA\u03C4\u03B1\u03C3\u03B7 \u03B4\u03B5\u03BE\u03B9\u03AC",
  dialogInputFibonacciBands: "\u0396\u03CE\u03BD\u03B5\u03C2",
  dialogInputFibonacciBandsAltText: "\u0396\u03CE\u03BD\u03B5\u03C2 Fibonacci",
  dialogInputFillColorPicker: "\u0393\u03AD\u03BC\u03B9\u03C3\u03BC\u03B1",
  dialogInputFillColorPickerAltText: "\u03A7\u03C1\u03CE\u03BC\u03B1 \u03A3\u03C5\u03BC\u03C0\u03BB\u03AE\u03C1\u03C9\u03C3\u03B7\u03C2",
  dialogInputFontSize: "\u039C\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2",
  dialogInputFontSizeAltText: "\u039C\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03B1\u03C4\u03BF\u03C3\u03B5\u03B9\u03C1\u03AC\u03C2",
  dialogInputLineStyle: "\u03A0\u03B1\u03CD\u03BB\u03B1",
  dialogInputPosition: "\u0398\u03AD\u03C3\u03B7",
  dialogInputReverse: "\u0391\u03BD\u03C4\u03AF\u03C3\u03C4\u03C1\u03BF\u03C6\u03B1",
  dialogInputShowFill: "\u0395\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7 \u0393\u03AD\u03BC\u03B9\u03C3\u03B7\u03C2",
  dialogInputStrokeWidth: "\u0392\u03AC\u03C1\u03BF\u03C2",
  dialogInputStrokeWidthAltText: "\u03A0\u03AC\u03C7\u03BF\u03C2 \u03B3\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2",
  iconAltTextAlignCenter: "\u039A\u03AD\u03BD\u03C4\u03C1\u03BF",
  iconAltTextAlignLeft: "\u0391\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AC",
  iconAltTextAlignRight: "\u0394\u03B5\u03BE\u03B9\u03AC",
  iconAltTextClose: "\u039A\u03BB\u03B5\u03AF\u03C3\u03B9\u03BC\u03BF",
  iconAltTextLineStyleDashed: "\u039C\u03B1\u03BA\u03C1\u03AC-\u03C0\u03B1\u03CD\u03BB\u03B1",
  iconAltTextLineStyleDotted: "\u039C\u03B9\u03BA\u03C1\u03AE \u03C0\u03B1\u03CD\u03BB\u03B1",
  iconAltTextLineStyleSolid: "\u03A3\u03C5\u03BC\u03C0\u03B1\u03B3\u03AD\u03C2",
  iconAltTextPositionBottom: "\u039A\u03AC\u03C4\u03C9",
  iconAltTextPositionCenter: "\u039A\u03AD\u03BD\u03C4\u03C1\u03BF",
  iconAltTextPositionTop: "\u039A\u03BF\u03C1\u03C5\u03C6\u03AE",
  inputTextareaPlaceholder: "\u03A0\u03C1\u03BF\u03C3\u03B8\u03AE\u03BA\u03B7 \u039A\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
  measurerDateRangeBars: "${value}[number] \u03BC\u03C0\u03AC\u03C1\u03B5\u03C2",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u038C\u03B3\u03BF ${value}",
  overlayLoadingData: "\u03A6\u03CC\u03C1\u03C4\u03C9\u03C3\u03B7 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03C9\u03BD...",
  overlayNoData: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03BF\u03C5\u03BD \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03B5\u03BC\u03C6\u03AC\u03BD\u03B9\u03C3\u03B7",
  overlayNoVisibleSeries: "\u0394\u03B5\u03BD \u03C5\u03C0\u03AC\u03C1\u03C7\u03B5\u03B9 \u03BF\u03C1\u03B1\u03C4\u03AE \u03C3\u03B5\u03B9\u03C1\u03AC",
  overlayUnsupportedBrowser: "\u039C\u03B7 \u03C3\u03C5\u03BC\u03B2\u03B1\u03C4\u03AE \u03AD\u03BA\u03B4\u03BF\u03C3\u03B7 \u03C0\u03C1\u03BF\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03B7\u03C2. \u03A0\u03B1\u03C1\u03B1\u03BA\u03B1\u03BB\u03CE \u03B1\u03BD\u03B1\u03B2\u03B1\u03B8\u03BC\u03AF\u03C3\u03C4\u03B5 \u03C4\u03BF \u03C0\u03C1\u03CC\u03B3\u03C1\u03B1\u03BC\u03BC\u03B1 \u03C0\u03B5\u03C1\u03B9\u03AE\u03B3\u03B7\u03C3\u03AE\u03C2 \u03C3\u03B1\u03C2.",
  seriesHistogramTooltipCount: "${yName} (\u03C0\u03BB\u03AE\u03B8\u03BF\u03C2)",
  seriesHistogramTooltipFrequency: "\u03A3\u03C5\u03C7\u03BD\u03CC\u03C4\u03B7\u03C4\u03B1",
  seriesHistogramTooltipMean: "${yName} (\u03BC\u03AD\u03C3\u03BF\u03C2 \u03CC\u03C1\u03BF\u03C2)",
  seriesHistogramTooltipSum: "${yName} (\u03AC\u03B8\u03C1\u03BF\u03B9\u03C3\u03BC\u03B1)",
  toolbarAnnotationsArrow: "\u0392\u03AD\u03BB\u03BF\u03C2",
  toolbarAnnotationsArrowDown: "\u0392\u03AD\u03BB\u03BF\u03C2 \u039A\u03AC\u03C4\u03C9",
  toolbarAnnotationsArrowUp: "\u0392\u03AD\u03BB\u03BF\u03C2 \u03A0\u03AC\u03BD\u03C9",
  toolbarAnnotationsCallout: "\u0395\u03C0\u03B9\u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7",
  toolbarAnnotationsClearAll: "\u039A\u03B1\u03B8\u03B1\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u038C\u03BB\u03C9\u03BD",
  toolbarAnnotationsComment: "\u03A3\u03C7\u03CC\u03BB\u03B9\u03BF",
  toolbarAnnotationsDatePriceRange: "\u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03AF\u03B1 \u03BA\u03B1\u03B9 \u03A4\u03B9\u03BC\u03AE",
  toolbarAnnotationsDateRange: "\u0395\u03CD\u03C1\u03BF\u03C2 \u0397\u03BC\u03B5\u03C1\u03BF\u03BC\u03B7\u03BD\u03B9\u03CE\u03BD",
  toolbarAnnotationsDelete: "\u0394\u03B9\u03B1\u03B3\u03C1\u03B1\u03C6\u03AE",
  toolbarAnnotationsDisjointChannel: "\u0391\u03C0\u03BF\u03C3\u03C5\u03BD\u03B4\u03B5\u03B4\u03B5\u03BC\u03AD\u03BD\u03BF \u039A\u03B1\u03BD\u03AC\u03BB\u03B9",
  toolbarAnnotationsDragHandle: "\u03A3\u03CD\u03C1\u03B5\u03C4\u03B5 \u03C4\u03B7 \u0393\u03C1\u03B1\u03BC\u03BC\u03AE \u0395\u03C1\u03B3\u03B1\u03BB\u03B5\u03AF\u03C9\u03BD",
  toolbarAnnotationsFibonacciAnnotations: "\u03A6\u03B9\u03BC\u03C0\u03BF\u03BD\u03AC\u03C4\u03C3\u03B9",
  toolbarAnnotationsFibonacciRetracement: "\u0395\u03C0\u03B9\u03C3\u03C4\u03C1\u03BF\u03C6\u03AE \u03A6\u03B9\u03BC\u03C0\u03BF\u03BD\u03AC\u03C4\u03C3\u03B9",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u039D\u03AD\u03B1 \u0392\u03AC\u03C3\u03B7 \u03A4\u03AC\u03C3\u03B7\u03C2 \u03A6\u03AF\u03BC\u03C0\u03BF\u03BD\u03B1\u03C4\u03C3\u03B9",
  toolbarAnnotationsFillColor: "\u03A7\u03C1\u03CE\u03BC\u03B1 \u0393\u03AD\u03BC\u03B9\u03C3\u03B7\u03C2",
  toolbarAnnotationsHorizontalLine: "\u039F\u03C1\u03B9\u03B6\u03CC\u03BD\u03C4\u03B9\u03B1 \u0393\u03C1\u03B1\u03BC\u03BC\u03AE",
  toolbarAnnotationsLineAnnotations: "\u0393\u03C1\u03B1\u03BC\u03BC\u03AD\u03C2 \u03A4\u03AC\u03C3\u03B7\u03C2",
  toolbarAnnotationsLineColor: "\u03A7\u03C1\u03CE\u03BC\u03B1 \u0393\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2",
  toolbarAnnotationsLineStrokeWidth: "\u03A0\u03BB\u03AC\u03C4\u03BF\u03C2 \u0393\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2 \u0394\u03B9\u03B1\u03B4\u03C1\u03BF\u03BC\u03AE\u03C2",
  toolbarAnnotationsLineStyle: "\u03A3\u03C4\u03C5\u03BB \u0393\u03C1\u03B1\u03BC\u03BC\u03AE\u03C2",
  toolbarAnnotationsLock: "\u039A\u03BB\u03B5\u03AF\u03B4\u03C9\u03BC\u03B1",
  toolbarAnnotationsMeasurerAnnotations: "\u039C\u03AD\u03C4\u03C1\u03B1",
  toolbarAnnotationsNote: "\u03A3\u03B7\u03BC\u03B5\u03AF\u03C9\u03C3\u03B7",
  toolbarAnnotationsParallelChannel: "\u03A0\u03B1\u03C1\u03AC\u03BB\u03BB\u03B7\u03BB\u03BF \u039A\u03B1\u03BD\u03AC\u03BB\u03B9",
  toolbarAnnotationsPriceRange: "\u0395\u03CD\u03C1\u03BF\u03C2 \u03A4\u03B9\u03BC\u03CE\u03BD",
  toolbarAnnotationsQuickDatePriceRange: "\u039C\u03B5\u03C4\u03C1\u03AE\u03C3\u03C4\u03B5",
  toolbarAnnotationsSettings: "\u03A1\u03C5\u03B8\u03BC\u03AF\u03C3\u03B5\u03B9\u03C2",
  toolbarAnnotationsShapeAnnotations: "\u0392\u03AD\u03BB\u03B7",
  toolbarAnnotationsText: "\u039A\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF",
  toolbarAnnotationsTextAnnotations: "\u039A\u03B5\u03AF\u03BC\u03B5\u03BD\u03BF \u03A3\u03C7\u03BF\u03BB\u03AF\u03C9\u03BD",
  toolbarAnnotationsTextColor: "\u03A7\u03C1\u03CE\u03BC\u03B1 \u039A\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
  toolbarAnnotationsTextSize: "\u039C\u03AD\u03B3\u03B5\u03B8\u03BF\u03C2 \u039A\u03B5\u03B9\u03BC\u03AD\u03BD\u03BF\u03C5",
  toolbarAnnotationsTrendLine: "\u0393\u03C1\u03B1\u03BC\u03BC\u03AE \u03A4\u03AC\u03C3\u03B7\u03C2",
  toolbarAnnotationsUnlock: "\u039E\u03B5\u03BA\u03BB\u03B5\u03AF\u03B4\u03C9\u03BC\u03B1",
  toolbarAnnotationsVerticalLine: "\u039A\u03AC\u03B8\u03B5\u03C4\u03B7 \u0393\u03C1\u03B1\u03BC\u03BC\u03AE",
  toolbarRange1Month: "1\u039C",
  toolbarRange1MonthAria: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
  toolbarRange1Year: "1\u0388\u03C4\u03BF\u03C2",
  toolbarRange1YearAria: "1 \u03AD\u03C4\u03BF\u03C2",
  toolbarRange3Months: "3\u039C",
  toolbarRange3MonthsAria: "3 \u03BC\u03AE\u03BD\u03B5\u03C2",
  toolbarRange6Months: "6\u039C\u03AE",
  toolbarRange6MonthsAria: "6 \u03BC\u03AE\u03BD\u03B5\u03C2",
  toolbarRangeAll: "\u038C\u03BB\u03B1",
  toolbarRangeAllAria: "\u038C\u03BB\u03B1",
  toolbarRangeYearToDate: "\u0388\u03C4\u03BF\u03C2 \u03AD\u03C9\u03C2 \u03C3\u03AE\u03BC\u03B5\u03C1\u03B1",
  toolbarRangeYearToDateAria: "\u0388\u03C4\u03BF\u03C2 \u03BC\u03AD\u03C7\u03C1\u03B9 \u03C3\u03AE\u03BC\u03B5\u03C1\u03B1",
  toolbarSeriesTypeCandles: "\u039A\u03B7\u03C1\u03BF\u03C0\u03AE\u03B3\u03B9\u03B1",
  toolbarSeriesTypeDropdown: "\u03A4\u03CD\u03C0\u03BF\u03C2 \u0394\u03B9\u03B1\u03B3\u03C1\u03AC\u03BC\u03BC\u03B1\u03C4\u03BF\u03C2",
  toolbarSeriesTypeHighLow: "\u03A5\u03C8\u03B7\u03BB\u03CC \u03A7\u03B1\u03BC\u03B7\u03BB\u03CC",
  toolbarSeriesTypeHLC: "\u03A5\u03A8\u03A7",
  toolbarSeriesTypeHollowCandles: "\u039A\u03B5\u03C1\u03B9\u03AC Hollow",
  toolbarSeriesTypeLine: "\u0393\u03C1\u03B1\u03BC\u03BC\u03AE",
  toolbarSeriesTypeLineWithMarkers: "\u0393\u03C1\u03B1\u03BC\u03BC\u03AE \u03BC\u03B5 \u0394\u03B5\u03AF\u03BA\u03C4\u03B5\u03C2",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u0392\u03B7\u03BC\u03B1\u03C4\u03B9\u03BA\u03AE \u0393\u03C1\u03B1\u03BC\u03BC\u03AE",
  toolbarZoomPanEnd: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C3\u03C4\u03BF \u03C4\u03AD\u03BB\u03BF\u03C2",
  toolbarZoomPanLeft: "\u039C\u03B5\u03C4\u03B1\u03C4\u03CC\u03C0\u03B9\u03C3\u03B7 \u03B1\u03C1\u03B9\u03C3\u03C4\u03B5\u03C1\u03AC",
  toolbarZoomPanRight: "\u039C\u03B5\u03C4\u03B1\u03C4\u03CC\u03C0\u03B9\u03C3\u03B7 \u03B4\u03B5\u03BE\u03B9\u03AC",
  toolbarZoomPanStart: "\u039C\u03B5\u03C4\u03B1\u03BA\u03AF\u03BD\u03B7\u03C3\u03B7 \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03AE",
  toolbarZoomReset: "\u0395\u03C0\u03B1\u03BD\u03B1\u03C6\u03BF\u03C1\u03AC \u03C4\u03B7\u03C2 \u03B5\u03C3\u03C4\u03AF\u03B1\u03C3\u03B7\u03C2",
  toolbarZoomZoomIn: "\u039C\u03B5\u03B3\u03AD\u03B8\u03C5\u03BD\u03C3\u03B7",
  toolbarZoomZoomOut: "\u03A3\u03BC\u03AF\u03BA\u03C1\u03C5\u03BD\u03C3\u03B7",
  tooltipPaginationStatus: "${index}[number] \u03B1\u03C0\u03CC ${count}[number]"
};
var AG_CHARTS_LOCALE_EN_US = {
  // Screen reader announcement when focusing an item in the chart
  ariaAnnounceHoverDatum: "${datum}",
  // Screen reader announcement when focusing a chart
  ariaAnnounceChart: "chart, ${seriesCount}[number] series",
  // Screen reader announcement when focusing a hierarchy chart
  ariaAnnounceHierarchyChart: "hierarchy chart, ${caption}",
  // Screen reader announcement when focusing a gauge chart
  ariaAnnounceGaugeChart: "gauge chart, ${caption}",
  // Screen reader announcement when focusing an item in a treemap or sunburst chart
  ariaAnnounceHierarchyDatum: "level ${level}[number], ${count}[number] children, ${description}",
  // Screen reader announcement when focusing a link in a Sankey or chord chart
  ariaAnnounceFlowProportionLink: "link ${index} of ${count}, from ${from} to ${to}, ${sizeName} ${size}",
  // Screen reader announcement when focusing a node in a Sankey or chord chart
  ariaAnnounceFlowProportionNode: "node ${index} of ${count}, ${description}",
  // Screen reader description for legend items
  ariaDescriptionLegendItem: "Press Space or Enter to toggle visibility",
  // Screen reader for the '+' horizontal line button on the Y-axis
  ariaLabelAddHorizontalLine: "Add Horizontal Line",
  // Screen reader text for annotation-options toolbar
  ariaLabelAnnotationOptionsToolbar: "Annotation Options",
  // Screen reader text for annotation-settings dialog
  ariaLabelAnnotationSettingsDialog: "Annotation Settings",
  // Screen reader text for the color picker dialog
  ariaLabelColorPicker: "Color picker",
  // Screen reader text for the financial charts toolbar
  ariaLabelFinancialCharts: "Financial Charts",
  // Screen reader text for the legend toolbar
  ariaLabelLegend: "Legend",
  // Screen reader text for the legend pagination button
  ariaLabelLegendPagination: "Legend Pagination",
  // Screen reader text for the previous legend page button
  ariaLabelLegendPagePrevious: "Previous Legend Page",
  // Screen reader text for the next legend page button
  ariaLabelLegendPageNext: "Next Legend Page",
  // Screen reader text for the an item in the legend
  ariaLabelLegendItem: "${label}, Legend item ${index}[number] of ${count}[number]",
  // Screen reader text for the an unknown item in the legend
  ariaLabelLegendItemUnknown: "Unknown legend item",
  // Screen reader text for the navigator element
  ariaLabelNavigator: "Navigator",
  // Screen reader text for an accessibility control that changes the position of the navigator's range
  ariaLabelNavigatorRange: "Range",
  // Screen reader text for an accessibility control that changes the start of the navigator's range
  ariaLabelNavigatorMinimum: "Minimum",
  // Screen reader text for an accessibility control that changes the end of the navigator's range
  ariaLabelNavigatorMaximum: "Maximum",
  // Screen reader text for ranges toolbar
  ariaLabelRangesToolbar: "Ranges",
  // Screen reader text for the settings dialog tab-bar
  ariaLabelSettingsTabBar: "Settings",
  // Screen reader text for zoom toolbar
  ariaLabelZoomToolbar: "Zoom",
  // Screen reader text for the value of the navigator's range
  ariaValuePanRange: "${min}[percent0to2dp] to ${max}[percent0to2dp]",
  // Alt-text for the solid line dash style menu item icon
  iconAltTextLineStyleSolid: "Solid",
  // Alt-text for the long-dashed line dash style menu item icon
  iconAltTextLineStyleDashed: "Long-dashed",
  // Alt-text for the short-dashed line dash style menu item icon
  iconAltTextLineStyleDotted: "Short-dashed",
  // Alt-text for the 'position-top' icon
  iconAltTextPositionTop: "Top",
  // Alt-text for the 'position-center' icon
  iconAltTextPositionCenter: "Center",
  // Alt-text for the 'position-bottom' icon
  iconAltTextPositionBottom: "Bottom",
  // Alt-text for the 'position-left' icon
  iconAltTextAlignLeft: "Left",
  // Alt-text for the 'align-center' icon
  iconAltTextAlignCenter: "Center",
  // Alt-text for the 'position-right' icon
  iconAltTextAlignRight: "Right",
  // Alt-text for the 'close' icon
  iconAltTextClose: "Close",
  // Default text for the 'loading data' overlay
  overlayLoadingData: "Loading data...",
  // Default text for the 'no data' overlay
  overlayNoData: "No data to display",
  // Default text for the 'no visible series' overlay
  overlayNoVisibleSeries: "No visible series",
  // Default text for the 'unsupported browser' overlay
  overlayUnsupportedBrowser: "Incompatible browser version. Please upgrade your browser.",
  // Text for frequency label in Histogram Series tooltip
  seriesHistogramTooltipFrequency: "Frequency",
  // Text for sum label in Histogram Series tooltip
  seriesHistogramTooltipSum: "${yName} (sum)",
  // Text for sum label in Histogram Series tooltip
  seriesHistogramTooltipCount: "${yName} (count)",
  // Text for sum label in Histogram Series tooltip
  seriesHistogramTooltipMean: "${yName} (mean)",
  // Text for the series type toolbar's chart type button
  toolbarSeriesTypeDropdown: "Chart Type",
  // Text for the series type toolbar's OHLC chart type button
  toolbarSeriesTypeOHLC: "OHLC",
  // Text for the series type toolbar's HLC chart type button
  toolbarSeriesTypeHLC: "HLC",
  // Text for the series type toolbar's high low chart type button
  toolbarSeriesTypeHighLow: "High Low",
  // Text for the series type toolbar's candles chart type button
  toolbarSeriesTypeCandles: "Candles",
  // Text for the series type toolbar's hollow candles chart type button
  toolbarSeriesTypeHollowCandles: "Hollow Candles",
  // Text for the series type toolbar's line chart type button
  toolbarSeriesTypeLine: "Line",
  // Text for the series type toolbar's line with markers chart type button
  toolbarSeriesTypeLineWithMarkers: "Line with Markers",
  // Text for the series type toolbar's line with step line chart type button
  toolbarSeriesTypeStepLine: "Step Line",
  // Text for the annotation toolbar's trend line button
  toolbarAnnotationsTrendLine: "Trend Line",
  // Text for the annotation toolbar's Fibonacci Retracement button
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  // Text for the annotation toolbar's Fibonacci Retracement Trend Based button
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based",
  // Text for the annotation toolbar's horizontal line button
  toolbarAnnotationsHorizontalLine: "Horizontal Line",
  // Text for the annotation toolbar's vertical line button
  toolbarAnnotationsVerticalLine: "Vertical Line",
  // Text for the annotation toolbar's parallel channel button
  toolbarAnnotationsParallelChannel: "Parallel Channel",
  // Text for the annotation toolbar's disjoint channel button
  toolbarAnnotationsDisjointChannel: "Disjoint Channel",
  // Text for the annotation toolbar's clear all button
  toolbarAnnotationsClearAll: "Clear All",
  // Text for the annotation toolbar's fill color picker annotation button
  toolbarAnnotationsFillColor: "Fill Color",
  // Text for the annotation toolbar's line color picker annotation button
  toolbarAnnotationsLineColor: "Line Color",
  // Text for the annotation toolbar's line style type button
  toolbarAnnotationsLineStyle: "Line Style",
  // Text for the annotation toolbar's line stroke width button
  toolbarAnnotationsLineStrokeWidth: "Line Stroke Width",
  // Text for the annotation toolbar's settings annotation button
  toolbarAnnotationsSettings: "Settings",
  // Text for the annotation toolbar's text color picker annotation button
  toolbarAnnotationsTextColor: "Text Color",
  // Text for the annotation toolbar's text size picker annotation button
  toolbarAnnotationsTextSize: "Text Size",
  // Text for the annotation toolbar's lock annotation button
  toolbarAnnotationsLock: "Lock",
  // Text for the annotation toolbar's unlock annotation button
  toolbarAnnotationsUnlock: "Unlock",
  // Text for the annotation toolbar's delete annotation button
  toolbarAnnotationsDelete: "Delete",
  // Text for the annotation toolbar's drag handle
  toolbarAnnotationsDragHandle: "Drag Toolbar",
  // Text for the annotation toolbar's line drawings menu button
  toolbarAnnotationsLineAnnotations: "Trend Lines",
  // Text for the annotation toolbar's Fibonacci drawings menu button
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  // Text for the annotation toolbar's text annotations menu button
  toolbarAnnotationsTextAnnotations: "Text Annotations",
  // Text for the annotation toolbar's shapes menu button
  toolbarAnnotationsShapeAnnotations: "Arrows",
  // Text for the annotation toolbar's measurers menu button
  toolbarAnnotationsMeasurerAnnotations: "Measurers",
  // Text for the annotation toolbar's callout button
  toolbarAnnotationsCallout: "Callout",
  // Text for the annotation toolbar's comment button
  toolbarAnnotationsComment: "Comment",
  // Text for the annotation toolbar's note button
  toolbarAnnotationsNote: "Note",
  // Text for the annotation toolbar's text button
  toolbarAnnotationsText: "Text",
  // Text for the annotation toolbar's arrow button
  toolbarAnnotationsArrow: "Arrow",
  // Text for the annotation toolbar's arrow up button
  toolbarAnnotationsArrowUp: "Arrow Up",
  // Text for the annotation toolbar's arrow down button
  toolbarAnnotationsArrowDown: "Arrow Down",
  // Text for the annotation toolbar's date range button
  toolbarAnnotationsDateRange: "Date Range",
  // Text for the annotation toolbar's price range button
  toolbarAnnotationsPriceRange: "Price Range",
  // Text for the annotation toolbar's date and price range button
  toolbarAnnotationsDatePriceRange: "Date and Price",
  // Text for the annotation toolbar's quick date and price range button
  toolbarAnnotationsQuickDatePriceRange: "Measure",
  // Text for the range toolbar's 1 month button
  toolbarRange1Month: "1M",
  // Aria label for the range toolbar's 1 month button
  toolbarRange1MonthAria: "1 month",
  // Text for the range toolbar's 3 month button
  toolbarRange3Months: "3M",
  // Aria label for the range toolbar's 3 month button
  toolbarRange3MonthsAria: "3 months",
  // Text for the range toolbar's 6 month button
  toolbarRange6Months: "6M",
  // Aria label for the range toolbar's 6 month button
  toolbarRange6MonthsAria: "6 months",
  // Text for the range toolbar's year to date button
  toolbarRangeYearToDate: "YTD",
  // Aria label for the range toolbar's year to date month button
  toolbarRangeYearToDateAria: "Year to date",
  // Text for the range toolbar's 1 year button
  toolbarRange1Year: "1Y",
  // Aria label for the range toolbar's 1 year button
  toolbarRange1YearAria: "1 year",
  // Text for the range toolbar's full range button
  toolbarRangeAll: "All",
  // Aria label for the range toolbar's full range button
  toolbarRangeAllAria: "All",
  // Text for the zoom toolbar's zoom out button
  toolbarZoomZoomOut: "Zoom out",
  // Text for the zoom toolbar's zoom in button
  toolbarZoomZoomIn: "Zoom in",
  // Text for the zoom toolbar's pan left button
  toolbarZoomPanLeft: "Pan left",
  // Text for the zoom toolbar's pan right button
  toolbarZoomPanRight: "Pan right",
  // Text for the zoom toolbar's pan to the start button
  toolbarZoomPanStart: "Pan to the start",
  // Text for the zoom toolbar's pan to the end button
  toolbarZoomPanEnd: "Pan to the end",
  // Text for the zoom toolbar's pan reset button
  toolbarZoomReset: "Reset the zoom",
  // Text for the context menu's download button
  contextMenuDownload: "Download",
  // Text for the context menu's toggle series visibility button
  contextMenuToggleSeriesVisibility: "Toggle Visibility",
  // Text for the context menu's toggle other series visibility button
  contextMenuToggleOtherSeries: "Toggle Other Series",
  // Text for the context menu's zoom to point button
  contextMenuZoomToCursor: "Zoom to here",
  // Text for the context menu's pan to point button
  contextMenuPanToCursor: "Pan to here",
  // Text for the annotation dialog's header channel tab label
  dialogHeaderChannel: "Channel",
  // Text for the annotation dialog's header line tab label
  dialogHeaderLine: "Line",
  // Text for the annotation dialog's header fibonacci retracement line tab label
  dialogHeaderFibonacciRange: "Fib Retracement",
  // Text for the annotation dialog's header date range tab label
  dialogHeaderDateRange: "Date Range",
  // Text for the annotation dialog's header price range tab label
  dialogHeaderPriceRange: "Price Range",
  // Text for the annotation dialog's header date and price range tab label
  dialogHeaderDatePriceRange: "Date and Price",
  // Text for the annotation dialog's header text tab label
  dialogHeaderText: "Text",
  // Text for the annotation dialog's text alignment radio label
  dialogInputAlign: "Align",
  // Text for the annotation dialog's color picker label
  dialogInputColorPicker: "Color",
  // Text for the annotation dialog's color picker alt text
  dialogInputColorPickerAltText: "Text Color",
  // Text for the annotation dialog's fill color picker label
  dialogInputFillColorPicker: "Fill",
  // Text for the annotation dialog's fill color picker alt text
  dialogInputFillColorPickerAltText: "Fill Color",
  // Text for the annotation dialog's extend channel start checkbox
  dialogInputExtendChannelStart: "Extend channel start",
  // Text for the annotation dialog's extend channel end checkbox
  dialogInputExtendChannelEnd: "Extend channel end",
  // Text for the annotation dialog's extend line start checkbox
  dialogInputExtendLineStart: "Extend line start",
  // Text for the annotation dialog's extend line end checkbox
  dialogInputExtendLineEnd: "Extend line end",
  // Text for the annotation dialog's extend above checkbox
  dialogInputExtendAbove: "Extend above",
  // Text for the annotation dialog's extend below checkbox
  dialogInputExtendBelow: "Extend below",
  // Text for the annotation dialog's extend left checkbox
  dialogInputExtendLeft: "Extend left",
  // Text for the annotation dialog's extend right checkbox
  dialogInputExtendRight: "Extend right",
  // Text for the annotation dialog's reverse checkbox
  dialogInputReverse: "Reverse",
  // Text for the annotation dialog's show fill checkbox
  dialogInputShowFill: "Show Fill",
  // Text for the annotation dialog's font size select box label
  dialogInputFontSize: "Size",
  // Text for the annotation dialog's font size select box alt text
  dialogInputFontSizeAltText: "Font Size",
  // Text for the annotation dialog's line style radio label
  dialogInputLineStyle: "Dash",
  // Text for the annotation dialog's text position radio label
  dialogInputPosition: "Position",
  // Text for the annotation dialog's stroke width label
  dialogInputStrokeWidth: "Weight",
  // Text for the annotation dialog's stroke width label
  dialogInputStrokeWidthAltText: "Line Weight",
  // Text for the annotation dialog's Fibonacci bands label
  dialogInputFibonacciBands: "Bands",
  // Text for the annotation dialog's Fibonacci bands label
  dialogInputFibonacciBandsAltText: "Fibonacci Bands",
  // Text for text area input placeholders
  inputTextareaPlaceholder: "Add Text",
  // Text for the measurer statistics date range bars value
  measurerDateRangeBars: "${value}[number] bars",
  // Text for the measurer statistics price range value
  measurerPriceRangeValue: "${value}[number]",
  // Text for the measurer statistics price range percentage
  measurerPriceRangePercent: "${value}[percent]",
  // Text for the measurer statistics volume value
  measurerVolume: "Vol ${value}",
  // Status when multiple data are under the cursor, and the user can click to cycle through which one appears in the tooltip
  tooltipPaginationStatus: "${index}[number] of ${count}[number]"
};
var AG_CHARTS_LOCALE_ES_ES = {
  ariaAnnounceChart: "gr\xE1fico, ${seriesCount}[number] series",
  ariaAnnounceFlowProportionLink: "enlace ${index} de ${count}, de ${from} a ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nodo ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "gr\xE1fico de veloc\xEDmetro, ${caption}",
  ariaAnnounceHierarchyChart: "gr\xE1fico de jerarqu\xEDa, ${caption}",
  ariaAnnounceHierarchyDatum: "nivel ${level}[number], ${count}[number] hijos, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Presiona Espacio o Enter para alternar la visibilidad",
  ariaLabelAddHorizontalLine: "A\xF1adir l\xEDnea horizontal",
  ariaLabelAnnotationOptionsToolbar: "Opciones de anotaci\xF3n",
  ariaLabelAnnotationSettingsDialog: "Configuraci\xF3n de anotaci\xF3n",
  ariaLabelColorPicker: "Selector de color",
  ariaLabelFinancialCharts: "Gr\xE1ficos financieros",
  ariaLabelLegend: "Leyenda",
  ariaLabelLegendItem: "${label}, Elemento de la leyenda ${index}[number] de ${count}[number]",
  ariaLabelLegendItemUnknown: "Elemento desconocido de la leyenda",
  ariaLabelLegendPageNext: "Siguiente p\xE1gina de leyenda",
  ariaLabelLegendPagePrevious: "P\xE1gina anterior de la leyenda",
  ariaLabelLegendPagination: "Paginaci\xF3n de la leyenda",
  ariaLabelNavigator: "Navegador",
  ariaLabelNavigatorMaximum: "M\xE1ximo",
  ariaLabelNavigatorMinimum: "M\xEDnimo",
  ariaLabelNavigatorRange: "Rango",
  ariaLabelRangesToolbar: "Rangos",
  ariaLabelSettingsTabBar: "Configuraci\xF3n",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Descargar",
  contextMenuPanToCursor: "Desplazar hasta aqu\xED",
  contextMenuToggleOtherSeries: "Alternar Otras Series",
  contextMenuToggleSeriesVisibility: "Alternar visibilidad",
  contextMenuZoomToCursor: "Acercar aqu\xED",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Fecha y Precio",
  dialogHeaderDateRange: "Rango de fechas",
  dialogHeaderFibonacciRange: "Fib Retroceso",
  dialogHeaderLine: "L\xEDnea",
  dialogHeaderPriceRange: "Rango de precios",
  dialogHeaderText: "Texto",
  dialogInputAlign: "Alinear",
  dialogInputColorPicker: "Color",
  dialogInputColorPickerAltText: "Color del texto",
  dialogInputExtendAbove: "Extender por encima",
  dialogInputExtendBelow: "Extender debajo",
  dialogInputExtendChannelEnd: "Extender fin del canal",
  dialogInputExtendChannelStart: "Extender inicio del canal",
  dialogInputExtendLeft: "Extender hacia la izquierda",
  dialogInputExtendLineEnd: "Extender el final de la l\xEDnea",
  dialogInputExtendLineStart: "Extender inicio de la l\xEDnea",
  dialogInputExtendRight: "Extender a la derecha",
  dialogInputFibonacciBands: "Bandas",
  dialogInputFibonacciBandsAltText: "Bandas de Fibonacci",
  dialogInputFillColorPicker: "Rellenar",
  dialogInputFillColorPickerAltText: "Color de relleno",
  dialogInputFontSize: "Tama\xF1o",
  dialogInputFontSizeAltText: "Tama\xF1o de Fuente",
  dialogInputLineStyle: "Guion",
  dialogInputPosition: "Posici\xF3n",
  dialogInputReverse: "Inverso",
  dialogInputShowFill: "Mostrar relleno",
  dialogInputStrokeWidth: "Grosor",
  dialogInputStrokeWidthAltText: "Grosor de l\xEDnea",
  iconAltTextAlignCenter: "Centrar",
  iconAltTextAlignLeft: "Izquierda",
  iconAltTextAlignRight: "Derecha",
  iconAltTextClose: "Cerrar",
  iconAltTextLineStyleDashed: "L\xEDneas largas",
  iconAltTextLineStyleDotted: "L\xEDnea corta discontinua",
  iconAltTextLineStyleSolid: "S\xF3lido",
  iconAltTextPositionBottom: "Inferior",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "Parte superior",
  inputTextareaPlaceholder: "Agregar texto",
  measurerDateRangeBars: "${value}[number] barras",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Cargando datos...",
  overlayNoData: "No hay datos para mostrar",
  overlayNoVisibleSeries: "No hay series visibles",
  overlayUnsupportedBrowser: "Versi\xF3n del navegador no compatible. Por favor, actualice su navegador.",
  seriesHistogramTooltipCount: "${yName} (cuenta)",
  seriesHistogramTooltipFrequency: "Frecuencia",
  seriesHistogramTooltipMean: "${yName} (media)",
  seriesHistogramTooltipSum: "${yName} (suma)",
  toolbarAnnotationsArrow: "Flecha",
  toolbarAnnotationsArrowDown: "Flecha hacia abajo",
  toolbarAnnotationsArrowUp: "Flecha Arriba",
  toolbarAnnotationsCallout: "Anotaci\xF3n",
  toolbarAnnotationsClearAll: "Borrar todo",
  toolbarAnnotationsComment: "Comentario",
  toolbarAnnotationsDatePriceRange: "Fecha y Precio",
  toolbarAnnotationsDateRange: "Rango de fechas",
  toolbarAnnotationsDelete: "Eliminar",
  toolbarAnnotationsDisjointChannel: "Canal disjunto",
  toolbarAnnotationsDragHandle: "Arrastrar barra de herramientas",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retroceso de Fib",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Tendencia basada en Fibonacci",
  toolbarAnnotationsFillColor: "Color de Relleno",
  toolbarAnnotationsHorizontalLine: "L\xEDnea horizontal",
  toolbarAnnotationsLineAnnotations: "L\xEDneas de tendencia",
  toolbarAnnotationsLineColor: "Color de l\xEDnea",
  toolbarAnnotationsLineStrokeWidth: "Ancho del trazo de l\xEDnea",
  toolbarAnnotationsLineStyle: "Estilo de l\xEDnea",
  toolbarAnnotationsLock: "Bloquear",
  toolbarAnnotationsMeasurerAnnotations: "Medidores",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canal Paralelo",
  toolbarAnnotationsPriceRange: "Rango de precios",
  toolbarAnnotationsQuickDatePriceRange: "Medir",
  toolbarAnnotationsSettings: "Configuraciones",
  toolbarAnnotationsShapeAnnotations: "Flechas",
  toolbarAnnotationsText: "Texto",
  toolbarAnnotationsTextAnnotations: "Anotaciones de texto",
  toolbarAnnotationsTextColor: "Color del texto",
  toolbarAnnotationsTextSize: "Tama\xF1o del texto",
  toolbarAnnotationsTrendLine: "L\xEDnea de tendencia",
  toolbarAnnotationsUnlock: "Desbloquear",
  toolbarAnnotationsVerticalLine: "L\xEDnea Vertical",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mes",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 a\xF1o",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 meses",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 meses",
  toolbarRangeAll: "Todo",
  toolbarRangeAllAria: "Todo",
  toolbarRangeYearToDate: "A\xF1o en curso",
  toolbarRangeYearToDateAria: "A\xF1o hasta la fecha",
  toolbarSeriesTypeCandles: "Velas",
  toolbarSeriesTypeDropdown: "Tipo de Gr\xE1fico",
  toolbarSeriesTypeHighLow: "Alto Bajo",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Velas Huecas",
  toolbarSeriesTypeLine: "L\xEDnea",
  toolbarSeriesTypeLineWithMarkers: "L\xEDnea con marcadores",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "L\xEDnea escalonada",
  toolbarZoomPanEnd: "Desplazar hasta el final",
  toolbarZoomPanLeft: "Desplazar a la izquierda",
  toolbarZoomPanRight: "Desplazar a la derecha",
  toolbarZoomPanStart: "Mover al inicio",
  toolbarZoomReset: "Restablecer el zoom",
  toolbarZoomZoomIn: "Acercar",
  toolbarZoomZoomOut: "Alejar",
  tooltipPaginationStatus: "${index}[number] de ${count}[number]"
};
var AG_CHARTS_LOCALE_FA_IR = {
  ariaAnnounceChart: "\u0686\u0627\u0631\u062A\u060C ${seriesCount}[number] \u0645\u062C\u0645\u0648\u0639\u0647",
  ariaAnnounceFlowProportionLink: "\u0644\u06CC\u0646\u06A9 ${index} \u0627\u0632 ${count}\u060C \u0627\u0632 ${from} \u0628\u0647 ${to}\u060C ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u06AF\u0631\u0647 ${index} \u0627\u0632 ${count}\u060C ${description}",
  ariaAnnounceGaugeChart: "\u0686\u0627\u0631\u062A \u0633\u0646\u062C\u0634\u06CC\u060C ${caption}",
  ariaAnnounceHierarchyChart: "\u0646\u0645\u0648\u062F\u0627\u0631 \u0633\u0644\u0633\u0644\u0647 \u0645\u0631\u0627\u062A\u0628\u06CC\u060C ${caption}",
  ariaAnnounceHierarchyDatum: "\u0633\u0637\u062D ${level}[number]\u060C ${count}[number] \u0641\u0631\u0632\u0646\u062F\u060C ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u0628\u0631\u0627\u06CC \u062A\u063A\u06CC\u06CC\u0631 \u0642\u0627\u0628\u0644 \u0645\u0634\u0627\u0647\u062F\u0647 \u0628\u0648\u062F\u0646\u060C \u0627\u0633\u067E\u06CC\u0633 \u06CC\u0627 \u0627\u06CC\u0646\u062A\u0631 \u0631\u0627 \u0641\u0634\u0627\u0631 \u062F\u0647\u06CC\u062F",
  ariaLabelAddHorizontalLine: "\u0627\u0641\u0632\u0648\u062F\u0646 \u062E\u0637 \u0627\u0641\u0642\u06CC",
  ariaLabelAnnotationOptionsToolbar: "\u06AF\u0632\u06CC\u0646\u0647\u200C\u0647\u0627\u06CC \u062D\u0627\u0634\u06CC\u0647\u200C\u0646\u0648\u06CC\u0633\u06CC",
  ariaLabelAnnotationSettingsDialog: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A \u062D\u0627\u0634\u06CC\u0647 \u0646\u0648\u06CC\u0633\u06CC",
  ariaLabelColorPicker: "\u0627\u0646\u062A\u062E\u0627\u0628\u200C\u06AF\u0631 \u0631\u0646\u06AF",
  ariaLabelFinancialCharts: "\u0646\u0645\u0648\u062F\u0627\u0631\u0647\u0627\u06CC \u0645\u0627\u0644\u06CC",
  ariaLabelLegend: "\u0631\u0627\u0647\u0646\u0645\u0627",
  ariaLabelLegendItem: "${label}\u060C \u0645\u0648\u0631\u062F \u0641\u0647\u0631\u0633\u062A ${index}[number] \u0627\u0632 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u0645\u0648\u0631\u062F \u0646\u0627\u0634\u0646\u0627\u062E\u062A\u0647 \u062F\u0631 \u0641\u0647\u0631\u0633\u062A \u0639\u0644\u0627\u0626\u0645",
  ariaLabelLegendPageNext: "\u0635\u0641\u062D\u0647 \u0628\u0639\u062F\u06CC \u0631\u0627\u0647\u0646\u0645\u0627",
  ariaLabelLegendPagePrevious: "\u0635\u0641\u062D\u0647 \u0642\u0628\u0644\u06CC \u0627\u0641\u0633\u0627\u0646\u0647",
  ariaLabelLegendPagination: "\u0635\u0641\u062D\u0647\u200C\u0628\u0646\u062F\u06CC \u0631\u0627\u0647\u0646\u0645\u0627",
  ariaLabelNavigator: "\u062C\u0647\u062A\u200C\u06CC\u0627\u0628",
  ariaLabelNavigatorMaximum: "\u062D\u062F\u0627\u06A9\u062B\u0631",
  ariaLabelNavigatorMinimum: "\u062D\u062F\u0627\u0642\u0644",
  ariaLabelNavigatorRange: "\u0645\u062D\u062F\u0648\u062F\u0647",
  ariaLabelRangesToolbar: "\u0645\u062D\u062F\u0648\u062F\u0647\u200C\u0647\u0627",
  ariaLabelSettingsTabBar: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A",
  ariaLabelZoomToolbar: "\u0628\u0632\u0631\u06AF\u0646\u0645\u0627\u06CC\u06CC",
  ariaValuePanRange: "${min}[percent0to2dp] \u062A\u0627 ${max}[percent0to2dp]",
  contextMenuDownload: "\u062F\u0627\u0646\u0644\u0648\u062F",
  contextMenuPanToCursor: "\u062D\u0631\u06A9\u062A \u0628\u0647 \u0627\u06CC\u0646\u062C\u0627",
  contextMenuToggleOtherSeries: "\u062A\u063A\u06CC\u06CC\u0631 \u0648\u0636\u0639\u06CC\u062A \u0633\u0627\u06CC\u0631 \u0633\u0631\u06CC\u200C\u0647\u0627",
  contextMenuToggleSeriesVisibility: "\u062A\u063A\u06CC\u06CC\u0631 \u0646\u0645\u0627\u06CC\u0634",
  contextMenuZoomToCursor: "\u0632\u0648\u0645 \u0628\u0647 \u0627\u06CC\u0646\u062C\u0627",
  dialogHeaderChannel: "\u06A9\u0627\u0646\u0627\u0644",
  dialogHeaderDatePriceRange: "\u062A\u0627\u0631\u06CC\u062E \u0648 \u0642\u06CC\u0645\u062A",
  dialogHeaderDateRange: "\u0628\u0627\u0632\u0647 \u0632\u0645\u0627\u0646\u06CC",
  dialogHeaderFibonacciRange: "\u0641\u06CC\u0628 \u0628\u0627\u0632\u06AF\u0634\u062A",
  dialogHeaderLine: "\u062E\u0637",
  dialogHeaderPriceRange: "\u0628\u0627\u0632\u0647 \u0642\u06CC\u0645\u062A\u06CC",
  dialogHeaderText: "\u0645\u062A\u0646",
  dialogInputAlign: "\u062A\u0631\u0627\u0632",
  dialogInputColorPicker: "\u0631\u0646\u06AF",
  dialogInputColorPickerAltText: "\u0631\u0646\u06AF \u0645\u062A\u0646",
  dialogInputExtendAbove: "\u06AF\u0633\u062A\u0631\u0634 \u0628\u0627\u0644\u0627",
  dialogInputExtendBelow: "\u062A\u062D\u062A\u0627\u0646\u06CC \u06AF\u0633\u062A\u0631\u0634 \u06CC\u0627\u0628\u062F",
  dialogInputExtendChannelEnd: "\u06AF\u0633\u062A\u0631\u0634 \u0627\u0646\u062A\u0647\u0627\u06CC \u06A9\u0627\u0646\u0627\u0644",
  dialogInputExtendChannelStart: "\u062A\u0645\u062F\u06CC\u062F \u0634\u0631\u0648\u0639 \u06A9\u0627\u0646\u0627\u0644",
  dialogInputExtendLeft: "\u06AF\u0633\u062A\u0631\u0634 \u0628\u0647 \u0686\u067E",
  dialogInputExtendLineEnd: "\u0627\u062F\u0627\u0645\u0647 \u062E\u0637 \u067E\u0627\u06CC\u0627\u0646",
  dialogInputExtendLineStart: "\u06AF\u0633\u062A\u0631\u0634 \u0634\u0631\u0648\u0639 \u062E\u0637",
  dialogInputExtendRight: "\u0627\u062F\u0627\u0645\u0647 \u0628\u0647 \u0631\u0627\u0633\u062A",
  dialogInputFibonacciBands: "\u0628\u0627\u0646\u062F\u0647\u0627",
  dialogInputFibonacciBandsAltText: "\u0628\u0627\u0646\u062F\u0647\u0627\u06CC \u0641\u06CC\u0628\u0648\u0646\u0627\u0686\u06CC",
  dialogInputFillColorPicker: "\u067E\u0631 \u06A9\u0631\u062F\u0646",
  dialogInputFillColorPickerAltText: "\u0631\u0646\u06AF \u067E\u0631 \u06A9\u0631\u062F\u0646",
  dialogInputFontSize: "\u0627\u0646\u062F\u0627\u0632\u0647",
  dialogInputFontSizeAltText: "\u0627\u0646\u062F\u0627\u0632\u0647 \u0641\u0648\u0646\u062A",
  dialogInputLineStyle: "\u062E\u0637 \u0686\u06CC\u0646",
  dialogInputPosition: "\u0645\u0648\u0642\u0639\u06CC\u062A",
  dialogInputReverse: "\u0628\u0631\u0639\u06A9\u0633",
  dialogInputShowFill: "\u0646\u0645\u0627\u06CC\u0634 \u067E\u0631 \u06A9\u0631\u062F\u0646",
  dialogInputStrokeWidth: "\u0648\u0632\u0646",
  dialogInputStrokeWidthAltText: "\u0648\u0632\u0646 \u062E\u0637",
  iconAltTextAlignCenter: "\u0648\u0633\u0637",
  iconAltTextAlignLeft: "\u0686\u067E",
  iconAltTextAlignRight: "\u0631\u0627\u0633\u062A",
  iconAltTextClose: "\u0628\u0633\u062A\u0646",
  iconAltTextLineStyleDashed: "\u062E\u0637-\u0686\u06CC\u0646 \u0628\u0644\u0646\u062F",
  iconAltTextLineStyleDotted: "\u062E\u0637 \u0628\u0627 \u062E\u0637\u200C\u0686\u06CC\u0646 \u06A9\u0648\u062A\u0627\u0647",
  iconAltTextLineStyleSolid: "\u06CC\u06A9\u062F\u0633\u062A",
  iconAltTextPositionBottom: "\u067E\u0627\u06CC\u06CC\u0646",
  iconAltTextPositionCenter: "\u0645\u0631\u06A9\u0632",
  iconAltTextPositionTop: "\u0628\u0627\u0644\u0627",
  inputTextareaPlaceholder: "\u0627\u0636\u0627\u0641\u0647 \u06A9\u0631\u062F\u0646 \u0645\u062A\u0646",
  measurerDateRangeBars: "${value}[number] \u0645\u06CC\u0644\u0647\u200C\u0647\u0627",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u062D\u062C\u0645 ${value}",
  overlayLoadingData: "\u062F\u0631 \u062D\u0627\u0644 \u0628\u0627\u0631\u06AF\u0630\u0627\u0631\u06CC \u062F\u0627\u062F\u0647...",
  overlayNoData: "\u062F\u0627\u062F\u0647\u200C\u0627\u06CC \u0628\u0631\u0627\u06CC \u0646\u0645\u0627\u06CC\u0634 \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F",
  overlayNoVisibleSeries: "\u0633\u0631\u06CC \u0642\u0627\u0628\u0644 \u0645\u0634\u0627\u0647\u062F\u0647\u200C\u0627\u06CC \u0648\u062C\u0648\u062F \u0646\u062F\u0627\u0631\u062F",
  overlayUnsupportedBrowser: "\u0646\u0633\u062E\u0647 \u0645\u0631\u0648\u0631\u06AF\u0631 \u0646\u0627\u0633\u0627\u0632\u06AF\u0627\u0631 \u0627\u0633\u062A. \u0644\u0637\u0641\u0627\u064B \u0645\u0631\u0648\u0631\u06AF\u0631 \u062E\u0648\u062F \u0631\u0627 \u0628\u0647\u200C\u0631\u0648\u0632\u0631\u0633\u0627\u0646\u06CC \u06A9\u0646\u06CC\u062F.",
  seriesHistogramTooltipCount: "${yName} (\u062A\u0639\u062F\u0627\u062F)",
  seriesHistogramTooltipFrequency: "\u0628\u0633\u0627\u0645\u062F",
  seriesHistogramTooltipMean: "${yName} (\u0645\u06CC\u0627\u0646\u06AF\u06CC\u0646)",
  seriesHistogramTooltipSum: "${yName} (\u0645\u062C\u0645\u0648\u0639)",
  toolbarAnnotationsArrow: "\u067E\u06CC\u06A9\u0627\u0646",
  toolbarAnnotationsArrowDown: "\u067E\u06CC\u06A9\u0627\u0646 \u067E\u0627\u06CC\u06CC\u0646",
  toolbarAnnotationsArrowUp: "\u067E\u06CC\u06A9\u0627\u0646 \u0628\u0627\u0644\u0627",
  toolbarAnnotationsCallout: "\u06CC\u0627\u062F\u062F\u0627\u0634\u062A",
  toolbarAnnotationsClearAll: "\u067E\u0627\u06A9 \u06A9\u0631\u062F\u0646 \u0647\u0645\u0647",
  toolbarAnnotationsComment: "\u0646\u0638\u0631",
  toolbarAnnotationsDatePriceRange: "\u062A\u0627\u0631\u06CC\u062E \u0648 \u0642\u06CC\u0645\u062A",
  toolbarAnnotationsDateRange: "\u0628\u0627\u0632\u0647 \u0632\u0645\u0627\u0646\u06CC",
  toolbarAnnotationsDelete: "\u062D\u0630\u0641",
  toolbarAnnotationsDisjointChannel: "\u06A9\u0627\u0646\u0627\u0644 \u062C\u062F\u0627\u06AF\u0627\u0646\u0647",
  toolbarAnnotationsDragHandle: "\u062F\u0633\u062A\u0647 \u0627\u0628\u0632\u0627\u0631 \u0631\u0627 \u0628\u06A9\u0634\u06CC\u062F",
  toolbarAnnotationsFibonacciAnnotations: "\u0641\u06CC\u0628\u0648\u0646\u0627\u0686\u06CC",
  toolbarAnnotationsFibonacciRetracement: "\u0641\u06CC\u0628 \u0628\u0627\u0632\u06AF\u0634\u062A\u06CC",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0631\u0648\u0646\u062F \u0641\u06CC\u0628 \u0628\u0631 \u0627\u0633\u0627\u0633",
  toolbarAnnotationsFillColor: "\u0631\u0646\u06AF \u067E\u0631 \u06A9\u0631\u062F\u0646",
  toolbarAnnotationsHorizontalLine: "\u062E\u0637 \u0627\u0641\u0642\u06CC",
  toolbarAnnotationsLineAnnotations: "\u062E\u0637\u0648\u0637 \u0631\u0648\u0646\u062F",
  toolbarAnnotationsLineColor: "\u0631\u0646\u06AF \u062E\u0637",
  toolbarAnnotationsLineStrokeWidth: "\u0639\u0631\u0636 \u062E\u0637 \u0642\u0644\u0645",
  toolbarAnnotationsLineStyle: "\u0633\u0628\u06A9 \u062E\u0637",
  toolbarAnnotationsLock: "\u0642\u0641\u0644 \u06A9\u0631\u062F\u0646",
  toolbarAnnotationsMeasurerAnnotations: "\u0627\u0628\u0632\u0627\u0631 \u0627\u0646\u062F\u0627\u0632\u0647\u200C\u06AF\u06CC\u0631\u06CC",
  toolbarAnnotationsNote: "\u062A\u0648\u062C\u0647",
  toolbarAnnotationsParallelChannel: "\u06A9\u0627\u0646\u0627\u0644 \u0645\u0648\u0627\u0632\u06CC",
  toolbarAnnotationsPriceRange: "\u0645\u062D\u062F\u0648\u062F\u0647 \u0642\u06CC\u0645\u062A",
  toolbarAnnotationsQuickDatePriceRange: "\u0627\u0646\u062F\u0627\u0632\u0647\u200C\u06AF\u06CC\u0631\u06CC",
  toolbarAnnotationsSettings: "\u062A\u0646\u0638\u06CC\u0645\u0627\u062A",
  toolbarAnnotationsShapeAnnotations: "\u067E\u06CC\u06A9\u0627\u0646\u200C\u0647\u0627",
  toolbarAnnotationsText: "\u0645\u062A\u0646",
  toolbarAnnotationsTextAnnotations: "\u062D\u0627\u0634\u06CC\u0647\u200C\u0646\u0648\u06CC\u0633\u06CC\u200C\u0647\u0627\u06CC \u0645\u062A\u0646\u06CC",
  toolbarAnnotationsTextColor: "\u0631\u0646\u06AF \u0645\u062A\u0646",
  toolbarAnnotationsTextSize: "\u0627\u0646\u062F\u0627\u0632\u0647 \u0645\u062A\u0646",
  toolbarAnnotationsTrendLine: "\u062E\u0637 \u0631\u0648\u0646\u062F",
  toolbarAnnotationsUnlock: "\u0628\u0627\u0632 \u06A9\u0631\u062F\u0646",
  toolbarAnnotationsVerticalLine: "\u062E\u0637 \u0639\u0645\u0648\u062F\u06CC",
  toolbarRange1Month: "\u06F1 \u0645\u0627\u0647",
  toolbarRange1MonthAria: "\u06F1 \u0645\u0627\u0647",
  toolbarRange1Year: "1\u0633\u0627\u0644",
  toolbarRange1YearAria: "\u06F1 \u0633\u0627\u0644",
  toolbarRange3Months: "\u06F3\u0645",
  toolbarRange3MonthsAria: "\u06F3 \u0645\u0627\u0647",
  toolbarRange6Months: "6\u0645\u0627\u0647",
  toolbarRange6MonthsAria: "\u06F6 \u0645\u0627\u0647",
  toolbarRangeAll: "\u0647\u0645\u0647",
  toolbarRangeAllAria: "\u0647\u0645\u0647",
  toolbarRangeYearToDate: "\u0627\u0632 \u0627\u0628\u062A\u062F\u0627\u06CC \u0633\u0627\u0644",
  toolbarRangeYearToDateAria: "\u0627\u0632 \u0627\u0628\u062A\u062F\u0627\u06CC \u0633\u0627\u0644 \u062A\u0627 \u06A9\u0646\u0648\u0646",
  toolbarSeriesTypeCandles: "\u0634\u0645\u0639\u200C\u0647\u0627",
  toolbarSeriesTypeDropdown: "\u0646\u0648\u0639 \u0646\u0645\u0648\u062F\u0627\u0631",
  toolbarSeriesTypeHighLow: "\u0628\u06CC\u0634\u062A\u0631\u06CC\u0646 \u0648 \u06A9\u0645\u062A\u0631\u06CC\u0646",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u0634\u0645\u0639 \u0647\u0627\u06CC \u062A\u0648\u062E\u0627\u0644\u06CC",
  toolbarSeriesTypeLine: "\u062E\u0637",
  toolbarSeriesTypeLineWithMarkers: "\u062E\u0637 \u0628\u0627 \u0646\u0634\u0627\u0646\u06AF\u0631\u0647\u0627",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u06AF\u0627\u0645 \u062E\u0637",
  toolbarZoomPanEnd: "\u062D\u0631\u06A9\u062A \u0628\u0647 \u0627\u0646\u062A\u0647\u0627",
  toolbarZoomPanLeft: "\u062D\u0631\u06A9\u062A \u0628\u0647 \u0686\u067E",
  toolbarZoomPanRight: "\u062D\u0631\u06A9\u062A \u0628\u0647 \u0631\u0627\u0633\u062A",
  toolbarZoomPanStart: "\u062C\u0627\u0628\u062C\u0627\u06CC\u06CC \u0628\u0647 \u0627\u0628\u062A\u062F\u0627",
  toolbarZoomReset: "\u0628\u0627\u0632\u0646\u0634\u0627\u0646\u06CC \u0628\u0632\u0631\u06AF\u200C\u0646\u0645\u0627\u06CC\u06CC",
  toolbarZoomZoomIn: "\u0628\u0632\u0631\u06AF\u0646\u0645\u0627\u06CC\u06CC",
  toolbarZoomZoomOut: "\u0628\u0632\u0631\u06AF\u0646\u0645\u0627\u06CC\u06CC \u06A9\u0645\u062A\u0631",
  tooltipPaginationStatus: "${index}[number] \u0627\u0632 ${count}[number]"
};
var AG_CHARTS_LOCALE_FI_FI = {
  ariaAnnounceChart: "kaavio, ${seriesCount}[number] sarjaa",
  ariaAnnounceFlowProportionLink: "linkki ${index} / ${count}, l\xE4htien ${from} p\xE4\xE4ttyen ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "solmu ${index} ${count} n\xE4kyviss\xE4, ${description}",
  ariaAnnounceGaugeChart: "mittarikaavio, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkkinen kaavio, ${caption}",
  ariaAnnounceHierarchyDatum: "taso ${level}[number], ${count}[number] lasta, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Paina v\xE4lily\xF6nti\xE4 tai Enteri\xE4 vaihtaaksesi n\xE4kyvyytt\xE4",
  ariaLabelAddHorizontalLine: "Lis\xE4\xE4 vaakasuora viiva",
  ariaLabelAnnotationOptionsToolbar: "Merkinn\xE4n vaihtoehdot",
  ariaLabelAnnotationSettingsDialog: "Merkinn\xE4n asetukset",
  ariaLabelColorPicker: "V\xE4rinvalitsin",
  ariaLabelFinancialCharts: "Taloudelliset kaaviot",
  ariaLabelLegend: "Selite",
  ariaLabelLegendItem: "${label}, Legendan kohde ${index}[number] ${count}[number] kohteesta",
  ariaLabelLegendItemUnknown: "Tuntematon legenda-esiintym\xE4",
  ariaLabelLegendPageNext: "Seuraava selitteen sivu",
  ariaLabelLegendPagePrevious: "Edellinen selitesivu",
  ariaLabelLegendPagination: "Legendan sivutus",
  ariaLabelNavigator: "Navigaattori",
  ariaLabelNavigatorMaximum: "Maksimi",
  ariaLabelNavigatorMinimum: "Minimi",
  ariaLabelNavigatorRange: "Alue",
  ariaLabelRangesToolbar: "Alueet",
  ariaLabelSettingsTabBar: "Asetukset",
  ariaLabelZoomToolbar: "Zoomaa",
  ariaValuePanRange: "${min}[percent0to2dp] - ${max}[percent0to2dp]",
  contextMenuDownload: "Lataa",
  contextMenuPanToCursor: "Siirry t\xE4h\xE4n",
  contextMenuToggleOtherSeries: "Vaihda muiden sarjojen n\xE4kyvyytt\xE4",
  contextMenuToggleSeriesVisibility: "Vaihda n\xE4kyvyytt\xE4",
  contextMenuZoomToCursor: "Zoomaa t\xE4h\xE4n",
  dialogHeaderChannel: "Kanava",
  dialogHeaderDatePriceRange: "P\xE4iv\xE4m\xE4\xE4r\xE4 ja hinta",
  dialogHeaderDateRange: "Aikav\xE4li",
  dialogHeaderFibonacciRange: "Fib-palautus",
  dialogHeaderLine: "Viiva",
  dialogHeaderPriceRange: "Hintaluokka",
  dialogHeaderText: "Teksti",
  dialogInputAlign: "Tasaa",
  dialogInputColorPicker: "V\xE4ri",
  dialogInputColorPickerAltText: "Tekstin v\xE4ri",
  dialogInputExtendAbove: "Laajenna yl\xE4puolelle",
  dialogInputExtendBelow: "Laajenna alle",
  dialogInputExtendChannelEnd: "Jatka kanavan p\xE4\xE4t\xE4",
  dialogInputExtendChannelStart: "Laajenna kanavan alkua",
  dialogInputExtendLeft: "Laajenna vasemmalle",
  dialogInputExtendLineEnd: "Jatka viivan loppua",
  dialogInputExtendLineStart: "Laajenna viivan alkua",
  dialogInputExtendRight: "Laajenna oikealle",
  dialogInputFibonacciBands: "Kaistat",
  dialogInputFibonacciBandsAltText: "Fibonacci-kaistat",
  dialogInputFillColorPicker: "T\xE4yt\xE4",
  dialogInputFillColorPickerAltText: "T\xE4ytt\xF6v\xE4ri",
  dialogInputFontSize: "Koko",
  dialogInputFontSizeAltText: "Kirjasinkoko",
  dialogInputLineStyle: "Viiva",
  dialogInputPosition: "Sijainti",
  dialogInputReverse: "K\xE4\xE4nteinen",
  dialogInputShowFill: "N\xE4yt\xE4 t\xE4ytt\xF6",
  dialogInputStrokeWidth: "Viivan paksuus",
  dialogInputStrokeWidthAltText: "Viivan leveys",
  iconAltTextAlignCenter: "Keskit\xE4",
  iconAltTextAlignLeft: "Vasen",
  iconAltTextAlignRight: "Oikea",
  iconAltTextClose: "Sulje",
  iconAltTextLineStyleDashed: "Pitk\xE4viivainen",
  iconAltTextLineStyleDotted: "Lyhytkatkoviivainen",
  iconAltTextLineStyleSolid: "Yhten\xE4inen",
  iconAltTextPositionBottom: "Alhaalla",
  iconAltTextPositionCenter: "Keskusta",
  iconAltTextPositionTop: "Yl\xE4osa",
  inputTextareaPlaceholder: "Lis\xE4\xE4 teksti\xE4",
  measurerDateRangeBars: "${value}[number] palkit",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "\u2018${value}[number]\u2019",
  measurerVolume: "Tilavuus ${value}",
  overlayLoadingData: "Ladataan tietoja...",
  overlayNoData: "Ei n\xE4ytett\xE4v\xE4\xE4 dataa",
  overlayNoVisibleSeries: "Ei n\xE4kyviss\xE4 olevia sarjoja",
  overlayUnsupportedBrowser: "Yhteensopimaton selaimen versio. P\xE4ivit\xE4 selaimesi.",
  seriesHistogramTooltipCount: "${yName} (m\xE4\xE4r\xE4)",
  seriesHistogramTooltipFrequency: "Tiheys",
  seriesHistogramTooltipMean: "${yName} (keskiarvo)",
  seriesHistogramTooltipSum: "${yName} (summa)",
  toolbarAnnotationsArrow: "Nuoli",
  toolbarAnnotationsArrowDown: "Nuoli alas",
  toolbarAnnotationsArrowUp: "Nuoli yl\xF6s",
  toolbarAnnotationsCallout: "Huomautus",
  toolbarAnnotationsClearAll: "Tyhjenn\xE4 kaikki",
  toolbarAnnotationsComment: "Kommentoi",
  toolbarAnnotationsDatePriceRange: "P\xE4iv\xE4ys ja Hinta",
  toolbarAnnotationsDateRange: "Aikav\xE4li",
  toolbarAnnotationsDelete: "Poista",
  toolbarAnnotationsDisjointChannel: "Ep\xE4yhten\xE4inen kanava",
  toolbarAnnotationsDragHandle: "Ved\xE4 ty\xF6kalurivi\xE4",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trendiin Perustuva",
  toolbarAnnotationsFillColor: "T\xE4ytt\xF6v\xE4ri",
  toolbarAnnotationsHorizontalLine: "Vaakasuora viiva",
  toolbarAnnotationsLineAnnotations: "Trendiviivat",
  toolbarAnnotationsLineColor: "V\xE4ri",
  toolbarAnnotationsLineStrokeWidth: "Viivan paksuus",
  toolbarAnnotationsLineStyle: "Viivatyylit",
  toolbarAnnotationsLock: "Lukitse",
  toolbarAnnotationsMeasurerAnnotations: "Mittaukset",
  toolbarAnnotationsNote: "Muistio",
  toolbarAnnotationsParallelChannel: "Rinnakkaiskanava",
  toolbarAnnotationsPriceRange: "Hintahaarukka",
  toolbarAnnotationsQuickDatePriceRange: "Mittaa",
  toolbarAnnotationsSettings: "Asetukset",
  toolbarAnnotationsShapeAnnotations: "Nuolia",
  toolbarAnnotationsText: "Teksti",
  toolbarAnnotationsTextAnnotations: "Tekstihuomautukset",
  toolbarAnnotationsTextColor: "Tekstin v\xE4ri",
  toolbarAnnotationsTextSize: "Tekstin koko",
  toolbarAnnotationsTrendLine: "Trendi Viiva",
  toolbarAnnotationsUnlock: "Avaa lukitus",
  toolbarAnnotationsVerticalLine: "Pystysuora viiva",
  toolbarRange1Month: "1KK",
  toolbarRange1MonthAria: "1 kuukausi",
  toolbarRange1Year: "1V",
  toolbarRange1YearAria: "1 vuosi",
  toolbarRange3Months: "3kk",
  toolbarRange3MonthsAria: "3 kuukautta",
  toolbarRange6Months: "6 kk",
  toolbarRange6MonthsAria: "6 kuukautta",
  toolbarRangeAll: "Kaikki",
  toolbarRangeAllAria: "Kaikki",
  toolbarRangeYearToDate: "Vuodesta t\xE4h\xE4n p\xE4iv\xE4\xE4n",
  toolbarRangeYearToDateAria: "Vuosi t\xE4h\xE4n p\xE4iv\xE4\xE4n",
  toolbarSeriesTypeCandles: "Kynttil\xE4t",
  toolbarSeriesTypeDropdown: "Kaaviotyyppi",
  toolbarSeriesTypeHighLow: "Korkea Matala",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Ontot Kynttil\xE4t",
  toolbarSeriesTypeLine: "Viiva",
  toolbarSeriesTypeLineWithMarkers: "Viiva merkinn\xF6ill\xE4",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Askelviiva",
  toolbarZoomPanEnd: "Siirry loppuun",
  toolbarZoomPanLeft: "Vierit\xE4 vasemmalle",
  toolbarZoomPanRight: "Panoroi oikealle",
  toolbarZoomPanStart: "Panoroi alkuun",
  toolbarZoomReset: "Palauta zoomaus",
  toolbarZoomZoomIn: "L\xE4henn\xE4",
  toolbarZoomZoomOut: "Loitonna",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
var AG_CHARTS_LOCALE_FR_FR = {
  ariaAnnounceChart: "graphique, ${seriesCount}[number] s\xE9ries",
  ariaAnnounceFlowProportionLink: "lien ${index} de ${count}, de ${from} \xE0 ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\u0153ud ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "graphique en jauge, ${caption}",
  ariaAnnounceHierarchyChart: "graphique hi\xE9rarchique, ${caption}",
  ariaAnnounceHierarchyDatum: "niveau ${level}[number], ${count}[number] enfants, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Appuyez sur Espace ou Entr\xE9e pour basculer la visibilit\xE9",
  ariaLabelAddHorizontalLine: "Ajouter une ligne horizontale",
  ariaLabelAnnotationOptionsToolbar: "Options d'annotation",
  ariaLabelAnnotationSettingsDialog: "Param\xE8tres d'annotation",
  ariaLabelColorPicker: "S\xE9lecteur de couleur",
  ariaLabelFinancialCharts: "Graphiques financiers",
  ariaLabelLegend: "L\xE9gende",
  ariaLabelLegendItem: "${label}, \xC9l\xE9ment de l\xE9gende ${index}[number] sur ${count}[number]",
  ariaLabelLegendItemUnknown: "\xC9l\xE9ment de l\xE9gende inconnu",
  ariaLabelLegendPageNext: "Page de l\xE9gende suivante",
  ariaLabelLegendPagePrevious: "Page pr\xE9c\xE9dente de la l\xE9gende",
  ariaLabelLegendPagination: "Pagination des l\xE9gendes",
  ariaLabelNavigator: "Navigateur",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Plage",
  ariaLabelRangesToolbar: "Plages",
  ariaLabelSettingsTabBar: "Param\xE8tres",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] \xE0 ${max}[percent0to2dp]",
  contextMenuDownload: "T\xE9l\xE9charger",
  contextMenuPanToCursor: "Panoramique jusqu'ici",
  contextMenuToggleOtherSeries: "Basculer les autres s\xE9ries",
  contextMenuToggleSeriesVisibility: "Basculer la visibilit\xE9",
  contextMenuZoomToCursor: "Zoomer ici",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Date et prix",
  dialogHeaderDateRange: "Plage de dates",
  dialogHeaderFibonacciRange: "Retracement Fib",
  dialogHeaderLine: "Ligne",
  dialogHeaderPriceRange: "Plage de prix",
  dialogHeaderText: "Texte",
  dialogInputAlign: "Alignement",
  dialogInputColorPicker: "Couleur",
  dialogInputColorPickerAltText: "Couleur de texte",
  dialogInputExtendAbove: "\xC9tendre au-dessus",
  dialogInputExtendBelow: "\xC9tendre vers le bas",
  dialogInputExtendChannelEnd: "Prolonger la fin du canal",
  dialogInputExtendChannelStart: "\xC9tendre le d\xE9but du canal",
  dialogInputExtendLeft: "\xC9tendre \xE0 gauche",
  dialogInputExtendLineEnd: "\xC9tendre la fin de la ligne",
  dialogInputExtendLineStart: "\xC9tendre le d\xE9but de la ligne",
  dialogInputExtendRight: "\xC9tendre vers la droite",
  dialogInputFibonacciBands: "Bandes",
  dialogInputFibonacciBandsAltText: "Bandes de Fibonacci",
  dialogInputFillColorPicker: "Remplissage",
  dialogInputFillColorPickerAltText: "Couleur de remplissage",
  dialogInputFontSize: "Taille",
  dialogInputFontSizeAltText: "Taille de police",
  dialogInputLineStyle: "Tiret",
  dialogInputPosition: "Position",
  dialogInputReverse: "Inverser",
  dialogInputShowFill: "Afficher le remplissage",
  dialogInputStrokeWidth: "\xC9paisseur",
  dialogInputStrokeWidthAltText: "\xC9paisseur de la ligne",
  iconAltTextAlignCenter: "Centrer",
  iconAltTextAlignLeft: "Gauche",
  iconAltTextAlignRight: "Droite",
  iconAltTextClose: "Fermer",
  iconAltTextLineStyleDashed: "Longue-tirets",
  iconAltTextLineStyleDotted: "Tirets courts",
  iconAltTextLineStyleSolid: "Solide",
  iconAltTextPositionBottom: "Bas",
  iconAltTextPositionCenter: "Centre",
  iconAltTextPositionTop: "Haut",
  inputTextareaPlaceholder: "Ajouter du texte",
  measurerDateRangeBars: "${value}[number] barres",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Chargement des donn\xE9es...",
  overlayNoData: "Aucune donn\xE9e \xE0 afficher",
  overlayNoVisibleSeries: "Aucune s\xE9rie visible",
  overlayUnsupportedBrowser: "Version de navigateur incompatible. Veuillez mettre \xE0 jour votre navigateur.",
  seriesHistogramTooltipCount: "${yName} (compte)",
  seriesHistogramTooltipFrequency: "Fr\xE9quence",
  seriesHistogramTooltipMean: "${yName} (moyenne)",
  seriesHistogramTooltipSum: "${yName} (somme)",
  toolbarAnnotationsArrow: "Fl\xE8che",
  toolbarAnnotationsArrowDown: "Fl\xE8che Bas",
  toolbarAnnotationsArrowUp: "Fl\xE8che Haut",
  toolbarAnnotationsCallout: "Bulles",
  toolbarAnnotationsClearAll: "Tout Effacer",
  toolbarAnnotationsComment: "Commentaire",
  toolbarAnnotationsDatePriceRange: "Date et prix",
  toolbarAnnotationsDateRange: "Plage de dates",
  toolbarAnnotationsDelete: "Supprimer",
  toolbarAnnotationsDisjointChannel: "Canal disjoint",
  toolbarAnnotationsDragHandle: "Faites glisser la barre d'outils",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retrait Fib",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib tendance bas\xE9e",
  toolbarAnnotationsFillColor: "Couleur de remplissage",
  toolbarAnnotationsHorizontalLine: "Ligne Horizontale",
  toolbarAnnotationsLineAnnotations: "Lignes de tendance",
  toolbarAnnotationsLineColor: "Couleur de la ligne",
  toolbarAnnotationsLineStrokeWidth: "\xC9paisseur du trait de la ligne",
  toolbarAnnotationsLineStyle: "Style de ligne",
  toolbarAnnotationsLock: "Verrouiller",
  toolbarAnnotationsMeasurerAnnotations: '"Mesureurs"',
  toolbarAnnotationsNote: "Note",
  toolbarAnnotationsParallelChannel: "Canal parall\xE8le",
  toolbarAnnotationsPriceRange: "Plage de prix",
  toolbarAnnotationsQuickDatePriceRange: "Mesurer",
  toolbarAnnotationsSettings: "Param\xE8tres",
  toolbarAnnotationsShapeAnnotations: "Fl\xE8ches",
  toolbarAnnotationsText: "Texte",
  toolbarAnnotationsTextAnnotations: "Annotations de texte",
  toolbarAnnotationsTextColor: "Couleur du texte",
  toolbarAnnotationsTextSize: "Taille du texte",
  toolbarAnnotationsTrendLine: "Tendance",
  toolbarAnnotationsUnlock: "D\xE9verrouiller",
  toolbarAnnotationsVerticalLine: "Ligne verticale",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mois",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 an",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mois",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mois",
  toolbarRangeAll: "Tous",
  toolbarRangeAllAria: "Tous",
  toolbarRangeYearToDate: "Depuis le d\xE9but de l'ann\xE9e",
  toolbarRangeYearToDateAria: "Ann\xE9e \xE0 ce jour",
  toolbarSeriesTypeCandles: "Bougies",
  toolbarSeriesTypeDropdown: "Type de graphique",
  toolbarSeriesTypeHighLow: "Haut Bas",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Bougies creuses",
  toolbarSeriesTypeLine: "Ligne",
  toolbarSeriesTypeLineWithMarkers: "Ligne avec Marqueurs",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Ligne en \xE9tapes",
  toolbarZoomPanEnd: "D\xE9placer jusqu'\xE0 la fin",
  toolbarZoomPanLeft: "D\xE9placer vers la gauche",
  toolbarZoomPanRight: "D\xE9placer vers la droite",
  toolbarZoomPanStart: "D\xE9placer au d\xE9but",
  toolbarZoomReset: "R\xE9initialiser le zoom",
  toolbarZoomZoomIn: "Agrandir",
  toolbarZoomZoomOut: "D\xE9zoomer",
  tooltipPaginationStatus: "${index}[number] sur ${count}[number]"
};
var AG_CHARTS_LOCALE_HE_IL = {
  ariaAnnounceChart: "\u05EA\u05E8\u05E9\u05D9\u05DD, ${seriesCount}[number] \u05E1\u05D3\u05E8\u05D5\u05EA",
  ariaAnnounceFlowProportionLink: "\u05E7\u05D9\u05E9\u05D5\u05E8 ${index} \u05DE\u05EA\u05D5\u05DA ${count}, \u05DE-${from} \u05DC-${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u05E6\u05D5\u05DE\u05EA ${index} \u05DE\u05EA\u05D5\u05DA ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u05EA\u05E8\u05E9\u05D9\u05DD \u05DE\u05D3, ${caption}",
  ariaAnnounceHierarchyChart: "\u05EA\u05E8\u05E9\u05D9\u05DD \u05D4\u05D9\u05E8\u05E8\u05DB\u05D9, ${caption}",
  ariaAnnounceHierarchyDatum: "\u05E8\u05DE\u05D4 ${level}[number], ${count}[number] \u05D9\u05DC\u05D3\u05D9\u05DD, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u05DC\u05D7\u05E5 \u05E2\u05DC \u05DE\u05E7\u05E9 \u05D4\u05E8\u05D5\u05D5\u05D7 \u05D0\u05D5 \u05D0\u05E0\u05D8\u05E8 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05D7\u05DC\u05D9\u05E3 \u05D0\u05EA \u05D4\u05E0\u05E8\u05D0\u05D5\u05EA",
  ariaLabelAddHorizontalLine: "\u05D4\u05D5\u05E1\u05E3 \u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
  ariaLabelAnnotationOptionsToolbar: "\u05D0\u05E4\u05E9\u05E8\u05D5\u05D9\u05D5\u05EA \u05D4\u05E2\u05E8\u05D5\u05EA",
  ariaLabelAnnotationSettingsDialog: '"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05D4\u05E2\u05E8\u05D5\u05EA"',
  ariaLabelColorPicker: "\u05D1\u05D5\u05D7\u05E8 \u05E6\u05D1\u05E2\u05D9\u05DD",
  ariaLabelFinancialCharts: "\u05EA\u05E8\u05E9\u05D9\u05DE\u05D9\u05DD \u05E4\u05D9\u05E0\u05E0\u05E1\u05D9\u05D9\u05DD",
  ariaLabelLegend: "\u05DE\u05E7\u05E8\u05D0",
  ariaLabelLegendItem: "${label}, \u05E4\u05E8\u05D9\u05D8 \u05D1\u05D0\u05D2\u05D3\u05D4 ${index}[number] \u05DE\u05EA\u05D5\u05DA ${count}[number]",
  ariaLabelLegendItemUnknown: "\u05E4\u05E8\u05D9\u05D8 \u05DE\u05E7\u05E8\u05D0 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2",
  ariaLabelLegendPageNext: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05DE\u05E7\u05E8\u05D0 \u05D4\u05D1\u05D0",
  ariaLabelLegendPagePrevious: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05DE\u05E7\u05E8\u05D0 \u05D4\u05E7\u05D5\u05D3\u05DD",
  ariaLabelLegendPagination: "\u05E0\u05D5\u05D5\u05D8 \u05D1\u05D3\u05E4\u05D9 \u05D4\u05DE\u05E7\u05E8\u05D0",
  ariaLabelNavigator: "\u05E0\u05D5\u05D5\u05D8",
  ariaLabelNavigatorMaximum: "\u05DE\u05E7\u05E1\u05D9\u05DE\u05D5\u05DD",
  ariaLabelNavigatorMinimum: "\u05DE\u05D9\u05E0\u05D9\u05DE\u05D5\u05DD",
  ariaLabelNavigatorRange: "\u05D8\u05D5\u05D5\u05D7",
  ariaLabelRangesToolbar: "\u05D8\u05D5\u05D5\u05D7\u05D9\u05DD",
  ariaLabelSettingsTabBar: "\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA",
  ariaLabelZoomToolbar: "\u05D6\u05D5\u05DD",
  ariaValuePanRange: "${min}[percent0to2dp] \u05E2\u05D3 ${max}[percent0to2dp]",
  contextMenuDownload: "\u05D4\u05D5\u05E8\u05D3\u05D4",
  contextMenuPanToCursor: "\u05D2\u05DC\u05D5\u05DC \u05DC\u05E4\u05D4",
  contextMenuToggleOtherSeries: "\u05D4\u05D7\u05DC\u05E3 \u05E0\u05E8\u05D0\u05D5\u05EA \u05E9\u05DC \u05E1\u05D3\u05E8\u05D5\u05EA \u05D0\u05D7\u05E8\u05D5\u05EA",
  contextMenuToggleSeriesVisibility: "\u05D4\u05D7\u05DC\u05E3 \u05E0\u05E8\u05D0\u05D5\u05EA",
  contextMenuZoomToCursor: "\u05D4\u05EA\u05E7\u05E8\u05D1 \u05DC\u05DB\u05D0\u05DF",
  dialogHeaderChannel: "\u05E2\u05E8\u05D5\u05E5",
  dialogHeaderDatePriceRange: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05DE\u05D7\u05D9\u05E8",
  dialogHeaderDateRange: " '\u05D8\u05D5\u05D5\u05D7 \u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD'",
  dialogHeaderFibonacciRange: "\u05EA\u05D9\u05E7\u05D5\u05DF \u05E4\u05D9\u05D1",
  dialogHeaderLine: "\u05E7\u05D5",
  dialogHeaderPriceRange: "\u05D8\u05D5\u05D5\u05D7 \u05DE\u05D7\u05D9\u05E8\u05D9\u05DD",
  dialogHeaderText: "\u05D8\u05E7\u05E1\u05D8",
  dialogInputAlign: "\u05D9\u05E9\u05D5\u05E8",
  dialogInputColorPicker: "\u05E6\u05D1\u05E2",
  dialogInputColorPickerAltText: "\u05E6\u05D1\u05E2 \u05D8\u05E7\u05E1\u05D8",
  dialogInputExtendAbove: "\u05DC\u05D4\u05E8\u05D7\u05D9\u05D1 \u05DC\u05DE\u05E2\u05DC\u05D4",
  dialogInputExtendBelow: "\u05D4\u05E8\u05D7\u05D1 \u05DE\u05D8\u05D4",
  dialogInputExtendChannelEnd: "\u05D4\u05D0\u05E8\u05DA \u05E1\u05D5\u05E3 \u05E2\u05E8\u05D5\u05E5",
  dialogInputExtendChannelStart: "\u05D4\u05E8\u05D7\u05D1 \u05EA\u05D7\u05D9\u05DC\u05EA \u05E2\u05E8\u05D5\u05E5",
  dialogInputExtendLeft: "\u05D4\u05E8\u05D7\u05D1 \u05E9\u05DE\u05D0\u05DC\u05D4",
  dialogInputExtendLineEnd: "\u05D4\u05E8\u05D7\u05D1 \u05E7\u05E6\u05D4 \u05E7\u05D5",
  dialogInputExtendLineStart: "\u05D4\u05E8\u05D7\u05D1 \u05D4\u05EA\u05D7\u05DC\u05EA \u05D4\u05E7\u05D5",
  dialogInputExtendRight: "\u05E9\u05DC\u05D7 \u05DC\u05D9\u05DE\u05D9\u05DF",
  dialogInputFibonacciBands: "\u05E8\u05E6\u05D5\u05E2\u05D5\u05EA",
  dialogInputFibonacciBandsAltText: "\u05E8\u05E6\u05D5\u05E2\u05D5\u05EA \u05E4\u05D9\u05D1\u05D5\u05E0\u05D0\u05E6'\u05D9",
  dialogInputFillColorPicker: "\u05DE\u05D9\u05DC\u05D5\u05D9",
  dialogInputFillColorPickerAltText: "\u05E6\u05D1\u05E2 \u05DE\u05D9\u05DC\u05D5\u05D9",
  dialogInputFontSize: "\u05D2\u05D5\u05D3\u05DC",
  dialogInputFontSizeAltText: "\u05D2\u05D5\u05D3\u05DC \u05D2\u05D5\u05E4\u05DF",
  dialogInputLineStyle: "\u05E7\u05D5 \u05DE\u05E7\u05D5\u05D5\u05E7\u05D5",
  dialogInputPosition: "\u05DE\u05D9\u05E7\u05D5\u05DD",
  dialogInputReverse: "\u05D4\u05E4\u05D5\u05DA",
  dialogInputShowFill: "\u05D4\u05E6\u05D2 \u05DE\u05D9\u05DC\u05D5\u05D9",
  dialogInputStrokeWidth: "\u05DE\u05E9\u05E7\u05DC",
  dialogInputStrokeWidthAltText: "\u05DE\u05E9\u05E7\u05DC \u05D4\u05E7\u05D5",
  iconAltTextAlignCenter: "\u05DE\u05E8\u05DB\u05D6",
  iconAltTextAlignLeft: "\u05E9\u05DE\u05D0\u05DC",
  iconAltTextAlignRight: "\u05DE\u05D9\u05D5\u05E9\u05E8 \u05D9\u05DE\u05D9\u05E0\u05D4",
  iconAltTextClose: "\u05E1\u05D2\u05D5\u05E8",
  iconAltTextLineStyleDashed: "\u05D0\u05E8\u05D5\u05DA \u05DE\u05E7\u05D5\u05D5\u05E7\u05D5",
  iconAltTextLineStyleDotted: "\u05DE\u05B0\u05E7\u05D5\u05BC\u05D5\u05B8\u05D5 \u05E7\u05B8\u05E6\u05B8\u05E8",
  iconAltTextLineStyleSolid: "\u05DE\u05D5\u05E6\u05E7",
  iconAltTextPositionBottom: "\u05EA\u05D7\u05EA\u05D5\u05DF",
  iconAltTextPositionCenter: "\u05DE\u05E8\u05DB\u05D6",
  iconAltTextPositionTop: "\u05DC\u05DE\u05E2\u05DC\u05D4",
  inputTextareaPlaceholder: "\u05D4\u05D5\u05E1\u05E3 \u05D8\u05E7\u05E1\u05D8",
  measurerDateRangeBars: "${value}[number] \u05E7\u05D5\u05D5\u05D9\u05DD",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u05E0\u05E4\u05D7 ${value}",
  overlayLoadingData: "\u05D8\u05D5\u05E2\u05DF \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD...",
  overlayNoData: "\u05D0\u05D9\u05DF \u05E0\u05EA\u05D5\u05E0\u05D9\u05DD \u05DC\u05D4\u05E6\u05D2\u05D4",
  overlayNoVisibleSeries: "\u05D0\u05D9\u05DF \u05E1\u05D3\u05E8\u05D5\u05EA \u05DC\u05D4\u05E6\u05D9\u05D2",
  overlayUnsupportedBrowser: "\u05D2\u05E8\u05E1\u05EA \u05D3\u05E4\u05D3\u05E4\u05DF \u05DC\u05D0 \u05EA\u05D5\u05D0\u05DE\u05EA. \u05E0\u05D0 \u05DC\u05E9\u05D3\u05E8\u05D2 \u05D0\u05EA \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA.",
  seriesHistogramTooltipCount: "${yName} (\u05DB\u05DE\u05D5\u05EA)",
  seriesHistogramTooltipFrequency: "\u05EA\u05D3\u05D9\u05E8\u05D5\u05EA",
  seriesHistogramTooltipMean: "${yName} (\u05DE\u05DE\u05D5\u05E6\u05E2)",
  seriesHistogramTooltipSum: "${yName} (\u05E1\u05DB\u05D5\u05DD)",
  toolbarAnnotationsArrow: "\u05D7\u05E5",
  toolbarAnnotationsArrowDown: "\u05D7\u05E5 \u05DC\u05DE\u05D8\u05D4",
  toolbarAnnotationsArrowUp: "\u05D7\u05E5 \u05DC\u05DE\u05E2\u05DC\u05D4",
  toolbarAnnotationsCallout: "\u05D4\u05E2\u05E8\u05D4",
  toolbarAnnotationsClearAll: "\u05E0\u05E7\u05D4 \u05D4\u05DB\u05DC",
  toolbarAnnotationsComment: "\u05EA\u05D2\u05D5\u05D1\u05D4",
  toolbarAnnotationsDatePriceRange: "\u05EA\u05D0\u05E8\u05D9\u05DA \u05D5\u05DE\u05D7\u05D9\u05E8",
  toolbarAnnotationsDateRange: "\u05D8\u05D5\u05D5\u05D7 \u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
  toolbarAnnotationsDelete: "\u05DE\u05D7\u05E7",
  toolbarAnnotationsDisjointChannel: "\u05E2\u05E8\u05D5\u05E5 \u05DE\u05E0\u05D5\u05EA\u05E7",
  toolbarAnnotationsDragHandle: "\u05D2\u05E8\u05D5\u05E8 \u05E1\u05E8\u05D2\u05DC \u05DB\u05DC\u05D9\u05DD",
  toolbarAnnotationsFibonacciAnnotations: "\u05E4\u05D9\u05D1\u05D5\u05E0\u05D0\u05E6'\u05D9",
  toolbarAnnotationsFibonacciRetracement: "\u05EA\u05D9\u05E7\u05D5\u05DF \u05E4\u05D9\u05D1\u05D5\u05E0\u05D0\u05E6'\u05D9",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u05E4\u05D9\u05D1 \u05D8\u05E8\u05E0\u05D3 \u05DE\u05D1\u05D5\u05E1\u05E1",
  toolbarAnnotationsFillColor: "\u05E6\u05D1\u05E2 \u05DE\u05D9\u05DC\u05D5\u05D9",
  toolbarAnnotationsHorizontalLine: "\u05E7\u05D5 \u05D0\u05D5\u05E4\u05E7\u05D9",
  toolbarAnnotationsLineAnnotations: "\u05E7\u05D5\u05D5\u05D9 \u05DE\u05D2\u05DE\u05D4",
  toolbarAnnotationsLineColor: "\u05E6\u05D1\u05E2 \u05D4\u05E7\u05D5",
  toolbarAnnotationsLineStrokeWidth: "\u05E2\u05D5\u05D1\u05D9 \u05E7\u05D5",
  toolbarAnnotationsLineStyle: "\u05E1\u05D2\u05E0\u05D5\u05DF \u05E7\u05D5",
  toolbarAnnotationsLock: "\u05E0\u05E2\u05DC",
  toolbarAnnotationsMeasurerAnnotations: "\u05DE\u05D5\u05D3\u05D3",
  toolbarAnnotationsNote: "\u05D4\u05E2\u05E8\u05D4",
  toolbarAnnotationsParallelChannel: "\u05E2\u05E8\u05D5\u05E5 \u05DE\u05E7\u05D1\u05D9\u05DC\u05D9",
  toolbarAnnotationsPriceRange: "\u05D8\u05D5\u05D5\u05D7 \u05DE\u05D7\u05D9\u05E8\u05D9\u05DD",
  toolbarAnnotationsQuickDatePriceRange: "\u05D4\u05E2\u05E8\u05DB\u05D4",
  toolbarAnnotationsSettings: "\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA",
  toolbarAnnotationsShapeAnnotations: "\u05D7\u05D9\u05E6\u05D9\u05DD",
  toolbarAnnotationsText: "\u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTextAnnotations: "\u05D4\u05E2\u05E8\u05D5\u05EA \u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTextColor: "\u05E6\u05D1\u05E2 \u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTextSize: "\u05D2\u05D5\u05D3\u05DC \u05D8\u05E7\u05E1\u05D8",
  toolbarAnnotationsTrendLine: "\u05E7\u05D5 \u05DE\u05D2\u05DE\u05D4",
  toolbarAnnotationsUnlock: "\u05E9\u05D7\u05E8\u05E8",
  toolbarAnnotationsVerticalLine: "\u05E7\u05D5 \u05D0\u05E0\u05DB\u05D9",
  toolbarRange1Month: "1 \u05D7\u05D5\u05D3\u05E9",
  toolbarRange1MonthAria: "\u05D7\u05D5\u05D3\u05E9 \u05D0\u05D7\u05D3",
  toolbarRange1Year: "\u05E9\u05E0\u05D4 1",
  toolbarRange1YearAria: "\u05E9\u05E0\u05D4 \u05D0\u05D7\u05EA",
  toolbarRange3Months: "3 \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  toolbarRange3MonthsAria: "3 \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  toolbarRange6Months: "6\u05D7",
  toolbarRange6MonthsAria: "6 \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD",
  toolbarRangeAll: "\u05D4\u05DB\u05DC",
  toolbarRangeAllAria: "\u05D4\u05DB\u05DC",
  toolbarRangeYearToDate: "\u05D4\u05E9\u05E0\u05D4",
  toolbarRangeYearToDateAria: "\u05D4\u05E9\u05E0\u05D4",
  toolbarSeriesTypeCandles: "\u05E0\u05E8\u05D5\u05EA",
  toolbarSeriesTypeDropdown: "\u05E1\u05D5\u05D2 \u05EA\u05E8\u05E9\u05D9\u05DD",
  toolbarSeriesTypeHighLow: "\u05D2\u05D1\u05D5\u05D4 \u05E0\u05DE\u05D5\u05DA",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u05E0\u05E8\u05D5\u05EA \u05D7\u05DC\u05D5\u05DC\u05D9\u05DD",
  toolbarSeriesTypeLine: "\u05E7\u05D5",
  toolbarSeriesTypeLineWithMarkers: "\u05E7\u05D5 \u05E2\u05DD \u05E1\u05D9\u05DE\u05D5\u05E0\u05D9\u05DD",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u05E7\u05D5 \u05DE\u05D3\u05E8\u05D2\u05D5\u05EA",
  toolbarZoomPanEnd: "\u05D2\u05DC\u05D5\u05DC \u05DC\u05E1\u05D5\u05E3",
  toolbarZoomPanLeft: "\u05D2\u05DC\u05D5\u05DC \u05E9\u05DE\u05D0\u05DC\u05D4",
  toolbarZoomPanRight: "\u05D2\u05DC\u05D5\u05DC \u05D9\u05DE\u05D9\u05E0\u05D4",
  toolbarZoomPanStart: "\u05D2\u05DC\u05D5\u05DC \u05DC\u05D4\u05EA\u05D7\u05DC\u05D4",
  toolbarZoomReset: "\u05D0\u05E4\u05E1 \u05D6\u05D5\u05DD",
  toolbarZoomZoomIn: "\u05D4\u05EA\u05E7\u05E8\u05D1",
  toolbarZoomZoomOut: "\u05D4\u05EA\u05E8\u05D7\u05E7",
  tooltipPaginationStatus: "${index}[number] \u05DE\u05EA\u05D5\u05DA ${count}[number]"
};
var AG_CHARTS_LOCALE_HR_HR = {
  ariaAnnounceChart: "grafikon, ${seriesCount}[number] serija",
  ariaAnnounceFlowProportionLink: "veza ${index} od ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u010Dvor ${index} od ${count}, ${description}",
  ariaAnnounceGaugeChart: "mjerna ljestvica, ${caption}",
  ariaAnnounceHierarchyChart: "hijerarhijski grafikon, ${caption}",
  ariaAnnounceHierarchyDatum: "razina ${level}[number], ${count}[number] djece, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Pritisnite razmaknicu ili Enter za uklju\u010Divanje/isklju\u010Divanje vidljivosti",
  ariaLabelAddHorizontalLine: "Dodaj vodoravnu liniju",
  ariaLabelAnnotationOptionsToolbar: "Opcije komentara",
  ariaLabelAnnotationSettingsDialog: "Postavke bilje\u0161ki",
  ariaLabelColorPicker: "Bira\u010D boja",
  ariaLabelFinancialCharts: "Financijski grafikoni",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Legenda stavka ${index}[number] od ${count}[number]",
  ariaLabelLegendItemUnknown: "Nepoznata stavka legende",
  ariaLabelLegendPageNext: "Sljede\u0107a stranica legende",
  ariaLabelLegendPagePrevious: "Prethodna stranica legende",
  ariaLabelLegendPagination: "Paginacija legende",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Raspon",
  ariaLabelRangesToolbar: "Rasponi",
  ariaLabelSettingsTabBar: "Postavke",
  ariaLabelZoomToolbar: "Zum",
  ariaValuePanRange: "${min}[percent0to2dp] do ${max}[percent0to2dp]",
  contextMenuDownload: "Preuzmi",
  contextMenuPanToCursor: "Pomakni ovdje",
  contextMenuToggleOtherSeries: "Prebaci ostale serije",
  contextMenuToggleSeriesVisibility: "Prebaci vidljivost",
  contextMenuZoomToCursor: "Pove\u0107aj ovdje",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Datum i cijena",
  dialogHeaderDateRange: "Raspon datuma",
  dialogHeaderFibonacciRange: "Fib Povla\u010Denje",
  dialogHeaderLine: "Linija",
  dialogHeaderPriceRange: "Raspon cijena",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Poravnaj",
  dialogInputColorPicker: "Boja",
  dialogInputColorPickerAltText: "Boja teksta",
  dialogInputExtendAbove: "Pro\u0161iri iznad",
  dialogInputExtendBelow: "Pro\u0161iri ispod",
  dialogInputExtendChannelEnd: "Pro\u0161iri kraj kanala",
  dialogInputExtendChannelStart: "Produ\u017Ei po\u010Detak kanala",
  dialogInputExtendLeft: "Pro\u0161iri lijevo",
  dialogInputExtendLineEnd: "Produ\u017Ei kraj linije",
  dialogInputExtendLineStart: "Produ\u017Ei po\u010Detak linije",
  dialogInputExtendRight: "Pro\u0161iri desno",
  dialogInputFibonacciBands: "Pojasevi",
  dialogInputFibonacciBandsAltText: "Fibonacci Pojasevi",
  dialogInputFillColorPicker: "Ispuna",
  dialogInputFillColorPickerAltText: "Ispuni boju",
  dialogInputFontSize: "Veli\u010Dina",
  dialogInputFontSizeAltText: "Veli\u010Dina fonta",
  dialogInputLineStyle: "Crtkano",
  dialogInputPosition: "Pozicija",
  dialogInputReverse: "Obrnuto",
  dialogInputShowFill: "Prika\u017Ei ispunu",
  dialogInputStrokeWidth: "Debljina",
  dialogInputStrokeWidthAltText: "Debljina crte",
  iconAltTextAlignCenter: "Poravnaj u sredinu",
  iconAltTextAlignLeft: "Lijevo",
  iconAltTextAlignRight: "Desno",
  iconAltTextClose: "Zatvori",
  iconAltTextLineStyleDashed: "Dugih crtica",
  iconAltTextLineStyleDotted: "Kratko-crtkano",
  iconAltTextLineStyleSolid: "Puna",
  iconAltTextPositionBottom: "Dno",
  iconAltTextPositionCenter: "Sredi\u0161te",
  iconAltTextPositionTop: "Vrh",
  inputTextareaPlaceholder: "Dodaj tekst",
  measurerDateRangeBars: "${value}[number] trake",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "U\u010Ditavanje podataka...",
  overlayNoData: "Nema dostupnih podataka za prikaz",
  overlayNoVisibleSeries: "Nema vidljivih serija",
  overlayUnsupportedBrowser: "Nekompatibilna verzija preglednika. Molimo a\u017Eurirajte svoj preglednik.",
  seriesHistogramTooltipCount: "${yName} (broj)",
  seriesHistogramTooltipFrequency: "Frekvencija",
  seriesHistogramTooltipMean: "${yName} (prosjek)",
  seriesHistogramTooltipSum: "${yName} (zbroj)",
  toolbarAnnotationsArrow: "Strelica",
  toolbarAnnotationsArrowDown: "Strelica dolje",
  toolbarAnnotationsArrowUp: "Strelica gore",
  toolbarAnnotationsCallout: "Poziv",
  toolbarAnnotationsClearAll: "O\u010Disti sve",
  toolbarAnnotationsComment: "Komentar",
  toolbarAnnotationsDatePriceRange: "Datum i cijena",
  toolbarAnnotationsDateRange: "Raspon datuma",
  toolbarAnnotationsDelete: "Izbri\u0161i",
  toolbarAnnotationsDisjointChannel: "Diskretni kanal",
  toolbarAnnotationsDragHandle: "Povuci alatnu traku",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Povla\u010Denje",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib temeljen na trendu",
  toolbarAnnotationsFillColor: "Boja ispune",
  toolbarAnnotationsHorizontalLine: "Horizontalna linija",
  toolbarAnnotationsLineAnnotations: "Linije trendova",
  toolbarAnnotationsLineColor: "Boja linije",
  toolbarAnnotationsLineStrokeWidth: "\u0160irina crte poteza",
  toolbarAnnotationsLineStyle: "Stil crte",
  toolbarAnnotationsLock: "Zaklju\u010Daj",
  toolbarAnnotationsMeasurerAnnotations: "Mjerne jedinice",
  toolbarAnnotationsNote: "Bilje\u0161ka",
  toolbarAnnotationsParallelChannel: "Paralelni kanal",
  toolbarAnnotationsPriceRange: "Raspon cijena",
  toolbarAnnotationsQuickDatePriceRange: "Mjera",
  toolbarAnnotationsSettings: "Postavke",
  toolbarAnnotationsShapeAnnotations: "Strelice",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstualne Anotacije",
  toolbarAnnotationsTextColor: "Boja teksta",
  toolbarAnnotationsTextSize: "Veli\u010Dina teksta",
  toolbarAnnotationsTrendLine: "Trend linija",
  toolbarAnnotationsUnlock: "Otklju\u010Daj",
  toolbarAnnotationsVerticalLine: "Vertikalna linija",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mjesec",
  toolbarRange1Year: "1G",
  toolbarRange1YearAria: "1 godina",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mjeseca",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mjeseci",
  toolbarRangeAll: "Sve",
  toolbarRangeAllAria: "Sve",
  toolbarRangeYearToDate: "Godina do danas",
  toolbarRangeYearToDateAria: "Godina do danas",
  toolbarSeriesTypeCandles: "Svije\u0107e",
  toolbarSeriesTypeDropdown: "Vrsta grafikona",
  toolbarSeriesTypeHighLow: "Visoko Nisko",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u0160uplje Svije\u0107e",
  toolbarSeriesTypeLine: "Linija",
  toolbarSeriesTypeLineWithMarkers: "Linija s oznakama",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Korak Linija",
  toolbarZoomPanEnd: "Pomicanje na kraj",
  toolbarZoomPanLeft: "Pomi\u010Dite lijevo",
  toolbarZoomPanRight: "Pomakni desno",
  toolbarZoomPanStart: "Pomakni na po\u010Detak",
  toolbarZoomReset: "Resetiraj pove\u0107anje",
  toolbarZoomZoomIn: "Pove\u0107aj",
  toolbarZoomZoomOut: "Umanji",
  tooltipPaginationStatus: "${index}[number] od ${count}[number]"
};
var AG_CHARTS_LOCALE_HU_HU = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] sorozat",
  ariaAnnounceFlowProportionLink: "hivatkoz\xE1s ${index} a(z) ${count} k\xF6z\xFCl, ${from}-t\xF3l ${to}-ig, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "${count} k\xF6z\xFCl ${index} csom\xF3pont, ${description}",
  ariaAnnounceGaugeChart: "m\xE9r\u0151m\u0171szer diagram, ${caption}",
  ariaAnnounceHierarchyChart: "hierarchia diagram, ${caption}",
  ariaAnnounceHierarchyDatum: "szint ${level}[number], ${count}[number] gyermek, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Nyomja meg a Sz\xF3k\xF6zt vagy az Entert a l\xE1that\xF3s\xE1g v\xE1lt\xE1s\xE1hoz",
  ariaLabelAddHorizontalLine: "V\xEDzszintes vonal hozz\xE1ad\xE1sa",
  ariaLabelAnnotationOptionsToolbar: "Jel\xF6l\xE9si lehet\u0151s\xE9gek",
  ariaLabelAnnotationSettingsDialog: "Jel\xF6l\xE9s be\xE1ll\xEDt\xE1sai",
  ariaLabelColorPicker: "Sz\xEDnv\xE1laszt\xF3",
  ariaLabelFinancialCharts: "P\xE9nz\xFCgyi diagramok",
  ariaLabelLegend: "Jelmagyar\xE1zat",
  ariaLabelLegendItem: "${label}, Jelmagyar\xE1zat eleme ${index}-b\u0151l [number] ${count}-b\u0151l [number]",
  ariaLabelLegendItemUnknown: "Ismeretlen jelmagyar\xE1zati elem",
  ariaLabelLegendPageNext: "K\xF6vetkez\u0151 jelmagyar\xE1zat oldal",
  ariaLabelLegendPagePrevious: "El\u0151z\u0151 jelmagyar\xE1zat oldal",
  ariaLabelLegendPagination: "Jelmagyar\xE1zat Lapoz\xE1s",
  ariaLabelNavigator: "Navig\xE1tor",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Tartom\xE1ny",
  ariaLabelRangesToolbar: "Tartom\xE1nyok",
  ariaLabelSettingsTabBar: "Be\xE1ll\xEDt\xE1sok",
  ariaLabelZoomToolbar: "Nagy\xEDt\xE1s",
  ariaValuePanRange: "${min}[percent0to2dp] \xE9s ${max}[percent0to2dp] k\xF6z\xF6tt",
  contextMenuDownload: "Let\xF6lt\xE9s",
  contextMenuPanToCursor: "P\xE1szt\xE1z\xE1s ide",
  contextMenuToggleOtherSeries: "Tov\xE1bbi sorozatok megjelen\xEDt\xE9se/elrejt\xE9se",
  contextMenuToggleSeriesVisibility: "L\xE1that\xF3s\xE1g v\xE1lt\xE1sa",
  contextMenuZoomToCursor: "Nagy\xEDt\xE1s ide",
  dialogHeaderChannel: "Csatorna",
  dialogHeaderDatePriceRange: "D\xE1tum \xE9s \xE1r",
  dialogHeaderDateRange: "D\xE1tum tartom\xE1ny",
  dialogHeaderFibonacciRange: "Fibonacci visszah\xFAz\xF3d\xE1s",
  dialogHeaderLine: "Vonal",
  dialogHeaderPriceRange: "\xC1rtartom\xE1ny",
  dialogHeaderText: "Sz\xF6veg",
  dialogInputAlign: "Igaz\xEDt\xE1s",
  dialogInputColorPicker: "Sz\xEDn",
  dialogInputColorPickerAltText: "Sz\xF6vegsz\xEDn",
  dialogInputExtendAbove: "Kiterjeszt\xE9s f\xF6l\xE9",
  dialogInputExtendBelow: "Kiterjeszt\xE9s al\xE1",
  dialogInputExtendChannelEnd: "Csatorna v\xE9g\xE9nek kiterjeszt\xE9se",
  dialogInputExtendChannelStart: "Csatornakezd\xE9s kiterjeszt\xE9se",
  dialogInputExtendLeft: "Balra kiterjeszt\xE9s",
  dialogInputExtendLineEnd: "Vonalv\xE9g meghosszabb\xEDt\xE1sa",
  dialogInputExtendLineStart: "Vonal kezd\xE9s\xE9nek kiterjeszt\xE9se",
  dialogInputExtendRight: "Ny\xFAjt\xE1s jobbra",
  dialogInputFibonacciBands: "S\xE1vok",
  dialogInputFibonacciBandsAltText: "Fibonacci s\xE1vok",
  dialogInputFillColorPicker: "Kit\xF6lt\xE9s",
  dialogInputFillColorPickerAltText: "Kit\xF6lt\xE9si sz\xEDn",
  dialogInputFontSize: "M\xE9ret",
  dialogInputFontSizeAltText: "Bet\u0171m\xE9ret",
  dialogInputLineStyle: "Szaggatott",
  dialogInputPosition: "Poz\xEDci\xF3",
  dialogInputReverse: "Ford\xEDtott",
  dialogInputShowFill: "Kit\xF6lt\xE9s megjelen\xEDt\xE9se",
  dialogInputStrokeWidth: "S\xFAly",
  dialogInputStrokeWidthAltText: "Vonal s\xFAly",
  iconAltTextAlignCenter: "K\xF6z\xE9pre",
  iconAltTextAlignLeft: "Balra",
  iconAltTextAlignRight: "Jobbra",
  iconAltTextClose: "Bez\xE1r\xE1s",
  iconAltTextLineStyleDashed: "Hossz\xFA szaggatott",
  iconAltTextLineStyleDotted: "R\xF6vid szaggatott",
  iconAltTextLineStyleSolid: "Folyamatos",
  iconAltTextPositionBottom: "Als\xF3",
  iconAltTextPositionCenter: "K\xF6z\xE9pre",
  iconAltTextPositionTop: "Fel\xFCl",
  inputTextareaPlaceholder: "Adjon hozz\xE1 sz\xF6veget",
  measurerDateRangeBars: "${value}[number] oszlopok",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "T\xE9rfogat ${value}",
  overlayLoadingData: "Adatok bet\xF6lt\xE9se...",
  overlayNoData: "Nincs megjelen\xEDthet\u0151 adat",
  overlayNoVisibleSeries: "Nincs l\xE1that\xF3 sorozat",
  overlayUnsupportedBrowser: "Nem kompatibilis b\xF6ng\xE9sz\u0151verzi\xF3. K\xE9rj\xFCk, friss\xEDtse b\xF6ng\xE9sz\u0151j\xE9t.",
  seriesHistogramTooltipCount: "${yName} (darab)",
  seriesHistogramTooltipFrequency: "Gyakoris\xE1g",
  seriesHistogramTooltipMean: "${yName} (\xE1tlag)",
  seriesHistogramTooltipSum: "${yName} (\xF6sszeg)",
  toolbarAnnotationsArrow: "Ny\xEDl",
  toolbarAnnotationsArrowDown: "Ny\xEDl lefel\xE9",
  toolbarAnnotationsArrowUp: "Fel ny\xEDl",
  toolbarAnnotationsCallout: "Kih\xEDv\xE1s",
  toolbarAnnotationsClearAll: "\xD6sszes t\xF6rl\xE9se",
  toolbarAnnotationsComment: "Megjegyz\xE9s",
  toolbarAnnotationsDatePriceRange: "D\xE1tum \xE9s \xC1r",
  toolbarAnnotationsDateRange: "D\xE1tumtartom\xE1ny",
  toolbarAnnotationsDelete: "T\xF6rl\xE9s",
  toolbarAnnotationsDisjointChannel: "Sz\xE9ttart\xF3 Csatorna",
  toolbarAnnotationsDragHandle: "Eszk\xF6zt\xE1r h\xFAz\xE1sa",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fibo visszah\xFAz\xF3d\xE1s",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Trend alap\xFA Fibonacci",
  toolbarAnnotationsFillColor: "Kit\xF6lt\xE9si Sz\xEDn",
  toolbarAnnotationsHorizontalLine: "V\xEDzszintes vonal",
  toolbarAnnotationsLineAnnotations: "Trendvonalak",
  toolbarAnnotationsLineColor: "Vonal sz\xEDne",
  toolbarAnnotationsLineStrokeWidth: "Vonal vastags\xE1ga",
  toolbarAnnotationsLineStyle: "Vonalst\xEDlus",
  toolbarAnnotationsLock: "Z\xE1rol\xE1s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE9r\u0151k",
  toolbarAnnotationsNote: "Megjegyz\xE9s",
  toolbarAnnotationsParallelChannel: "P\xE1rhuzamos csatorna",
  toolbarAnnotationsPriceRange: "\xC1rtartom\xE1ny",
  toolbarAnnotationsQuickDatePriceRange: "M\xE9rt\xE9k",
  toolbarAnnotationsSettings: "Be\xE1ll\xEDt\xE1sok",
  toolbarAnnotationsShapeAnnotations: "Nyilak",
  toolbarAnnotationsText: "Sz\xF6veg",
  toolbarAnnotationsTextAnnotations: "Sz\xF6veges annot\xE1ci\xF3k",
  toolbarAnnotationsTextColor: "Sz\xF6veg sz\xEDne",
  toolbarAnnotationsTextSize: "Sz\xF6veg M\xE9ret",
  toolbarAnnotationsTrendLine: "Trendvonal",
  toolbarAnnotationsUnlock: "Felold\xE1s",
  toolbarAnnotationsVerticalLine: "F\xFCgg\u0151leges vonal",
  toolbarRange1Month: "1H",
  toolbarRange1MonthAria: "1 h\xF3nap",
  toolbarRange1Year: "1 \xC9v",
  toolbarRange1YearAria: "1 \xE9v",
  toolbarRange3Months: "3H",
  toolbarRange3MonthsAria: "3 h\xF3nap",
  toolbarRange6Months: "6 h\xF3",
  toolbarRange6MonthsAria: "6 h\xF3nap",
  toolbarRangeAll: "\xD6sszes",
  toolbarRangeAllAria: "\xD6sszes",
  toolbarRangeYearToDate: "\xC9v elej\xE9t\u0151l",
  toolbarRangeYearToDateAria: "\xC9v elej\xE9t\u0151l",
  toolbarSeriesTypeCandles: "Gyerty\xE1k",
  toolbarSeriesTypeDropdown: "Diagramt\xEDpus",
  toolbarSeriesTypeHighLow: "Magas Alacsony",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\xDCreges gyerty\xE1k",
  toolbarSeriesTypeLine: "Vonal",
  toolbarSeriesTypeLineWithMarkers: "Vonal jel\xF6l\u0151kkel",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "L\xE9pcs\u0151s vonal",
  toolbarZoomPanEnd: "G\xF6rget\xE9s a v\xE9g\xE9re",
  toolbarZoomPanLeft: "Balra mozgat\xE1s",
  toolbarZoomPanRight: "Jobbra g\xF6rd\xEDt\xE9s",
  toolbarZoomPanStart: "Lapoz\xE1s az elej\xE9re",
  toolbarZoomReset: "Nagy\xEDt\xE1s vissza\xE1ll\xEDt\xE1sa",
  toolbarZoomZoomIn: "Nagy\xEDt\xE1s",
  toolbarZoomZoomOut: "Kicsiny\xEDt\xE9s",
  tooltipPaginationStatus: "${index}[number] a(z) ${count}[number]"
};
var AG_CHARTS_LOCALE_IT_IT = {
  ariaAnnounceChart: "grafico, ${seriesCount}[number] serie",
  ariaAnnounceFlowProportionLink: "collegamento ${index} di ${count}, da ${from} a ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nodo ${index} di ${count}, ${description}",
  ariaAnnounceGaugeChart: "grafico a tachimetro, ${caption}",
  ariaAnnounceHierarchyChart: "grafico gerarchico, ${caption}",
  ariaAnnounceHierarchyDatum: "livello ${level}[number], ${count}[number] figli, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Premi Spazio o Invio per attivare/disattivare la visibilit\xE0",
  ariaLabelAddHorizontalLine: "Aggiungi linea orizzontale",
  ariaLabelAnnotationOptionsToolbar: "Opzioni di annotazione",
  ariaLabelAnnotationSettingsDialog: "Impostazioni Annotazioni",
  ariaLabelColorPicker: "Selettore colore",
  ariaLabelFinancialCharts: "Grafici finanziari",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Elemento della leggenda ${index}[number] di ${count}[number]",
  ariaLabelLegendItemUnknown: "Elemento della legenda sconosciuto",
  ariaLabelLegendPageNext: "Prossima pagina della legenda",
  ariaLabelLegendPagePrevious: "Pagina precedente della legenda",
  ariaLabelLegendPagination: "Paginazione della leggenda",
  ariaLabelNavigator: "Navigatore",
  ariaLabelNavigatorMaximum: "Massimo",
  ariaLabelNavigatorMinimum: "Minimo",
  ariaLabelNavigatorRange: "Intervallo",
  ariaLabelRangesToolbar: "Intervalli",
  ariaLabelSettingsTabBar: "Impostazioni",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Scarica",
  contextMenuPanToCursor: "Sposta qui",
  contextMenuToggleOtherSeries: "Attiva/Disattiva altre serie",
  contextMenuToggleSeriesVisibility: "Attiva/Disattiva Visibilit\xE0",
  contextMenuZoomToCursor: "Zoom qui",
  dialogHeaderChannel: "Canale",
  dialogHeaderDatePriceRange: "Data e Prezzo",
  dialogHeaderDateRange: "Intervallo di date",
  dialogHeaderFibonacciRange: "Ritracciamento di Fibonacci",
  dialogHeaderLine: "Linea",
  dialogHeaderPriceRange: "Intervallo di Prezzo",
  dialogHeaderText: "Testo",
  dialogInputAlign: "Allinea",
  dialogInputColorPicker: "Colore",
  dialogInputColorPickerAltText: "Colore del testo",
  dialogInputExtendAbove: "Estendi sopra",
  dialogInputExtendBelow: "Estendi sotto",
  dialogInputExtendChannelEnd: "Estendi estremit\xE0 del canale",
  dialogInputExtendChannelStart: "Estendi l'inizio del canale",
  dialogInputExtendLeft: "Estendi a sinistra",
  dialogInputExtendLineEnd: "Estendi estremit\xE0 di linea",
  dialogInputExtendLineStart: "Estendi inizio linea",
  dialogInputExtendRight: "Estendi a destra",
  dialogInputFibonacciBands: "Bande",
  dialogInputFibonacciBandsAltText: "Bande di Fibonacci",
  dialogInputFillColorPicker: "Riempimento",
  dialogInputFillColorPickerAltText: "Colore di riempimento",
  dialogInputFontSize: "Dimensione",
  dialogInputFontSizeAltText: "Dimensione del carattere",
  dialogInputLineStyle: "Tratteggiato",
  dialogInputPosition: "Posizione",
  dialogInputReverse: "Inverti",
  dialogInputShowFill: "Mostra riempimento",
  dialogInputStrokeWidth: "Peso",
  dialogInputStrokeWidthAltText: "Peso della Linea",
  iconAltTextAlignCenter: "Centro",
  iconAltTextAlignLeft: "Sinistra",
  iconAltTextAlignRight: "Destra",
  iconAltTextClose: "Chiudi",
  iconAltTextLineStyleDashed: "Linee tratteggiate lunghe",
  iconAltTextLineStyleDotted: "Tratteggiato corto",
  iconAltTextLineStyleSolid: "Solido",
  iconAltTextPositionBottom: "In basso",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "In alto",
  inputTextareaPlaceholder: "Aggiungi testo",
  measurerDateRangeBars: "${value}[number] barre",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volume ${value}",
  overlayLoadingData: "Caricamento dati...",
  overlayNoData: "Nessun dato da visualizzare",
  overlayNoVisibleSeries: "Nessuna serie visibile",
  overlayUnsupportedBrowser: "Versione del browser non compatibile. Si prega di aggiornare il browser.",
  seriesHistogramTooltipCount: "${yName} (conteggio)",
  seriesHistogramTooltipFrequency: "Frequenza",
  seriesHistogramTooltipMean: "${yName} (media)",
  seriesHistogramTooltipSum: "${yName} (somma)",
  toolbarAnnotationsArrow: "Freccia",
  toolbarAnnotationsArrowDown: "Freccia Gi\xF9",
  toolbarAnnotationsArrowUp: "Freccia Su",
  toolbarAnnotationsCallout: "Annotazione",
  toolbarAnnotationsClearAll: "Cancella Tutto",
  toolbarAnnotationsComment: "Commento",
  toolbarAnnotationsDatePriceRange: "Data e Prezzo",
  toolbarAnnotationsDateRange: "Intervallo di date",
  toolbarAnnotationsDelete: "Elimina",
  toolbarAnnotationsDisjointChannel: "Canale Disgiunto",
  toolbarAnnotationsDragHandle: "Trascina la Barra degli Strumenti",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Ritracciamento di Fibonacci",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Basato su Tendenza",
  toolbarAnnotationsFillColor: "Colore di Riempimento",
  toolbarAnnotationsHorizontalLine: "Linea Orizzontale",
  toolbarAnnotationsLineAnnotations: "Linee di tendenza",
  toolbarAnnotationsLineColor: "Colore della linea",
  toolbarAnnotationsLineStrokeWidth: "Spessore tratto linea",
  toolbarAnnotationsLineStyle: "Stile della linea",
  toolbarAnnotationsLock: "Blocca",
  toolbarAnnotationsMeasurerAnnotations: "Misuratori",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canale parallelo",
  toolbarAnnotationsPriceRange: "Intervallo di Prezzo",
  toolbarAnnotationsQuickDatePriceRange: "Misura",
  toolbarAnnotationsSettings: "Impostazioni",
  toolbarAnnotationsShapeAnnotations: "Frecce",
  toolbarAnnotationsText: "Testo",
  toolbarAnnotationsTextAnnotations: "Annotazioni di testo",
  toolbarAnnotationsTextColor: "Colore del testo",
  toolbarAnnotationsTextSize: "Dimensione del testo",
  toolbarAnnotationsTrendLine: "Linea di tendenza",
  toolbarAnnotationsUnlock: "Sblocca",
  toolbarAnnotationsVerticalLine: "Linea Verticale",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mese",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 anno",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mesi",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mesi",
  toolbarRangeAll: "Tutti",
  toolbarRangeAllAria: "Tutto",
  toolbarRangeYearToDate: "Da Inizio Anno",
  toolbarRangeYearToDateAria: "Anno fino ad oggi",
  toolbarSeriesTypeCandles: "Candele",
  toolbarSeriesTypeDropdown: "Tipo di grafico",
  toolbarSeriesTypeHighLow: "Massimo Minimo",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Candele Vuote",
  toolbarSeriesTypeLine: "Linea",
  toolbarSeriesTypeLineWithMarkers: "Linea con Marcatori",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linea a Passi",
  toolbarZoomPanEnd: "Dalla fine",
  toolbarZoomPanLeft: "Sposta a sinistra",
  toolbarZoomPanRight: "Sposta a destra",
  toolbarZoomPanStart: "Panoramica all'inizio",
  toolbarZoomReset: "Reimposta lo zoom",
  toolbarZoomZoomIn: "Ingrandisci",
  toolbarZoomZoomOut: "Riduci lo zoom",
  tooltipPaginationStatus: "${index}[number] di ${count}[number]"
};
var AG_CHARTS_LOCALE_JA_JP = {
  ariaAnnounceChart: "\u30C1\u30E3\u30FC\u30C8, ${seriesCount}[number]\u30B7\u30EA\u30FC\u30BA",
  ariaAnnounceFlowProportionLink: "\u30EA\u30F3\u30AF ${index} / ${count}\u3001${from} \u304B\u3089 ${to} \u3078\u3001${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u30CE\u30FC\u30C9 ${index} / ${count}\u3001${description}",
  ariaAnnounceGaugeChart: "\u30B2\u30FC\u30B8\u30C1\u30E3\u30FC\u30C8\u3001${caption}",
  ariaAnnounceHierarchyChart: "\u968E\u5C64\u30C1\u30E3\u30FC\u30C8, ${caption}",
  ariaAnnounceHierarchyDatum: "\u30EC\u30D9\u30EB ${level}[number]\u3001${count}[number] \u306E\u5B50\u4F9B\u3001${description}",
  ariaAnnounceHoverDatum: "${datum}\u306B\u30D5\u30A9\u30FC\u30AB\u30B9\u3057\u3066\u3044\u307E\u3059",
  ariaDescriptionLegendItem: "Space \u30AD\u30FC\u307E\u305F\u306F Enter \u30AD\u30FC\u3092\u62BC\u3057\u3066\u8868\u793A\u3092\u5207\u308A\u66FF\u3048\u307E\u3059",
  ariaLabelAddHorizontalLine: "\u6C34\u5E73\u7DDA\u3092\u8FFD\u52A0",
  ariaLabelAnnotationOptionsToolbar: "\u6CE8\u91C8\u30AA\u30D7\u30B7\u30E7\u30F3",
  ariaLabelAnnotationSettingsDialog: "\u6CE8\u91C8\u8A2D\u5B9A",
  ariaLabelColorPicker: "\u30AB\u30E9\u30FC\u30D4\u30C3\u30AB\u30FC",
  ariaLabelFinancialCharts: "\u30D5\u30A1\u30A4\u30CA\u30F3\u30B7\u30E3\u30EB\u30C1\u30E3\u30FC\u30C8",
  ariaLabelLegend: "\u51E1\u4F8B",
  ariaLabelLegendItem: "${label}, \u51E1\u4F8B\u30A2\u30A4\u30C6\u30E0 ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\u4E0D\u660E\u306A\u51E1\u4F8B\u9805\u76EE",
  ariaLabelLegendPageNext: "\u6B21\u306E\u51E1\u4F8B\u30DA\u30FC\u30B8",
  ariaLabelLegendPagePrevious: "\u524D\u306E\u51E1\u4F8B\u30DA\u30FC\u30B8",
  ariaLabelLegendPagination: "\u51E1\u4F8B\u30DA\u30FC\u30B8\u30CD\u30FC\u30B7\u30E7\u30F3",
  ariaLabelNavigator: "\u30CA\u30D3\u30B2\u30FC\u30BF\u30FC",
  ariaLabelNavigatorMaximum: "\u6700\u5927",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F",
  ariaLabelNavigatorRange: "\u7BC4\u56F2",
  ariaLabelRangesToolbar: "\u7BC4\u56F2",
  ariaLabelSettingsTabBar: "\u8A2D\u5B9A",
  ariaLabelZoomToolbar: "\u30BA\u30FC\u30E0",
  ariaValuePanRange: "${min}[percent0to2dp] \u304B\u3089 ${max}[percent0to2dp]",
  contextMenuDownload: "\u30C0\u30A6\u30F3\u30ED\u30FC\u30C9",
  contextMenuPanToCursor: "\u3053\u3053\u306B\u30D1\u30F3\u3059\u308B",
  contextMenuToggleOtherSeries: "\u4ED6\u306E\u30B7\u30EA\u30FC\u30BA\u3092\u5207\u308A\u66FF\u3048\u308B",
  contextMenuToggleSeriesVisibility: "\u8868\u793A\u3092\u5207\u308A\u66FF\u3048\u308B",
  contextMenuZoomToCursor: "\u3053\u3053\u306B\u30BA\u30FC\u30E0",
  dialogHeaderChannel: "\u30C1\u30E3\u30F3\u30CD\u30EB",
  dialogHeaderDatePriceRange: "\u65E5\u4ED8\u3068\u4FA1\u683C",
  dialogHeaderDateRange: "\u65E5\u4ED8\u7BC4\u56F2",
  dialogHeaderFibonacciRange: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30EA\u30C8\u30EC\u30FC\u30B9\u30E1\u30F3\u30C8",
  dialogHeaderLine: "\u30E9\u30A4\u30F3",
  dialogHeaderPriceRange: "\u4FA1\u683C\u7BC4\u56F2",
  dialogHeaderText: "\u30C6\u30AD\u30B9\u30C8",
  dialogInputAlign: "\u6574\u5217",
  dialogInputColorPicker: "\u8272",
  dialogInputColorPickerAltText: "\u30C6\u30AD\u30B9\u30C8\u306E\u8272",
  dialogInputExtendAbove: "\u4E0A\u306B\u62E1\u5F35\u3059\u308B",
  dialogInputExtendBelow: "\u4EE5\u4E0B\u306B\u62E1\u5F35",
  dialogInputExtendChannelEnd: "\u30C1\u30E3\u30CD\u30EB\u306E\u7D42\u308F\u308A\u3092\u62E1\u5F35\u3059\u308B",
  dialogInputExtendChannelStart: "\u30C1\u30E3\u30CD\u30EB\u306E\u958B\u59CB\u3092\u5EF6\u9577\u3059\u308B",
  dialogInputExtendLeft: "\u300C\u5DE6\u306B\u4F38\u3070\u3059\u300D",
  dialogInputExtendLineEnd: "\u30E9\u30A4\u30F3\u7D42\u7AEF\u3092\u62E1\u5F35\u3059\u308B",
  dialogInputExtendLineStart: "\u7DDA\u306E\u958B\u59CB\u3092\u5EF6\u9577\u3059\u308B",
  dialogInputExtendRight: "\u53F3\u3078\u62E1\u5F35",
  dialogInputFibonacciBands: "\u30D0\u30F3\u30C9",
  dialogInputFibonacciBandsAltText: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30D0\u30F3\u30C9",
  dialogInputFillColorPicker: "\u5857\u308A\u3064\u3076\u3057",
  dialogInputFillColorPickerAltText: "\u5857\u308A\u3064\u3076\u3057\u306E\u8272",
  dialogInputFontSize: "\u30B5\u30A4\u30BA",
  dialogInputFontSizeAltText: "\u30D5\u30A9\u30F3\u30C8\u30B5\u30A4\u30BA",
  dialogInputLineStyle: "\u30C0\u30C3\u30B7\u30E5",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u8EE2",
  dialogInputShowFill: "\u5857\u308A\u3064\u3076\u3057\u3092\u8868\u793A",
  dialogInputStrokeWidth: "\u592A\u3055",
  dialogInputStrokeWidthAltText: "\u7DDA\u306E\u592A\u3055",
  iconAltTextAlignCenter: "\u4E2D\u592E\u63C3\u3048",
  iconAltTextAlignLeft: "\u5DE6",
  iconAltTextAlignRight: "\u53F3",
  iconAltTextClose: "\u9589\u3058\u308B",
  iconAltTextLineStyleDashed: "\u9577\u3044\u7834\u7DDA",
  iconAltTextLineStyleDotted: "\u77ED\u3044\u7834\u7DDA",
  iconAltTextLineStyleSolid: "\u5B9F\u7DDA",
  iconAltTextPositionBottom: "\u4E0B",
  iconAltTextPositionCenter: "\u4E2D\u592E",
  iconAltTextPositionTop: "\u300C\u30C8\u30C3\u30D7\u300D",
  inputTextareaPlaceholder: "\u30C6\u30AD\u30B9\u30C8\u3092\u8FFD\u52A0",
  measurerDateRangeBars: "${value}[number] \u672C\u306E\u30D0\u30FC",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "\u300E${value}[number]\u300F",
  measurerVolume: "\u30DC\u30EA\u30E5\u30FC\u30E0 ${value}",
  overlayLoadingData: "\u30C7\u30FC\u30BF\u3092\u8AAD\u307F\u8FBC\u307F\u4E2D...",
  overlayNoData: "\u8868\u793A\u3059\u308B\u30C7\u30FC\u30BF\u304C\u3042\u308A\u307E\u305B\u3093",
  overlayNoVisibleSeries: "\u8868\u793A\u53EF\u80FD\u306A\u30B7\u30EA\u30FC\u30BA\u304C\u3042\u308A\u307E\u305B\u3093",
  overlayUnsupportedBrowser: "\u4E92\u63DB\u6027\u306E\u306A\u3044\u30D6\u30E9\u30A6\u30B6\u30FC\u306E\u30D0\u30FC\u30B8\u30E7\u30F3\u3067\u3059\u3002\u30D6\u30E9\u30A6\u30B6\u30FC\u3092\u30A2\u30C3\u30D7\u30B0\u30EC\u30FC\u30C9\u3057\u3066\u304F\u3060\u3055\u3044\u3002",
  seriesHistogramTooltipCount: "${yName} (\u30AB\u30A6\u30F3\u30C8)",
  seriesHistogramTooltipFrequency: "\u983B\u5EA6",
  seriesHistogramTooltipMean: "${yName} (\u5E73\u5747)",
  seriesHistogramTooltipSum: "${yName} (\u5408\u8A08)",
  toolbarAnnotationsArrow: "\u77E2\u5370",
  toolbarAnnotationsArrowDown: "\u4E0B\u5411\u304D\u306E\u77E2\u5370",
  toolbarAnnotationsArrowUp: "\u77E2\u5370\u4E0A",
  toolbarAnnotationsCallout: "\u56F3\u5F62\u6CE8\u91C8",
  toolbarAnnotationsClearAll: "\u3059\u3079\u3066\u30AF\u30EA\u30A2",
  toolbarAnnotationsComment: "\u30B3\u30E1\u30F3\u30C8",
  toolbarAnnotationsDatePriceRange: "\u300C\u65E5\u4ED8\u3068\u4FA1\u683C\u300D",
  toolbarAnnotationsDateRange: "\u65E5\u4ED8\u7BC4\u56F2",
  toolbarAnnotationsDelete: "\u524A\u9664",
  toolbarAnnotationsDisjointChannel: "\u975E\u9023\u7D50\u30C1\u30E3\u30CD\u30EB",
  toolbarAnnotationsDragHandle: "\u30C4\u30FC\u30EB\u30D0\u30FC\u3092\u30C9\u30E9\u30C3\u30B0",
  toolbarAnnotationsFibonacciAnnotations: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1",
  toolbarAnnotationsFibonacciRetracement: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30FB\u30EA\u30C8\u30EC\u30FC\u30B9\u30E1\u30F3\u30C8",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u30D5\u30A3\u30DC\u30CA\u30C3\u30C1\u30C8\u30EC\u30F3\u30C9\u30D9\u30FC\u30B9",
  toolbarAnnotationsFillColor: "\u5857\u308A\u3064\u3076\u3057\u306E\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7DDA",
  toolbarAnnotationsLineAnnotations: "\u30C8\u30EC\u30F3\u30C9\u30E9\u30A4\u30F3",
  toolbarAnnotationsLineColor: "\u7DDA\u306E\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7DDA\u306E\u592A\u3055",
  toolbarAnnotationsLineStyle: "\u7DDA\u30B9\u30BF\u30A4\u30EB",
  toolbarAnnotationsLock: "\u30ED\u30C3\u30AF",
  toolbarAnnotationsMeasurerAnnotations: "\u6E2C\u5B9A\u30C4\u30FC\u30EB",
  toolbarAnnotationsNote: "\u30CE\u30FC\u30C8",
  toolbarAnnotationsParallelChannel: "\u30D1\u30E9\u30EC\u30EB\u30C1\u30E3\u30CD\u30EB",
  toolbarAnnotationsPriceRange: "\u4FA1\u683C\u7BC4\u56F2",
  toolbarAnnotationsQuickDatePriceRange: "\u6E2C\u5B9A",
  toolbarAnnotationsSettings: "\u8A2D\u5B9A",
  toolbarAnnotationsShapeAnnotations: "\u77E2\u5370",
  toolbarAnnotationsText: "\u30C6\u30AD\u30B9\u30C8",
  toolbarAnnotationsTextAnnotations: "\u30C6\u30AD\u30B9\u30C8\u6CE8\u91C8",
  toolbarAnnotationsTextColor: "\u30C6\u30AD\u30B9\u30C8\u306E\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u30B5\u30A4\u30BA",
  toolbarAnnotationsTrendLine: "\u30C8\u30EC\u30F3\u30C9\u30E9\u30A4\u30F3",
  toolbarAnnotationsUnlock: "\u30ED\u30C3\u30AF\u89E3\u9664",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7DDA",
  toolbarRange1Month: "1\u30F6\u6708",
  toolbarRange1MonthAria: "1\u304B\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u30F6\u6708",
  toolbarRange3MonthsAria: "3\u30F6\u6708",
  toolbarRange6Months: "6\u30F6\u6708",
  toolbarRange6MonthsAria: "6\u304B\u6708",
  toolbarRangeAll: "\u3059\u3079\u3066",
  toolbarRangeAllAria: "\u3059\u3079\u3066",
  toolbarRangeYearToDate: "\u5E74\u521D\u6765",
  toolbarRangeYearToDateAria: "\u5E74\u521D\u6765",
  toolbarSeriesTypeCandles: "\u30AD\u30E3\u30F3\u30C9\u30EB",
  toolbarSeriesTypeDropdown: "\u30B0\u30E9\u30D5\u30BF\u30A4\u30D7",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u6D1E\u306E\u308D\u3046\u305D\u304F",
  toolbarSeriesTypeLine: "\u30E9\u30A4\u30F3",
  toolbarSeriesTypeLineWithMarkers: "\u30DE\u30FC\u30AB\u30FC\u4ED8\u304D\u6298\u308C\u7DDA\u30B0\u30E9\u30D5",
  toolbarSeriesTypeOHLC: "OHLC(\u59CB\u5024\u3001\u9AD8\u5024\u3001\u5B89\u5024\u3001\u7D42\u5024)",
  toolbarSeriesTypeStepLine: "\u968E\u6BB5\u7DDA",
  toolbarZoomPanEnd: "\u6700\u5F8C\u307E\u3067\u30D1\u30F3",
  toolbarZoomPanLeft: "\u5DE6\u306B\u30D1\u30F3",
  toolbarZoomPanRight: "\u53F3\u306B\u30D1\u30F3",
  toolbarZoomPanStart: "\u6700\u521D\u306B\u30D1\u30F3\u3059\u308B",
  toolbarZoomReset: "\u30BA\u30FC\u30E0\u3092\u30EA\u30BB\u30C3\u30C8",
  toolbarZoomZoomIn: "\u30BA\u30FC\u30E0\u30A4\u30F3",
  toolbarZoomZoomOut: "\u30BA\u30FC\u30E0\u30A2\u30A6\u30C8",
  tooltipPaginationStatus: "${index}[number] \u306E ${count}[number]"
};
var AG_CHARTS_LOCALE_KO_KR = {
  ariaAnnounceChart: "\uCC28\uD2B8, ${seriesCount}[number] \uC2DC\uB9AC\uC988",
  ariaAnnounceFlowProportionLink: "\uB9C1\uD06C ${index} / ${count}, ${from}\uC5D0\uC11C ${to}\uB85C, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\uB178\uB4DC ${index} / ${count}, ${description}",
  ariaAnnounceGaugeChart: "\uAC8C\uC774\uC9C0 \uCC28\uD2B8, ${caption}",
  ariaAnnounceHierarchyChart: "\uACC4\uCE35 \uCC28\uD2B8, ${caption}",
  ariaAnnounceHierarchyDatum: "\uB808\uBCA8 ${level}[number], ${count}[number] \uC790\uC2DD, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\uC2A4\uD398\uC774\uC2A4\uBC14 \uB610\uB294 \uC5D4\uD130\uB97C \uB20C\uB7EC \uD45C\uC2DC \uC5EC\uBD80\uB97C \uC804\uD658\uD558\uC138\uC694",
  ariaLabelAddHorizontalLine: "\uC218\uD3C9\uC120 \uCD94\uAC00",
  ariaLabelAnnotationOptionsToolbar: "\uC8FC\uC11D \uC635\uC158",
  ariaLabelAnnotationSettingsDialog: "\uC8FC\uC11D \uC124\uC815",
  ariaLabelColorPicker: "\uC0C9\uC0C1 \uC120\uD0DD\uAE30",
  ariaLabelFinancialCharts: "\uAE08\uC735 \uCC28\uD2B8",
  ariaLabelLegend: "\uBC94\uB840",
  ariaLabelLegendItem: "${label}, \uBC94\uB840 \uD56D\uBAA9 ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\uC54C \uC218 \uC5C6\uB294 \uBC94\uB840 \uD56D\uBAA9",
  ariaLabelLegendPageNext: "\uB2E4\uC74C \uBC94\uB840 \uD398\uC774\uC9C0",
  ariaLabelLegendPagePrevious: "\uC774\uC804 \uBC94\uB840 \uD398\uC774\uC9C0",
  ariaLabelLegendPagination: "\uBC94\uB840 \uD398\uC774\uC9C0 \uB9E4\uAE40",
  ariaLabelNavigator: "\uB124\uBE44\uAC8C\uC774\uD130",
  ariaLabelNavigatorMaximum: "\uCD5C\uB300",
  ariaLabelNavigatorMinimum: "\uCD5C\uC18C",
  ariaLabelNavigatorRange: "\uBC94\uC704",
  ariaLabelRangesToolbar: "\uBC94\uC704",
  ariaLabelSettingsTabBar: "\uC124\uC815",
  ariaLabelZoomToolbar: "\uD655\uB300",
  ariaValuePanRange: "${min}[percent0to2dp]\uC5D0\uC11C ${max}[percent0to2dp]\uAE4C\uC9C0",
  contextMenuDownload: "\uB2E4\uC6B4\uB85C\uB4DC",
  contextMenuPanToCursor: "\uC5EC\uAE30\uB85C \uC774\uB3D9",
  contextMenuToggleOtherSeries: "\uB2E4\uB978 \uACC4\uC5F4 \uC804\uD658",
  contextMenuToggleSeriesVisibility: "\uAC00\uC2DC\uC131 \uC804\uD658",
  contextMenuZoomToCursor: "\uC5EC\uAE30\uB85C \uD655\uB300",
  dialogHeaderChannel: "\uCC44\uB110",
  dialogHeaderDatePriceRange: "\uB0A0\uC9DC \uBC0F \uAC00\uACA9",
  dialogHeaderDateRange: "\uB0A0\uC9DC \uBC94\uC704",
  dialogHeaderFibonacciRange: "\uD53C\uBCF4\uB098\uCE58 \uB418\uB3CC\uB9BC",
  dialogHeaderLine: "\uB77C\uC778",
  dialogHeaderPriceRange: "\uAC00\uACA9 \uBC94\uC704",
  dialogHeaderText: "\uD14D\uC2A4\uD2B8",
  dialogInputAlign: "\uC815\uB82C",
  dialogInputColorPicker: "\uC0C9\uC0C1",
  dialogInputColorPickerAltText: "\uD14D\uC2A4\uD2B8 \uC0C9\uC0C1",
  dialogInputExtendAbove: "\uC704\uB85C \uD655\uC7A5",
  dialogInputExtendBelow: "\uC544\uB798\uB85C \uD655\uC7A5\uD558\uAE30",
  dialogInputExtendChannelEnd: "\uCC44\uB110 \uB05D \uD655\uC7A5",
  dialogInputExtendChannelStart: "\uCC44\uB110 \uC2DC\uC791 \uD655\uC7A5",
  dialogInputExtendLeft: "\uC67C\uCABD\uC73C\uB85C \uD655\uC7A5",
  dialogInputExtendLineEnd: "\uC120 \uB05D \uC5F0\uC7A5",
  dialogInputExtendLineStart: "\uC120 \uC2DC\uC791 \uD655\uC7A5",
  dialogInputExtendRight: "\uC624\uB978\uCABD \uD655\uC7A5",
  dialogInputFibonacciBands: "\uBC34\uB4DC",
  dialogInputFibonacciBandsAltText: "\uD53C\uBCF4\uB098\uCE58 \uBC34\uB4DC",
  dialogInputFillColorPicker: "\uC0C9 \uCC44\uC6B0\uAE30",
  dialogInputFillColorPickerAltText: "\uCC44\uC6B0\uAE30 \uC0C9\uC0C1",
  dialogInputFontSize: "\uD06C\uAE30",
  dialogInputFontSizeAltText: "\uAE00\uAF34 \uD06C\uAE30",
  dialogInputLineStyle: "\uB300\uC2DC",
  dialogInputPosition: "\uC704\uCE58",
  dialogInputReverse: '"\uBC18\uC804"',
  dialogInputShowFill: "\uCC44\uC6B0\uAE30 \uD45C\uC2DC",
  dialogInputStrokeWidth: "\uAD75\uAE30",
  dialogInputStrokeWidthAltText: "\uC120 \uAD75\uAE30",
  iconAltTextAlignCenter: "\uAC00\uC6B4\uB370 \uB9DE\uCDA4",
  iconAltTextAlignLeft: "\uC67C\uCABD",
  iconAltTextAlignRight: "\uC624\uB978\uCABD",
  iconAltTextClose: "\uB2EB\uAE30",
  iconAltTextLineStyleDashed: "\uAE34 \uB300\uC2DC",
  iconAltTextLineStyleDotted: "\u2018\uC9E7\uC740 \uB300\uC2DC\u2019",
  iconAltTextLineStyleSolid: "\uC2E4\uC120",
  iconAltTextPositionBottom: "\uC544\uB798\uCABD",
  iconAltTextPositionCenter: "\uC911\uC559",
  iconAltTextPositionTop: "\uC704",
  inputTextareaPlaceholder: "\uD14D\uC2A4\uD2B8 \uCD94\uAC00",
  measurerDateRangeBars: "${value}[number] \uB9C9\uB300",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\uC6A9\uB7C9 ${value}",
  overlayLoadingData: "\uB370\uC774\uD130\uB97C \uB85C\uB4DC\uD558\uB294 \uC911...",
  overlayNoData: "\uD45C\uC2DC\uD560 \uB370\uC774\uD130\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4",
  overlayNoVisibleSeries: "\uBCF4\uC774\uB294 \uC2DC\uB9AC\uC988\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4",
  overlayUnsupportedBrowser: "\uD638\uD658\uB418\uC9C0 \uC54A\uB294 \uBE0C\uB77C\uC6B0\uC800 \uBC84\uC804\uC785\uB2C8\uB2E4. \uBE0C\uB77C\uC6B0\uC800\uB97C \uC5C5\uADF8\uB808\uC774\uB4DC\uD574 \uC8FC\uC2ED\uC2DC\uC624.",
  seriesHistogramTooltipCount: "${yName} (\uAC1C\uC218)",
  seriesHistogramTooltipFrequency: "\uBE48\uB3C4",
  seriesHistogramTooltipMean: "${yName} (\uD3C9\uADE0)",
  seriesHistogramTooltipSum: "${yName} (\uD569\uACC4)",
  toolbarAnnotationsArrow: "\uD654\uC0B4\uD45C",
  toolbarAnnotationsArrowDown: "\uC544\uB798\uCABD \uD654\uC0B4\uD45C",
  toolbarAnnotationsArrowUp: "\uC704\uCABD \uD654\uC0B4\uD45C",
  toolbarAnnotationsCallout: "\uCF5C\uC544\uC6C3",
  toolbarAnnotationsClearAll: "\uBAA8\uB450 \uC9C0\uC6B0\uAE30",
  toolbarAnnotationsComment: "\uB313\uAE00",
  toolbarAnnotationsDatePriceRange: "\uB0A0\uC9DC \uBC0F \uAC00\uACA9",
  toolbarAnnotationsDateRange: "\uB0A0\uC9DC \uBC94\uC704",
  toolbarAnnotationsDelete: "\uC0AD\uC81C",
  toolbarAnnotationsDisjointChannel: "\uB3C5\uB9BD \uCC44\uB110",
  toolbarAnnotationsDragHandle: "\uB3C4\uAD6C \uBAA8\uC74C \uB04C\uAE30",
  toolbarAnnotationsFibonacciAnnotations: "\uD53C\uBCF4\uB098\uCE58",
  toolbarAnnotationsFibonacciRetracement: "\uD53C\uBCF4\uB098\uCE58 \uB418\uB3CC\uB9BC",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\uD53C\uBCF4\uB098\uCE58 \uCD94\uC138 \uAE30\uBC18",
  toolbarAnnotationsFillColor: "\uCC44\uC6B0\uAE30 \uC0C9\uC0C1",
  toolbarAnnotationsHorizontalLine: "\uC218\uD3C9\uC120",
  toolbarAnnotationsLineAnnotations: "\uCD94\uC138\uC120",
  toolbarAnnotationsLineColor: "\uC120 \uC0C9\uC0C1",
  toolbarAnnotationsLineStrokeWidth: "\uC120 \uD68D \uB108\uBE44",
  toolbarAnnotationsLineStyle: "\uC120 \uC2A4\uD0C0\uC77C",
  toolbarAnnotationsLock: "\uC7A0\uAE08",
  toolbarAnnotationsMeasurerAnnotations: "\uCE21\uC815\uAE30",
  toolbarAnnotationsNote: "\uB178\uD2B8",
  toolbarAnnotationsParallelChannel: "\uD3C9\uD589 \uCC44\uB110",
  toolbarAnnotationsPriceRange: "\uAC00\uACA9 \uBC94\uC704",
  toolbarAnnotationsQuickDatePriceRange: "\uCE21\uC815",
  toolbarAnnotationsSettings: "\uC124\uC815",
  toolbarAnnotationsShapeAnnotations: "\uD654\uC0B4\uD45C",
  toolbarAnnotationsText: "\uD14D\uC2A4\uD2B8",
  toolbarAnnotationsTextAnnotations: "\uD14D\uC2A4\uD2B8 \uC8FC\uC11D",
  toolbarAnnotationsTextColor: "\uD14D\uC2A4\uD2B8 \uC0C9\uC0C1",
  toolbarAnnotationsTextSize: "\uD14D\uC2A4\uD2B8 \uD06C\uAE30",
  toolbarAnnotationsTrendLine: "\uCD94\uC138\uC120",
  toolbarAnnotationsUnlock: "\uC7A0\uAE08 \uD574\uC81C",
  toolbarAnnotationsVerticalLine: "\uC138\uB85C \uC120",
  toolbarRange1Month: "1\uAC1C\uC6D4",
  toolbarRange1MonthAria: "1\uAC1C\uC6D4",
  toolbarRange1Year: "1\uB144",
  toolbarRange1YearAria: "1\uB144",
  toolbarRange3Months: "3\uAC1C\uC6D4",
  toolbarRange3MonthsAria: "3\uAC1C\uC6D4",
  toolbarRange6Months: "6\uAC1C\uC6D4",
  toolbarRange6MonthsAria: "6\uAC1C\uC6D4",
  toolbarRangeAll: "\uC804\uCCB4",
  toolbarRangeAllAria: "\uBAA8\uB450",
  toolbarRangeYearToDate: "\uC5F0\uCD08\uBD80\uD130 \uD604\uC7AC\uAE4C\uC9C0",
  toolbarRangeYearToDateAria: "\uC62C\uD574 \uCD08\uBD80\uD130 \uD604\uC7AC\uAE4C\uC9C0",
  toolbarSeriesTypeCandles: "\uCE94\uB4E4",
  toolbarSeriesTypeDropdown: "\uCC28\uD2B8 \uC720\uD615",
  toolbarSeriesTypeHighLow: "\uACE0\uC800",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\uC18D\uBE48 \uC591\uCD08",
  toolbarSeriesTypeLine: "\uB77C\uC778",
  toolbarSeriesTypeLineWithMarkers: "\uB9C8\uCEE4\uAC00 \uC788\uB294 \uC120",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\uACC4\uB2E8\uD615 \uC120",
  toolbarZoomPanEnd: "\uB05D\uC73C\uB85C \uC774\uB3D9",
  toolbarZoomPanLeft: "\uC67C\uCABD\uC73C\uB85C \uC774\uB3D9",
  toolbarZoomPanRight: "\uC624\uB978\uCABD\uC73C\uB85C \uC774\uB3D9",
  toolbarZoomPanStart: "\uC2DC\uC791 \uC704\uCE58\uB85C \uC774\uB3D9",
  toolbarZoomReset: "\uC90C \uB9AC\uC14B",
  toolbarZoomZoomIn: "\uD655\uB300",
  toolbarZoomZoomOut: "\uCD95\uC18C",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
var AG_CHARTS_LOCALE_NB_NO = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] serier",
  ariaAnnounceFlowProportionLink: "lenke ${index} av ${count}, fra ${from} til ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "node ${index} av ${count}, ${description}",
  ariaAnnounceGaugeChart: "m\xE5lerdiagram, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkidiagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niv\xE5 ${level}[number], ${count}[number] barn, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Trykk p\xE5 mellomromstasten eller Enter for \xE5 bytte synlighet",
  ariaLabelAddHorizontalLine: "Legg til horisontal linje",
  ariaLabelAnnotationOptionsToolbar: "Merknadsalternativer",
  ariaLabelAnnotationSettingsDialog: "Kommentarinnstillinger",
  ariaLabelColorPicker: "Fargevelger",
  ariaLabelFinancialCharts: "Finansielle diagrammer",
  ariaLabelLegend: "Forklaring",
  ariaLabelLegendItem: "${label}, Legendepost ${index}[number] av ${count}[number]",
  ariaLabelLegendItemUnknown: "Ukjent legendeelement",
  ariaLabelLegendPageNext: "Neste legende side",
  ariaLabelLegendPagePrevious: "Forrige legende-side",
  ariaLabelLegendPagination: "Paginering av legenden",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Omr\xE5de",
  ariaLabelRangesToolbar: "Omr\xE5der",
  ariaLabelSettingsTabBar: "Innstillinger",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] til ${max}[percent0to2dp]",
  contextMenuDownload: "Last ned",
  contextMenuPanToCursor: "Panorer til dette punktet",
  contextMenuToggleOtherSeries: "Sl\xE5 av/p\xE5 andre serier",
  contextMenuToggleSeriesVisibility: "Veksle synlighet",
  contextMenuZoomToCursor: "Zoom hit",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Dato og pris",
  dialogHeaderDateRange: "Datoperiode",
  dialogHeaderFibonacciRange: "Fib Tilbakeretracement",
  dialogHeaderLine: "Linje",
  dialogHeaderPriceRange: "Prisklasse",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Justering",
  dialogInputColorPicker: "Farge",
  dialogInputColorPickerAltText: "Tekstfarge",
  dialogInputExtendAbove: "Forleng over",
  dialogInputExtendBelow: "Utvid nedenfor",
  dialogInputExtendChannelEnd: "Forleng kanalende",
  dialogInputExtendChannelStart: "Utvide kanalstart",
  dialogInputExtendLeft: "Forleng til venstre",
  dialogInputExtendLineEnd: "Forleng linjeslutt",
  dialogInputExtendLineStart: "Forleng linjestart",
  dialogInputExtendRight: "Forleng til h\xF8yre",
  dialogInputFibonacciBands: "B\xE5nd",
  dialogInputFibonacciBandsAltText: "Fibonacci-b\xE5nd",
  dialogInputFillColorPicker: "Fyll",
  dialogInputFillColorPickerAltText: "Fyllfarge",
  dialogInputFontSize: "St\xF8rrelse",
  dialogInputFontSizeAltText: "Skriftst\xF8rrelse",
  dialogInputLineStyle: "Strek",
  dialogInputPosition: "Posisjon",
  dialogInputReverse: "Omvendt",
  dialogInputShowFill: "Vis fyll",
  dialogInputStrokeWidth: "Tykkelse",
  dialogInputStrokeWidthAltText: "Linjetykkelse",
  iconAltTextAlignCenter: "Midtstill",
  iconAltTextAlignLeft: "Venstre",
  iconAltTextAlignRight: "H\xF8yre",
  iconAltTextClose: "Lukk",
  iconAltTextLineStyleDashed: "Lang-stiplet",
  iconAltTextLineStyleDotted: "Kort-stiplet",
  iconAltTextLineStyleSolid: "Heltrukket",
  iconAltTextPositionBottom: "Bunnen",
  iconAltTextPositionCenter: "Senter",
  iconAltTextPositionTop: "Topp",
  inputTextareaPlaceholder: "Legg til tekst",
  measurerDateRangeBars: "${value}[number] s\xF8yler",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volum ${value}",
  overlayLoadingData: "Laster data...",
  overlayNoData: "Ingen data \xE5 vise",
  overlayNoVisibleSeries: "Ingen synlige serier",
  overlayUnsupportedBrowser: "Ukompatibel nettleserversjon. Vennligst oppgrader nettleseren din.",
  seriesHistogramTooltipCount: "${yName} (antall)",
  seriesHistogramTooltipFrequency: "Frekvens",
  seriesHistogramTooltipMean: "${yName} (gjennomsnitt)",
  seriesHistogramTooltipSum: "${yName} (sum)",
  toolbarAnnotationsArrow: "Pil",
  toolbarAnnotationsArrowDown: "Pil ned",
  toolbarAnnotationsArrowUp: "Pil opp",
  toolbarAnnotationsCallout: "Notat",
  toolbarAnnotationsClearAll: "Fjern alt",
  toolbarAnnotationsComment: "Kommenter",
  toolbarAnnotationsDatePriceRange: "Dato og pris",
  toolbarAnnotationsDateRange: "Datoomr\xE5de",
  toolbarAnnotationsDelete: "Slett",
  toolbarAnnotationsDisjointChannel: "Disjoint kanal",
  toolbarAnnotationsDragHandle: "Dra-verkt\xF8ylinje",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fibonnaci Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Basert",
  toolbarAnnotationsFillColor: "Fargefyll",
  toolbarAnnotationsHorizontalLine: "Horisontal linje",
  toolbarAnnotationsLineAnnotations: "Trendlinjer",
  toolbarAnnotationsLineColor: "Linjefarge",
  toolbarAnnotationsLineStrokeWidth: "Linjeslagbredde",
  toolbarAnnotationsLineStyle: "Linjestil",
  toolbarAnnotationsLock: "L\xE5s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE5lere",
  toolbarAnnotationsNote: "Notat",
  toolbarAnnotationsParallelChannel: "Parallell kanal",
  toolbarAnnotationsPriceRange: "Prisomr\xE5de",
  toolbarAnnotationsQuickDatePriceRange: "M\xE5l",
  toolbarAnnotationsSettings: "Innstillinger",
  toolbarAnnotationsShapeAnnotations: "Piler",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstanmerkninger",
  toolbarAnnotationsTextColor: "Tekstfarge",
  toolbarAnnotationsTextSize: "Tekstst\xF8rrelse",
  toolbarAnnotationsTrendLine: "Trendlinje",
  toolbarAnnotationsUnlock: "L\xE5s opp",
  toolbarAnnotationsVerticalLine: "Vertikal linje",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xE5ned",
  toolbarRange1Year: "1\xC5",
  toolbarRange1YearAria: "1 \xE5r",
  toolbarRange3Months: "3 mnd",
  toolbarRange3MonthsAria: "3 m\xE5neder",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\xE5neder",
  toolbarRangeAll: "Alle",
  toolbarRangeAllAria: "Alle",
  toolbarRangeYearToDate: "Hittil i \xE5r",
  toolbarRangeYearToDateAria: "\xC5r til dags dato",
  toolbarSeriesTypeCandles: "Lysestaker",
  toolbarSeriesTypeDropdown: "Diagramtype",
  toolbarSeriesTypeHighLow: "H\xF8y Lav",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Tom lysestake",
  toolbarSeriesTypeLine: "Linje",
  toolbarSeriesTypeLineWithMarkers: "Linje med mark\xF8rer",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Trinnlinje",
  toolbarZoomPanEnd: "Panorer til slutten",
  toolbarZoomPanLeft: "Panorer til venstre",
  toolbarZoomPanRight: "Panorer til h\xF8yre",
  toolbarZoomPanStart: "Panorer til start",
  toolbarZoomReset: "Tilbakestill zoom",
  toolbarZoomZoomIn: "Zoom inn",
  toolbarZoomZoomOut: "Zoom ut",
  tooltipPaginationStatus: "${index}[number] av ${count}[number]"
};
var AG_CHARTS_LOCALE_NL_NL = {
  ariaAnnounceChart: "grafiek, ${seriesCount}[number] reeksen",
  ariaAnnounceFlowProportionLink: "link ${index} van ${count}, van ${from} naar ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "knooppunt ${index} van ${count}, ${description}",
  ariaAnnounceGaugeChart: "meterdiagram, ${caption}",
  ariaAnnounceHierarchyChart: "hi\xEBrarchie diagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niveau ${level}[number], ${count}[number] kinderen, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Druk op Spatie of Enter om zichtbaarheid te wisselen",
  ariaLabelAddHorizontalLine: "Horizontale Lijn Toevoegen",
  ariaLabelAnnotationOptionsToolbar: "Annotatie-opties",
  ariaLabelAnnotationSettingsDialog: "Annotatie-instellingen",
  ariaLabelColorPicker: "Kleurkiezer",
  ariaLabelFinancialCharts: "Financi\xEBle grafieken",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Legenda-item ${index}[number] van ${count}[number]",
  ariaLabelLegendItemUnknown: "Onbekend legende-item",
  ariaLabelLegendPageNext: "Volgende Legend Pagina",
  ariaLabelLegendPagePrevious: "Vorige Legenda Pagina",
  ariaLabelLegendPagination: "Legenda Paginering",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Bereik",
  ariaLabelRangesToolbar: "Bereiken",
  ariaLabelSettingsTabBar: "Instellingen",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] tot ${max}[percent0to2dp]",
  contextMenuDownload: "Downloaden",
  contextMenuPanToCursor: "Naar hier pannen",
  contextMenuToggleOtherSeries: "Andere series in-/uitschakelen",
  contextMenuToggleSeriesVisibility: "Zichtbaarheid Wijzigen",
  contextMenuZoomToCursor: "Hier inzoomen",
  dialogHeaderChannel: "Kanaal",
  dialogHeaderDatePriceRange: "Datum en Prijs",
  dialogHeaderDateRange: "Datumbereik",
  dialogHeaderFibonacciRange: "Fib Retracement",
  dialogHeaderLine: "Lijn",
  dialogHeaderPriceRange: "Prijsklasse",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Uitlijnen",
  dialogInputColorPicker: "Kleur",
  dialogInputColorPickerAltText: "Tekstkleur",
  dialogInputExtendAbove: "Boven uitbreiden",
  dialogInputExtendBelow: "Naar beneden uitbreiden",
  dialogInputExtendChannelEnd: "Kanaaleinde uitbreiden",
  dialogInputExtendChannelStart: "Kanaalstart verlengen",
  dialogInputExtendLeft: "Links uitbreiden",
  dialogInputExtendLineEnd: "Verleng lijneinde",
  dialogInputExtendLineStart: "Lijnbegin verlengen",
  dialogInputExtendRight: "Naar rechts uitbreiden",
  dialogInputFibonacciBands: "Banden",
  dialogInputFibonacciBandsAltText: "Fibonacci Banden",
  dialogInputFillColorPicker: "Vul",
  dialogInputFillColorPickerAltText: "Vulkleur",
  dialogInputFontSize: "Grootte",
  dialogInputFontSizeAltText: "Lettergrootte",
  dialogInputLineStyle: "Streep",
  dialogInputPosition: "Positie",
  dialogInputReverse: "Omkeren",
  dialogInputShowFill: "Inkleuren weergeven",
  dialogInputStrokeWidth: "Gewicht",
  dialogInputStrokeWidthAltText: "Lijndikte",
  iconAltTextAlignCenter: "Centreren",
  iconAltTextAlignLeft: "Links",
  iconAltTextAlignRight: "Rechts",
  iconAltTextClose: "Sluiten",
  iconAltTextLineStyleDashed: "Lang-gestreept",
  iconAltTextLineStyleDotted: "Kort-gestreept",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Onderkant",
  iconAltTextPositionCenter: "Midden",
  iconAltTextPositionTop: "Boven",
  inputTextareaPlaceholder: "Voeg Tekst Toe",
  measurerDateRangeBars: "${value}[number] staven",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volume ${value}",
  overlayLoadingData: "Gegevens laden...",
  overlayNoData: "Geen gegevens om weer te geven",
  overlayNoVisibleSeries: "Geen zichtbare reeks",
  overlayUnsupportedBrowser: "Ongeschikte browserversie. Gelieve uw browser te updaten.",
  seriesHistogramTooltipCount: "${yName} (aantal)",
  seriesHistogramTooltipFrequency: "Frequentie",
  seriesHistogramTooltipMean: "${yName} (gemiddelde)",
  seriesHistogramTooltipSum: "${yName} (som)",
  toolbarAnnotationsArrow: "Pijl",
  toolbarAnnotationsArrowDown: "Pijl Omlaag",
  toolbarAnnotationsArrowUp: "Pijl Omhoog",
  toolbarAnnotationsCallout: "Tekstballon",
  toolbarAnnotationsClearAll: "Alles wissen",
  toolbarAnnotationsComment: "Opmerking",
  toolbarAnnotationsDatePriceRange: "Datum en Prijs",
  toolbarAnnotationsDateRange: "Datumbereik",
  toolbarAnnotationsDelete: "Verwijderen",
  toolbarAnnotationsDisjointChannel: "Niet-overlappend kanaal",
  toolbarAnnotationsDragHandle: "Sleepwerkbalk",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Gebaseerd",
  toolbarAnnotationsFillColor: "Vulkleur",
  toolbarAnnotationsHorizontalLine: "Horizontale lijn",
  toolbarAnnotationsLineAnnotations: "Trendlijnen",
  toolbarAnnotationsLineColor: "Lijnkleur",
  toolbarAnnotationsLineStrokeWidth: "Lijnstreepdikte",
  toolbarAnnotationsLineStyle: "Lijnstijl",
  toolbarAnnotationsLock: "Vergrendelen",
  toolbarAnnotationsMeasurerAnnotations: "Meetinstrumenten",
  toolbarAnnotationsNote: "Notitie",
  toolbarAnnotationsParallelChannel: "Parallel Kanaal",
  toolbarAnnotationsPriceRange: "Prijscategorie",
  toolbarAnnotationsQuickDatePriceRange: "Meten",
  toolbarAnnotationsSettings: "Instellingen",
  toolbarAnnotationsShapeAnnotations: "Pijlen",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Tekstanmerkingen",
  toolbarAnnotationsTextColor: "Tekstkleur",
  toolbarAnnotationsTextSize: "Tekstgrootte",
  toolbarAnnotationsTrendLine: "Trend Lijn",
  toolbarAnnotationsUnlock: "Ontgrendelen",
  toolbarAnnotationsVerticalLine: "Verticale lijn",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 maand",
  toolbarRange1Year: "1Jr",
  toolbarRange1YearAria: "1 jaar",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 maanden",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 maanden",
  toolbarRangeAll: "Alles",
  toolbarRangeAllAria: "Alles",
  toolbarRangeYearToDate: "JTD",
  toolbarRangeYearToDateAria: "Jaar tot nu toe",
  toolbarSeriesTypeCandles: "Kaarsen",
  toolbarSeriesTypeDropdown: "Grafiektype",
  toolbarSeriesTypeHighLow: "Hoog Laag",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hollow Kaarsen",
  toolbarSeriesTypeLine: "Lijn",
  toolbarSeriesTypeLineWithMarkers: "Lijn met Markers",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Stappenlijn",
  toolbarZoomPanEnd: "Naar het einde pannen",
  toolbarZoomPanLeft: "Links pannen",
  toolbarZoomPanRight: "Naar rechts pannen",
  toolbarZoomPanStart: "Scroll naar het begin",
  toolbarZoomReset: "Zoom resetten",
  toolbarZoomZoomIn: "Inzoomen",
  toolbarZoomZoomOut: "Uitzoomen",
  tooltipPaginationStatus: "${index}[number] van ${count}[number]"
};
var AG_CHARTS_LOCALE_PL_PL = {
  ariaAnnounceChart: "wykres, ${seriesCount}[number] serii",
  ariaAnnounceFlowProportionLink: "link ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "w\u0119ze\u0142 ${index} z ${count}, ${description}",
  ariaAnnounceGaugeChart: "wykres wska\u017Anikowy, ${caption}",
  ariaAnnounceHierarchyChart: "wykres hierarchii, ${caption}",
  ariaAnnounceHierarchyDatum: "poziom ${level}[number], ${count}[number] dzieci, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Naci\u015Bnij Spacj\u0119 lub Enter, aby prze\u0142\u0105cza\u0107 widoczno\u015B\u0107",
  ariaLabelAddHorizontalLine: "Dodaj lini\u0119 poziom\u0105",
  ariaLabelAnnotationOptionsToolbar: "Opcje Adnotacji",
  ariaLabelAnnotationSettingsDialog: "Ustawienia Adnotacji",
  ariaLabelColorPicker: "Wyb\xF3r koloru",
  ariaLabelFinancialCharts: "Wykresy finansowe",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Element legendy ${index}[number] z ${count}[number]",
  ariaLabelLegendItemUnknown: "Nieznany element legendy",
  ariaLabelLegendPageNext: "Nast\u0119pna strona legendy",
  ariaLabelLegendPagePrevious: "Poprzednia strona legendy",
  ariaLabelLegendPagination: "Stronicowanie legendy",
  ariaLabelNavigator: "Nawigator",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Zakres",
  ariaLabelRangesToolbar: "Zakresy",
  ariaLabelSettingsTabBar: "Ustawienia",
  ariaLabelZoomToolbar: "Powi\u0119kszenie",
  ariaValuePanRange: "${min}[percent0to2dp] do ${max}[percent0to2dp]",
  contextMenuDownload: "Pobierz",
  contextMenuPanToCursor: "Przesu\u0144 do tutaj",
  contextMenuToggleOtherSeries: "Prze\u0142\u0105cz inne serie",
  contextMenuToggleSeriesVisibility: "Prze\u0142\u0105cz widoczno\u015B\u0107",
  contextMenuZoomToCursor: "Powi\u0119ksz tutaj",
  dialogHeaderChannel: "Kana\u0142",
  dialogHeaderDatePriceRange: "Data i Cena",
  dialogHeaderDateRange: "Zakres dat",
  dialogHeaderFibonacciRange: "Fib Odpowiednio\u015B\u0107",
  dialogHeaderLine: "Linia",
  dialogHeaderPriceRange: "Zakres cenowy",
  dialogHeaderText: "Tekst",
  dialogInputAlign: "Wyr\xF3wnaj",
  dialogInputColorPicker: "Kolor",
  dialogInputColorPickerAltText: "Kolor tekstu",
  dialogInputExtendAbove: "Rozszerz powy\u017Cej",
  dialogInputExtendBelow: "Rozszerz poni\u017Cej",
  dialogInputExtendChannelEnd: "Przed\u0142u\u017C zako\u0144czenie kana\u0142u",
  dialogInputExtendChannelStart: "Rozszerz pocz\u0105tek kana\u0142u",
  dialogInputExtendLeft: "Rozci\u0105gnij w lewo",
  dialogInputExtendLineEnd: "Przed\u0142u\u017C zako\u0144czenie linii",
  dialogInputExtendLineStart: "Przed\u0142u\u017C pocz\u0105tek linii",
  dialogInputExtendRight: "Rozszerz w prawo",
  dialogInputFibonacciBands: "Pasma",
  dialogInputFibonacciBandsAltText: "Pasma Fibonacciego",
  dialogInputFillColorPicker: "Wype\u0142nij",
  dialogInputFillColorPickerAltText: "Kolor wype\u0142nienia",
  dialogInputFontSize: "Rozmiar",
  dialogInputFontSizeAltText: "Rozmiar czcionki",
  dialogInputLineStyle: "Kreska",
  dialogInputPosition: "Pozycja",
  dialogInputReverse: "Odwr\xF3\u0107",
  dialogInputShowFill: "Poka\u017C wype\u0142nienie",
  dialogInputStrokeWidth: "Grubo\u015B\u0107",
  dialogInputStrokeWidthAltText: "Grubo\u015B\u0107 linii",
  iconAltTextAlignCenter: "Wy\u015Brodkuj",
  iconAltTextAlignLeft: "Lewo",
  iconAltTextAlignRight: "Prawo",
  iconAltTextClose: "Zamknij",
  iconAltTextLineStyleDashed: "D\u0142ugie kreski",
  iconAltTextLineStyleDotted: "Kr\xF3tka kreska",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "D\xF3\u0142",
  iconAltTextPositionCenter: "\u015Arodek",
  iconAltTextPositionTop: "G\xF3ra",
  inputTextareaPlaceholder: "Dodaj Tekst",
  measurerDateRangeBars: "${value}[number] s\u0142upk\xF3w",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Obj\u0119to\u015B\u0107 ${value}",
  overlayLoadingData: "\u0141adowanie danych...",
  overlayNoData: "Brak danych do wy\u015Bwietlenia",
  overlayNoVisibleSeries: "Brak widocznych serii",
  overlayUnsupportedBrowser: "Niekompatybilna wersja przegl\u0105darki. Prosz\u0119 zaktualizowa\u0107 przegl\u0105dark\u0119.",
  seriesHistogramTooltipCount: "${yName} (liczba)",
  seriesHistogramTooltipFrequency: "Cz\u0119stotliwo\u015B\u0107",
  seriesHistogramTooltipMean: "${yName} (\u015Brednia)",
  seriesHistogramTooltipSum: "${yName} (suma)",
  toolbarAnnotationsArrow: "Strza\u0142ka",
  toolbarAnnotationsArrowDown: "Strza\u0142ka w d\xF3\u0142",
  toolbarAnnotationsArrowUp: "Strza\u0142ka w g\xF3r\u0119",
  toolbarAnnotationsCallout: "Adnotacja",
  toolbarAnnotationsClearAll: "Wyczy\u015B\u0107 wszystkie",
  toolbarAnnotationsComment: "Komentarz",
  toolbarAnnotationsDatePriceRange: "Data i cena",
  toolbarAnnotationsDateRange: "Zakres dat",
  toolbarAnnotationsDelete: "Usu\u0144",
  toolbarAnnotationsDisjointChannel: "Roz\u0142\u0105czony kana\u0142",
  toolbarAnnotationsDragHandle: "Przeci\u0105gnij pasek narz\u0119dzi",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Odbicie",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based' oparty na trendzi",
  toolbarAnnotationsFillColor: "Kolor wype\u0142nienia",
  toolbarAnnotationsHorizontalLine: "Linia pozioma",
  toolbarAnnotationsLineAnnotations: "Linie Trendu",
  toolbarAnnotationsLineColor: "Kolor linii",
  toolbarAnnotationsLineStrokeWidth: "Grubo\u015B\u0107 linii",
  toolbarAnnotationsLineStyle: "Styl linii",
  toolbarAnnotationsLock: "Zablokuj",
  toolbarAnnotationsMeasurerAnnotations: "Mierniki",
  toolbarAnnotationsNote: "Notatka",
  toolbarAnnotationsParallelChannel: "Kana\u0142 r\xF3wnoleg\u0142y",
  toolbarAnnotationsPriceRange: "Zakres cen",
  toolbarAnnotationsQuickDatePriceRange: "Zmierz",
  toolbarAnnotationsSettings: "Ustawienia",
  toolbarAnnotationsShapeAnnotations: "Strza\u0142ki",
  toolbarAnnotationsText: "Tekst",
  toolbarAnnotationsTextAnnotations: "Adnotacje tekstowe",
  toolbarAnnotationsTextColor: "Kolor tekstu",
  toolbarAnnotationsTextSize: "Rozmiar tekstu",
  toolbarAnnotationsTrendLine: "Linia trendu",
  toolbarAnnotationsUnlock: "Odblokuj",
  toolbarAnnotationsVerticalLine: "Linia pionowa",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 miesi\u0105c",
  toolbarRange1Year: "1R",
  toolbarRange1YearAria: "1 rok",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 miesi\u0105ce",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 miesi\u0119cy",
  toolbarRangeAll: "Wszystko",
  toolbarRangeAllAria: "Wszystko",
  toolbarRangeYearToDate: "Rok Do Dzi\u015B",
  toolbarRangeYearToDateAria: "Od pocz\u0105tku roku",
  toolbarSeriesTypeCandles: "\u015Awiece",
  toolbarSeriesTypeDropdown: "Typ wykresu",
  toolbarSeriesTypeHighLow: "Wysoki Niski",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u015Awieczki Puste",
  toolbarSeriesTypeLine: "Linia",
  toolbarSeriesTypeLineWithMarkers: "Linia z znacznikami",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linia krokowa",
  toolbarZoomPanEnd: "Przesu\u0144 na koniec",
  toolbarZoomPanLeft: "Przesu\u0144 w lewo",
  toolbarZoomPanRight: "Przesu\u0144 w prawo",
  toolbarZoomPanStart: "Przesu\u0144 na pocz\u0105tek",
  toolbarZoomReset: "Resetuj powi\u0119kszenie",
  toolbarZoomZoomIn: "Powi\u0119ksz",
  toolbarZoomZoomOut: "Oddal",
  tooltipPaginationStatus: "${index}[number] z ${count}[number]"
};
var AG_CHARTS_LOCALE_PT_BR = {
  ariaAnnounceChart: "gr\xE1fico, ${seriesCount}[number] s\xE9ries",
  ariaAnnounceFlowProportionLink: "link ${index} de ${count}, de ${from} para ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\xF3 ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "gr\xE1fico de medidor, ${caption}",
  ariaAnnounceHierarchyChart: "gr\xE1fico de hierarquia, ${caption}",
  ariaAnnounceHierarchyDatum: "n\xEDvel ${level}[number], ${count}[number] filhos, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Pressione Espa\xE7o ou Enter para alternar a visibilidade",
  ariaLabelAddHorizontalLine: "Adicionar Linha Horizontal",
  ariaLabelAnnotationOptionsToolbar: "Op\xE7\xF5es de Anota\xE7\xE3o",
  ariaLabelAnnotationSettingsDialog: "Configura\xE7\xF5es de Anota\xE7\xE3o",
  ariaLabelColorPicker: "Seletor de cores",
  ariaLabelFinancialCharts: "Gr\xE1ficos financeiros",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Item da legenda ${index}[number] de ${count}[number]",
  ariaLabelLegendItemUnknown: "Item desconhecido da legenda",
  ariaLabelLegendPageNext: "Pr\xF3xima P\xE1gina da Legenda",
  ariaLabelLegendPagePrevious: "P\xE1gina Anterior da Legenda",
  ariaLabelLegendPagination: "Pagina\xE7\xE3o da Legenda",
  ariaLabelNavigator: "Navegador",
  ariaLabelNavigatorMaximum: "M\xE1ximo",
  ariaLabelNavigatorMinimum: "M\xEDnimo",
  ariaLabelNavigatorRange: "Intervalo",
  ariaLabelRangesToolbar: "Faixas",
  ariaLabelSettingsTabBar: "Configura\xE7\xF5es",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Baixar",
  contextMenuPanToCursor: "Mover para aqui",
  contextMenuToggleOtherSeries: "Alternar Outras S\xE9ries",
  contextMenuToggleSeriesVisibility: "Alternar Visibilidade",
  contextMenuZoomToCursor: "Dar zoom aqui",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Data e Pre\xE7o",
  dialogHeaderDateRange: "Intervalo de Datas",
  dialogHeaderFibonacciRange: "Retra\xE7\xE3o de Fib",
  dialogHeaderLine: "Linha",
  dialogHeaderPriceRange: "Faixa de Pre\xE7o",
  dialogHeaderText: "Texto",
  dialogInputAlign: "Alinhar",
  dialogInputColorPicker: "Cor",
  dialogInputColorPickerAltText: "Cor do Texto",
  dialogInputExtendAbove: "Estender acima",
  dialogInputExtendBelow: "Estender abaixo",
  dialogInputExtendChannelEnd: "Estender final do canal",
  dialogInputExtendChannelStart: "Estender in\xEDcio do canal",
  dialogInputExtendLeft: "Estender \xE0 esquerda",
  dialogInputExtendLineEnd: "Estender fim da linha",
  dialogInputExtendLineStart: "Estender in\xEDcio da linha",
  dialogInputExtendRight: "Estender \xE0 direita",
  dialogInputFibonacciBands: "Bandas",
  dialogInputFibonacciBandsAltText: "Bandas de Fibonacci",
  dialogInputFillColorPicker: "Preencher",
  dialogInputFillColorPickerAltText: "Cor de Preenchimento",
  dialogInputFontSize: "Tamanho",
  dialogInputFontSizeAltText: "Tamanho da Fonte",
  dialogInputLineStyle: "Tracejado",
  dialogInputPosition: "Posi\xE7\xE3o",
  dialogInputReverse: "Inverter",
  dialogInputShowFill: "Exibir Preenchimento",
  dialogInputStrokeWidth: "Peso",
  dialogInputStrokeWidthAltText: "Peso da Linha",
  iconAltTextAlignCenter: "Centralizar",
  iconAltTextAlignLeft: "Esquerda",
  iconAltTextAlignRight: "Direita",
  iconAltTextClose: "Fechar",
  iconAltTextLineStyleDashed: "Tra\xE7o longo",
  iconAltTextLineStyleDotted: "Tra\xE7o Curto",
  iconAltTextLineStyleSolid: "S\xF3lido",
  iconAltTextPositionBottom: "Inferior",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "Topo",
  inputTextareaPlaceholder: "Adicionar Texto",
  measurerDateRangeBars: "${value}[number] barras",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: '"Vol ${value}"',
  overlayLoadingData: "Carregando dados...",
  overlayNoData: "Sem dados para exibir",
  overlayNoVisibleSeries: "Nenhuma s\xE9rie vis\xEDvel",
  overlayUnsupportedBrowser: "Vers\xE3o do navegador incompat\xEDvel. Por favor, atualize seu navegador.",
  seriesHistogramTooltipCount: "${yName} (contagem)",
  seriesHistogramTooltipFrequency: "Frequ\xEAncia",
  seriesHistogramTooltipMean: "${yName} (m\xE9dia)",
  seriesHistogramTooltipSum: "${yName} (soma)",
  toolbarAnnotationsArrow: "Seta",
  toolbarAnnotationsArrowDown: "Seta para Baixo",
  toolbarAnnotationsArrowUp: "Seta para cima",
  toolbarAnnotationsCallout: "Anota\xE7\xE3o",
  toolbarAnnotationsClearAll: "Limpar Tudo",
  toolbarAnnotationsComment: "Comentar",
  toolbarAnnotationsDatePriceRange: "Data e Pre\xE7o",
  toolbarAnnotationsDateRange: "Intervalo de Datas",
  toolbarAnnotationsDelete: "Excluir",
  toolbarAnnotationsDisjointChannel: "Canal Independente",
  toolbarAnnotationsDragHandle: "Arrastar Barra de Ferramentas",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retra\xE7\xE3o de Fibonacci",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Tend\xEAncia Baseada em Fib",
  toolbarAnnotationsFillColor: "Cor de Preenchimento",
  toolbarAnnotationsHorizontalLine: "Linha Horizontal",
  toolbarAnnotationsLineAnnotations: "Linhas de Tend\xEAncia",
  toolbarAnnotationsLineColor: "Cor da Linha",
  toolbarAnnotationsLineStrokeWidth: "Espessura do Tra\xE7o da Linha",
  toolbarAnnotationsLineStyle: "Estilo de Linha",
  toolbarAnnotationsLock: "Bloquear",
  toolbarAnnotationsMeasurerAnnotations: "Medidores",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canal Paralelo",
  toolbarAnnotationsPriceRange: "Faixa de Pre\xE7o",
  toolbarAnnotationsQuickDatePriceRange: "Medir",
  toolbarAnnotationsSettings: "Configura\xE7\xF5es",
  toolbarAnnotationsShapeAnnotations: "Setas",
  toolbarAnnotationsText: "Texto",
  toolbarAnnotationsTextAnnotations: "Anota\xE7\xF5es de Texto",
  toolbarAnnotationsTextColor: "Cor do Texto",
  toolbarAnnotationsTextSize: "Tamanho do Texto",
  toolbarAnnotationsTrendLine: "Linha de Tend\xEAncia",
  toolbarAnnotationsUnlock: "Desbloquear",
  toolbarAnnotationsVerticalLine: "Linha Vertical",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xEAs",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 ano",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 meses",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 meses",
  toolbarRangeAll: "Todos",
  toolbarRangeAllAria: "Tudo",
  toolbarRangeYearToDate: "YTD",
  toolbarRangeYearToDateAria: "Ano at\xE9 a data",
  toolbarSeriesTypeCandles: "Velas",
  toolbarSeriesTypeDropdown: "Tipo de Gr\xE1fico",
  toolbarSeriesTypeHighLow: "Alta Baixa",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Velas Vazadas",
  toolbarSeriesTypeLine: "Linha",
  toolbarSeriesTypeLineWithMarkers: "Linha com Marcadores",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linha de Passos",
  toolbarZoomPanEnd: "Panorar para o final",
  toolbarZoomPanLeft: "Mover para a esquerda",
  toolbarZoomPanRight: "Mover para a direita",
  toolbarZoomPanStart: "Mover para o in\xEDcio",
  toolbarZoomReset: "Redefinir o zoom",
  toolbarZoomZoomIn: "Aproximar",
  toolbarZoomZoomOut: "Diminuir zoom",
  tooltipPaginationStatus: "${index}[number] de ${count}[number]"
};
var AG_CHARTS_LOCALE_PT_PT = {
  ariaAnnounceChart: "gr\xE1fico, ${seriesCount}[number] s\xE9ries",
  ariaAnnounceFlowProportionLink: "link ${index} de ${count}, de ${from} para ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\xF3 ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "gr\xE1fico de medidor, ${caption}",
  ariaAnnounceHierarchyChart: "gr\xE1fico hier\xE1rquico, ${caption}",
  ariaAnnounceHierarchyDatum: "n\xEDvel ${level}[number], ${count}[number] filhos, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Pressione Espa\xE7o ou Enter para alternar a visibilidade",
  ariaLabelAddHorizontalLine: "Adicionar Linha Horizontal",
  ariaLabelAnnotationOptionsToolbar: "Op\xE7\xF5es de Anota\xE7\xE3o",
  ariaLabelAnnotationSettingsDialog: "Configura\xE7\xF5es de Anota\xE7\xE3o",
  ariaLabelColorPicker: "Seletor de cores",
  ariaLabelFinancialCharts: "Gr\xE1ficos financeiros",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, item da legenda ${index}[number] de ${count}[number]",
  ariaLabelLegendItemUnknown: "Item desconhecido na legenda",
  ariaLabelLegendPageNext: "Pr\xF3xima p\xE1gina da legenda",
  ariaLabelLegendPagePrevious: "P\xE1gina Anterior da Legenda",
  ariaLabelLegendPagination: "Pagina\xE7\xE3o da Lenda",
  ariaLabelNavigator: "Navegador",
  ariaLabelNavigatorMaximum: "M\xE1ximo",
  ariaLabelNavigatorMinimum: "M\xEDnimo",
  ariaLabelNavigatorRange: "Intervalo",
  ariaLabelRangesToolbar: "Intervalos",
  ariaLabelSettingsTabBar: "Configura\xE7\xF5es",
  ariaLabelZoomToolbar: "Ampliar",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Baixar",
  contextMenuPanToCursor: "Mover para aqui",
  contextMenuToggleOtherSeries: "Alternar Outras S\xE9ries",
  contextMenuToggleSeriesVisibility: "Alternar Visibilidade",
  contextMenuZoomToCursor: "Ampliar para aqui",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Data e Pre\xE7o",
  dialogHeaderDateRange: "Intervalo de Datas",
  dialogHeaderFibonacciRange: "Retra\xE7\xE3o Fib",
  dialogHeaderLine: "Linha",
  dialogHeaderPriceRange: "Faixa de Pre\xE7o",
  dialogHeaderText: "Texto",
  dialogInputAlign: "Alinhar",
  dialogInputColorPicker: "Cor",
  dialogInputColorPickerAltText: "Cor do Texto",
  dialogInputExtendAbove: "Estender acima",
  dialogInputExtendBelow: "Estender abaixo",
  dialogInputExtendChannelEnd: "Estender extremidade do canal",
  dialogInputExtendChannelStart: "Estender in\xEDcio do canal",
  dialogInputExtendLeft: "Estender para a esquerda",
  dialogInputExtendLineEnd: "Estender o fim da linha",
  dialogInputExtendLineStart: "Estender in\xEDcio da linha",
  dialogInputExtendRight: "Estender para a direita",
  dialogInputFibonacciBands: "Bandas",
  dialogInputFibonacciBandsAltText: "Bandas de Fibonacci",
  dialogInputFillColorPicker: "Preencher",
  dialogInputFillColorPickerAltText: "Cor de Preenchimento",
  dialogInputFontSize: "Tamanho",
  dialogInputFontSizeAltText: "Tamanho da Fonte",
  dialogInputLineStyle: "Tracejado",
  dialogInputPosition: "Posi\xE7\xE3o",
  dialogInputReverse: "Reverter",
  dialogInputShowFill: "Mostrar preenchimento",
  dialogInputStrokeWidth: "Espessura",
  dialogInputStrokeWidthAltText: "Espessura da Linha",
  iconAltTextAlignCenter: "Centralizar",
  iconAltTextAlignLeft: "Esquerda",
  iconAltTextAlignRight: "Direita",
  iconAltTextClose: "Fechar",
  iconAltTextLineStyleDashed: "Tra\xE7o-longo",
  iconAltTextLineStyleDotted: "Tracejado curto",
  iconAltTextLineStyleSolid: "S\xF3lido",
  iconAltTextPositionBottom: "Inferior",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "Topo",
  inputTextareaPlaceholder: "Adicionar Texto",
  measurerDateRangeBars: "${value}[number] barras",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volume ${value}",
  overlayLoadingData: "Carregando dados...",
  overlayNoData: "Sem dados para exibir",
  overlayNoVisibleSeries: "Nenhuma s\xE9rie vis\xEDvel",
  overlayUnsupportedBrowser: "Vers\xE3o de navegador incompat\xEDvel. Por favor, atualize seu navegador.",
  seriesHistogramTooltipCount: "${yName} (contagem)",
  seriesHistogramTooltipFrequency: "Frequ\xEAncia",
  seriesHistogramTooltipMean: "${yName} (m\xE9dia)",
  seriesHistogramTooltipSum: "${yName} (soma)",
  toolbarAnnotationsArrow: "Seta",
  toolbarAnnotationsArrowDown: "Seta para Baixo",
  toolbarAnnotationsArrowUp: "Seta para cima",
  toolbarAnnotationsCallout: "Anota\xE7\xE3o",
  toolbarAnnotationsClearAll: "Limpar Tudo",
  toolbarAnnotationsComment: "Coment\xE1rio",
  toolbarAnnotationsDatePriceRange: "Data e Pre\xE7o",
  toolbarAnnotationsDateRange: "Intervalo de Datas",
  toolbarAnnotationsDelete: "Excluir",
  toolbarAnnotationsDisjointChannel: "Canal Disjunto",
  toolbarAnnotationsDragHandle: "Arrastar Barra de Ferramentas",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retrocesso",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Linha de Tend\xEAncia Baseada no Fibonacci",
  toolbarAnnotationsFillColor: "Cor de Preenchimento",
  toolbarAnnotationsHorizontalLine: "Linha Horizontal",
  toolbarAnnotationsLineAnnotations: "Linhas de Tend\xEAncia",
  toolbarAnnotationsLineColor: "Cor da Linha",
  toolbarAnnotationsLineStrokeWidth: "Largura da Linha do Tra\xE7o",
  toolbarAnnotationsLineStyle: "Estilo de Linha",
  toolbarAnnotationsLock: "Bloquear",
  toolbarAnnotationsMeasurerAnnotations: "Medidores",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canal Paralelo",
  toolbarAnnotationsPriceRange: "Intervalo de Pre\xE7os",
  toolbarAnnotationsQuickDatePriceRange: "Medir",
  toolbarAnnotationsSettings: "Configura\xE7\xF5es",
  toolbarAnnotationsShapeAnnotations: "Setas",
  toolbarAnnotationsText: "Texto",
  toolbarAnnotationsTextAnnotations: "Anota\xE7\xF5es de Texto",
  toolbarAnnotationsTextColor: "Cor do Texto",
  toolbarAnnotationsTextSize: "Tamanho do Texto",
  toolbarAnnotationsTrendLine: "Linha de Tend\xEAncia",
  toolbarAnnotationsUnlock: "Desbloquear",
  toolbarAnnotationsVerticalLine: "Linha Vertical",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xEAs",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 ano",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 meses",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 meses",
  toolbarRangeAll: "Tudo",
  toolbarRangeAllAria: "Tudo",
  toolbarRangeYearToDate: "YTD",
  toolbarRangeYearToDateAria: "Ano at\xE9 a data",
  toolbarSeriesTypeCandles: "Velas",
  toolbarSeriesTypeDropdown: "Tipo de Gr\xE1fico",
  toolbarSeriesTypeHighLow: "Alta Baixa",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Velas Vazadas",
  toolbarSeriesTypeLine: "Linha",
  toolbarSeriesTypeLineWithMarkers: "Linha com Marcadores",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linha com passos",
  toolbarZoomPanEnd: "Deslocar para o fim",
  toolbarZoomPanLeft: "Mover para a esquerda",
  toolbarZoomPanRight: "Mover para a direita",
  toolbarZoomPanStart: "Mover para o in\xEDcio",
  toolbarZoomReset: "Redefinir o zoom",
  toolbarZoomZoomIn: "Aproximar",
  toolbarZoomZoomOut: "Afastar",
  tooltipPaginationStatus: "${index}[number] de ${count}[number]"
};
var AG_CHARTS_LOCALE_RO_RO = {
  ariaAnnounceChart: "diagram\u0103, ${seriesCount}[number] serii",
  ariaAnnounceFlowProportionLink: "leg\u0103tur\u0103 ${index} din ${count}, de la ${from} la ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nodul ${index} din ${count}, ${description}",
  ariaAnnounceGaugeChart: "grafic indicator, ${caption}",
  ariaAnnounceHierarchyChart: "diagram\u0103 ierarhic\u0103, ${caption}",
  ariaAnnounceHierarchyDatum: "nivel ${level}[number], ${count}[number] copii, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Ap\u0103sa\u021Bi Spa\u021Biu sau Enter pentru a comuta vizibilitatea",
  ariaLabelAddHorizontalLine: "Adaug\u0103 Linie Orizontal\u0103",
  ariaLabelAnnotationOptionsToolbar: "Op\u021Biuni adnotare",
  ariaLabelAnnotationSettingsDialog: "Set\u0103ri Anotare",
  ariaLabelColorPicker: "Selector de culoare",
  ariaLabelFinancialCharts: "Grafice financiare",
  ariaLabelLegend: "Legend\u0103",
  ariaLabelLegendItem: "${label}, Element de legend\u0103 ${index}[number] din ${count}[number]",
  ariaLabelLegendItemUnknown: "Element necunoscut din legend\u0103",
  ariaLabelLegendPageNext: "Pagina urm\u0103toare a legendei",
  ariaLabelLegendPagePrevious: "Pagina precedent\u0103 a legendei",
  ariaLabelLegendPagination: "Pagini legend\u0103",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maxim",
  ariaLabelNavigatorMinimum: "Minim",
  ariaLabelNavigatorRange: "Interval",
  ariaLabelRangesToolbar: "Intervale",
  ariaLabelSettingsTabBar: "Set\u0103ri",
  ariaLabelZoomToolbar: "Zoomare",
  ariaValuePanRange: "${min}[percent0to2dp] la ${max}[percent0to2dp]",
  contextMenuDownload: "Desc\u0103rcare",
  contextMenuPanToCursor: "Mut\u0103 vizualizarea aici",
  contextMenuToggleOtherSeries: "Comut\u0103 alte serii",
  contextMenuToggleSeriesVisibility: "Comutare Vizibilitate",
  contextMenuZoomToCursor: "Zoom la acest punct",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Dat\u0103 \u0219i Pre\u021B",
  dialogHeaderDateRange: "Interval de date",
  dialogHeaderFibonacciRange: "Retragere Fibonacci",
  dialogHeaderLine: "Linie",
  dialogHeaderPriceRange: "Interval de pre\u021B",
  dialogHeaderText: "Text",
  dialogInputAlign: "Aliniaz\u0103",
  dialogInputColorPicker: "Culoare",
  dialogInputColorPickerAltText: "Culoarea textului",
  dialogInputExtendAbove: "Extinde deasupra",
  dialogInputExtendBelow: "Extinde \xEEn jos",
  dialogInputExtendChannelEnd: "Extinde cap\u0103tul canalului",
  dialogInputExtendChannelStart: "Extinde \xEEnceputul canalului",
  dialogInputExtendLeft: "Extinde la st\xE2nga",
  dialogInputExtendLineEnd: "Extinde sf\xE2r\u0219itul liniei",
  dialogInputExtendLineStart: "Extinde \xEEnceputul liniei",
  dialogInputExtendRight: "Extinde spre dreapta",
  dialogInputFibonacciBands: "Benzi",
  dialogInputFibonacciBandsAltText: "Benzi Fibonacci",
  dialogInputFillColorPicker: "Umplere",
  dialogInputFillColorPickerAltText: "Culoare de umplere",
  dialogInputFontSize: "M\u0103rime",
  dialogInputFontSizeAltText: "M\u0103rime font",
  dialogInputLineStyle: "Linie Punctat\u0103",
  dialogInputPosition: "Pozi\u021Bie",
  dialogInputReverse: "Invers",
  dialogInputShowFill: "Afi\u0219eaz\u0103 Umplerea",
  dialogInputStrokeWidth: "Grosime",
  dialogInputStrokeWidthAltText: "Grosimea liniei",
  iconAltTextAlignCenter: "Centrat",
  iconAltTextAlignLeft: "St\xE2nga",
  iconAltTextAlignRight: "Dreapta",
  iconAltTextClose: "\xCEnchide",
  iconAltTextLineStyleDashed: "Lung-tratat",
  iconAltTextLineStyleDotted: "Linie punctat\u0103 scurt\u0103",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Jos",
  iconAltTextPositionCenter: "Centru",
  iconAltTextPositionTop: "Sus",
  inputTextareaPlaceholder: "Ad\u0103uga\u021Bi text",
  measurerDateRangeBars: "${value}[number] bare",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Volumul ${value}",
  overlayLoadingData: "Se \xEEncarc\u0103 datele...",
  overlayNoData: "Nicio dat\u0103 de afi\u0219at",
  overlayNoVisibleSeries: "Nicio serie vizibil\u0103",
  overlayUnsupportedBrowser: "Versiune de browser incompatibil\u0103. V\u0103 rug\u0103m s\u0103 actualiza\u021Bi browserul.",
  seriesHistogramTooltipCount: "${yName} (num\u0103r)",
  seriesHistogramTooltipFrequency: "Frecven\u021B\u0103",
  seriesHistogramTooltipMean: "${yName} (medie)",
  seriesHistogramTooltipSum: "${yName} (suma)",
  toolbarAnnotationsArrow: "S\u0103geat\u0103",
  toolbarAnnotationsArrowDown: "S\u0103geat\u0103 \xEEn jos",
  toolbarAnnotationsArrowUp: "S\u0103geat\u0103 \xEEn sus",
  toolbarAnnotationsCallout: "Anotare",
  toolbarAnnotationsClearAll: "\u0218terge tot",
  toolbarAnnotationsComment: "Comentariu",
  toolbarAnnotationsDatePriceRange: "Dat\u0103 \u0219i Pre\u021B",
  toolbarAnnotationsDateRange: "Interval de date",
  toolbarAnnotationsDelete: "\u0218terge",
  toolbarAnnotationsDisjointChannel: "Canal separat",
  toolbarAnnotationsDragHandle: "Trage\u021Bi bara de instrumente",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retragere Fibonacci",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Bazat pe Trend",
  toolbarAnnotationsFillColor: "Culoare de umplere",
  toolbarAnnotationsHorizontalLine: "Linie orizontal\u0103",
  toolbarAnnotationsLineAnnotations: "Linii de tendin\u021B\u0103",
  toolbarAnnotationsLineColor: "Culoare Linie",
  toolbarAnnotationsLineStrokeWidth: "Grosimea Liniei",
  toolbarAnnotationsLineStyle: "Stil linie",
  toolbarAnnotationsLock: "Blocare",
  toolbarAnnotationsMeasurerAnnotations: "M\u0103sur\u0103tori",
  toolbarAnnotationsNote: "Not\u0103",
  toolbarAnnotationsParallelChannel: "Canal paralel",
  toolbarAnnotationsPriceRange: "Interval de pre\u021B",
  toolbarAnnotationsQuickDatePriceRange: "M\u0103sur\u0103",
  toolbarAnnotationsSettings: "Set\u0103ri",
  toolbarAnnotationsShapeAnnotations: "S\u0103ge\u021Bi",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Adnot\u0103ri text",
  toolbarAnnotationsTextColor: "Culoarea textului",
  toolbarAnnotationsTextSize: "Dimensiune text",
  toolbarAnnotationsTrendLine: "Linie de tendin\u021B\u0103",
  toolbarAnnotationsUnlock: "Deblocare",
  toolbarAnnotationsVerticalLine: "Linie Vertical\u0103",
  toolbarRange1Month: "1L",
  toolbarRange1MonthAria: "1 lun\u0103",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 an",
  toolbarRange3Months: "3L",
  toolbarRange3MonthsAria: "3 luni",
  toolbarRange6Months: "6L",
  toolbarRange6MonthsAria: "6 luni",
  toolbarRangeAll: "Total",
  toolbarRangeAllAria: "Toate",
  toolbarRangeYearToDate: "An p\xE2n\u0103 \xEEn prezent",
  toolbarRangeYearToDateAria: "Anul p\xE2n\u0103 \xEEn prezent",
  toolbarSeriesTypeCandles: "Lum\xE2n\u0103ri",
  toolbarSeriesTypeDropdown: "Tip de diagram\u0103",
  toolbarSeriesTypeHighLow: "High Low",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Lum\xE2n\u0103ri goale",
  toolbarSeriesTypeLine: "Linie",
  toolbarSeriesTypeLineWithMarkers: "Linie cu Marcatori",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Linie \xEEn trepte",
  toolbarZoomPanEnd: "Deruleaz\u0103 p\xE2n\u0103 la sf\xE2r\u0219it",
  toolbarZoomPanLeft: "Panoramare spre st\xE2nga",
  toolbarZoomPanRight: "Panoramare la dreapta",
  toolbarZoomPanStart: "Panoramare la \xEEnceput",
  toolbarZoomReset: "Reseteaz\u0103 zoom-ul",
  toolbarZoomZoomIn: "M\u0103rire",
  toolbarZoomZoomOut: "Mic\u0219oreaz\u0103",
  tooltipPaginationStatus: "${index}[number] din ${count}[number]"
};
var AG_CHARTS_LOCALE_SK_SK = {
  ariaAnnounceChart: "graf, ${seriesCount}[number] s\xE9ri\xED",
  ariaAnnounceFlowProportionLink: "odkaz ${index} z ${count}, od ${from} do ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "uzol ${index} z ${count}, ${description}",
  ariaAnnounceGaugeChart: "stupnicov\xFD graf, ${caption}",
  ariaAnnounceHierarchyChart: "hierarchick\xFD graf, ${caption}",
  ariaAnnounceHierarchyDatum: "\xFArove\u0148 ${level}[number], ${count}[number] det\xED, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Stla\u010Den\xEDm medzern\xEDka alebo kl\xE1vesy Enter prepnete vidite\u013Enos\u0165",
  ariaLabelAddHorizontalLine: "Prida\u0165 vodorovn\xFA \u010Diaru",
  ariaLabelAnnotationOptionsToolbar: "Mo\u017Enosti anot\xE1cie",
  ariaLabelAnnotationSettingsDialog: "Nastavenia anot\xE1ci\xED",
  ariaLabelColorPicker: "V\xFDber farby",
  ariaLabelFinancialCharts: "Finan\u010Dn\xE9 grafy",
  ariaLabelLegend: "Legenda",
  ariaLabelLegendItem: "${label}, Polo\u017Eka legendy ${index}[number] z ${count}[number]",
  ariaLabelLegendItemUnknown: "Nezn\xE1ma polo\u017Eka legendy",
  ariaLabelLegendPageNext: "\u010Eal\u0161ia strana legendy",
  ariaLabelLegendPagePrevious: "Predch\xE1dzaj\xFAca str\xE1nka legendy",
  ariaLabelLegendPagination: "Str\xE1nkovanie legendy",
  ariaLabelNavigator: "Navig\xE1tor",
  ariaLabelNavigatorMaximum: "Maximum",
  ariaLabelNavigatorMinimum: "Minim\xE1lne",
  ariaLabelNavigatorRange: "Rozsah",
  ariaLabelRangesToolbar: "Rozsahy",
  ariaLabelSettingsTabBar: "Nastavenia",
  ariaLabelZoomToolbar: "Pribl\xED\u017Ei\u0165",
  ariaValuePanRange: "${min}[percent0to2dp] do ${max}[percent0to2dp]",
  contextMenuDownload: "Stiahnu\u0165",
  contextMenuPanToCursor: "Posun\xFA\u0165 sem",
  contextMenuToggleOtherSeries: "Prepn\xFA\u0165 in\xE9 s\xE9rie",
  contextMenuToggleSeriesVisibility: "Prepn\xFA\u0165 vidite\u013Enos\u0165",
  contextMenuZoomToCursor: "Pribl\xED\u017Ei\u0165 sem",
  dialogHeaderChannel: "Kan\xE1l",
  dialogHeaderDatePriceRange: "D\xE1tum a cena",
  dialogHeaderDateRange: "Rozsah d\xE1tumov",
  dialogHeaderFibonacciRange: "Fib Oprava",
  dialogHeaderLine: "\u010Ciara",
  dialogHeaderPriceRange: "Cenov\xE9 rozp\xE4tie",
  dialogHeaderText: "Text",
  dialogInputAlign: "Zarovna\u0165",
  dialogInputColorPicker: "Farba",
  dialogInputColorPickerAltText: "Farba textu",
  dialogInputExtendAbove: "Roz\u0161\xEDri\u0165 nad",
  dialogInputExtendBelow: "Roz\u0161\xEDri\u0165 nadol",
  dialogInputExtendChannelEnd: "Roz\u0161\xEDri\u0165 koniec kan\xE1la",
  dialogInputExtendChannelStart: "Pred\u013A\u017Ei\u0165 za\u010Diatok kan\xE1la",
  dialogInputExtendLeft: "Roz\u0161\xEDri\u0165 do\u013Eava",
  dialogInputExtendLineEnd: "Pred\u013A\u017Ei\u0165 koniec \u010Diary",
  dialogInputExtendLineStart: "Pred\u013A\u017Ei\u0165 za\u010Diatok \u010Diary",
  dialogInputExtendRight: "Roz\u0161\xEDri\u0165 doprava",
  dialogInputFibonacciBands: "P\xE1sma",
  dialogInputFibonacciBandsAltText: "Fibonacciho p\xE1sma",
  dialogInputFillColorPicker: "Vyplni\u0165",
  dialogInputFillColorPickerAltText: "Farba v\xFDplne",
  dialogInputFontSize: "Ve\u013Ekos\u0165",
  dialogInputFontSizeAltText: "Ve\u013Ekos\u0165 p\xEDsma",
  dialogInputLineStyle: "\u010Ciarkovan\xFD",
  dialogInputPosition: "Poz\xEDcia",
  dialogInputReverse: "Opa\u010Dne",
  dialogInputShowFill: "Zobrazi\u0165 v\xFDpl\u0148",
  dialogInputStrokeWidth: "Hr\xFAbka \u010Diary",
  dialogInputStrokeWidthAltText: "Hr\xFAbka l\xEDnie",
  iconAltTextAlignCenter: "Centrova\u0165",
  iconAltTextAlignLeft: "V\u013Eavo",
  iconAltTextAlignRight: "Vpravo",
  iconAltTextClose: "Zavrie\u0165",
  iconAltTextLineStyleDashed: "Dlh\xE9 poml\u010Dky",
  iconAltTextLineStyleDotted: "Kr\xE1tka poml\u010Dka",
  iconAltTextLineStyleSolid: "Pln\xE1",
  iconAltTextPositionBottom: "Dno",
  iconAltTextPositionCenter: "Stred",
  iconAltTextPositionTop: "Horn\xE1",
  inputTextareaPlaceholder: "Prida\u0165 text",
  measurerDateRangeBars: "${value}[number] pruhy",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Objem ${value}",
  overlayLoadingData: "Na\u010D\xEDtavam \xFAdaje...",
  overlayNoData: "\u017Diadne \xFAdaje na zobrazenie",
  overlayNoVisibleSeries: "\u017Diadna vidite\u013En\xE1 s\xE9ria",
  overlayUnsupportedBrowser: "Nezlu\u010Dite\u013En\xE1 verzia prehliada\u010Da. Pros\xEDm, aktualizujte si prehliada\u010D.",
  seriesHistogramTooltipCount: "${yName} (po\u010Det)",
  seriesHistogramTooltipFrequency: "Frekvencia",
  seriesHistogramTooltipMean: "${yName} (priemer)",
  seriesHistogramTooltipSum: "${yName} (s\xFA\u010Det)",
  toolbarAnnotationsArrow: "\u0160\xEDpka",
  toolbarAnnotationsArrowDown: "\u0160\xEDpka dole",
  toolbarAnnotationsArrowUp: "\u0160\xEDpka hore",
  toolbarAnnotationsCallout: "Popis",
  toolbarAnnotationsClearAll: "Vymaza\u0165 v\u0161etko",
  toolbarAnnotationsComment: "Koment\xE1r",
  toolbarAnnotationsDatePriceRange: "D\xE1tum a cena",
  toolbarAnnotationsDateRange: "\u010Casov\xE9 obdobie",
  toolbarAnnotationsDelete: "Vymaza\u0165",
  toolbarAnnotationsDisjointChannel: "Nez\xE1visl\xFD kan\xE1l",
  toolbarAnnotationsDragHandle: "\u0164aha\u0165 panel n\xE1strojov",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Based na z\xE1klade trendu",
  toolbarAnnotationsFillColor: "Farba v\xFDplne",
  toolbarAnnotationsHorizontalLine: "Horizont\xE1lna \u010Diara",
  toolbarAnnotationsLineAnnotations: "Trendov\xE9 \u010Diary",
  toolbarAnnotationsLineColor: "Farba \u010Diary",
  toolbarAnnotationsLineStrokeWidth: "\u0160\xEDrka \u010Diarov\xE9ho \u0165ahu",
  toolbarAnnotationsLineStyle: "\u0160t\xFDl \u010Diary",
  toolbarAnnotationsLock: "Zamkn\xFA\u0165",
  toolbarAnnotationsMeasurerAnnotations: "Merania",
  toolbarAnnotationsNote: "Pozn\xE1mka",
  toolbarAnnotationsParallelChannel: "Paraleln\xFD kan\xE1l",
  toolbarAnnotationsPriceRange: "Cenov\xFD rozsah",
  toolbarAnnotationsQuickDatePriceRange: "Zmera\u0165",
  toolbarAnnotationsSettings: "Nastavenia",
  toolbarAnnotationsShapeAnnotations: "\u0160\xEDpky",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textov\xE9 anot\xE1cie",
  toolbarAnnotationsTextColor: "Farba textu",
  toolbarAnnotationsTextSize: "Ve\u013Ekos\u0165 textu",
  toolbarAnnotationsTrendLine: "Trendov\xE1 \u010Diara",
  toolbarAnnotationsUnlock: "Odomkn\xFA\u0165",
  toolbarAnnotationsVerticalLine: "Zvisl\xE1 \u010Diara",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mesiac",
  toolbarRange1Year: "1R",
  toolbarRange1YearAria: "1 rok",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 mesiace",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 mesiacov",
  toolbarRangeAll: "V\u0161etky",
  toolbarRangeAllAria: "V\u0161etko",
  toolbarRangeYearToDate: "Od za\u010Diatku roka",
  toolbarRangeYearToDateAria: "Rok do dne\u0161n\xE9ho d\u0148a",
  toolbarSeriesTypeCandles: "Svie\u010Dky",
  toolbarSeriesTypeDropdown: "Typ grafu",
  toolbarSeriesTypeHighLow: "Vysok\xFD N\xEDzky",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Pr\xE1zdne svie\u010Dky",
  toolbarSeriesTypeLine: "\u010Ciara",
  toolbarSeriesTypeLineWithMarkers: "\u010Ciara so zna\u010Dkami",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Schodiskov\xFD graf",
  toolbarZoomPanEnd: "Posun\xFA\u0165 na koniec",
  toolbarZoomPanLeft: "Posun\xFA\u0165 do\u013Eava",
  toolbarZoomPanRight: "Posun\xFA\u0165 doprava",
  toolbarZoomPanStart: "Posun na za\u010Diatok",
  toolbarZoomReset: "Obnovi\u0165 pribl\xED\u017Eenie",
  toolbarZoomZoomIn: "Pribl\xED\u017Ei\u0165",
  toolbarZoomZoomOut: "Oddiali\u0165",
  tooltipPaginationStatus: "${index}[number] z ${count}[number]"
};
var AG_CHARTS_LOCALE_SV_SE = {
  ariaAnnounceChart: "diagram, ${seriesCount}[number] serier",
  ariaAnnounceFlowProportionLink: "l\xE4nk ${index} av ${count}, fr\xE5n ${from} till ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nod ${index} av ${count}, ${description}",
  ariaAnnounceGaugeChart: "m\xE4targraf, ${caption}",
  ariaAnnounceHierarchyChart: "hierarkidiagram, ${caption}",
  ariaAnnounceHierarchyDatum: "niv\xE5 ${level}[number], ${count}[number] barn, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Tryck p\xE5 Space eller Enter f\xF6r att v\xE4xla synlighet",
  ariaLabelAddHorizontalLine: "L\xE4gg till horisontell linje",
  ariaLabelAnnotationOptionsToolbar: "Alternativ f\xF6r annotering",
  ariaLabelAnnotationSettingsDialog: "Inst\xE4llningar f\xF6r anteckningar",
  ariaLabelColorPicker: "F\xE4rgv\xE4ljare",
  ariaLabelFinancialCharts: "Finansiella diagram",
  ariaLabelLegend: "Teckenf\xF6rklaring",
  ariaLabelLegendItem: "${label}, Legend objekt ${index}[number] av ${count}[number]",
  ariaLabelLegendItemUnknown: "Ok\xE4nd legendpost",
  ariaLabelLegendPageNext: "N\xE4sta legend sida",
  ariaLabelLegendPagePrevious: "F\xF6reg\xE5ende legendasida",
  ariaLabelLegendPagination: "Legend Paginerings",
  ariaLabelNavigator: "Navigator",
  ariaLabelNavigatorMaximum: "Maximal",
  ariaLabelNavigatorMinimum: "Minsta",
  ariaLabelNavigatorRange: "R\xE4ckvidd",
  ariaLabelRangesToolbar: "Omr\xE5den",
  ariaLabelSettingsTabBar: "Inst\xE4llningar",
  ariaLabelZoomToolbar: "Zooma",
  ariaValuePanRange: "${min}[percent0to2dp] till ${max}[percent0to2dp]",
  contextMenuDownload: "Ladda ner",
  contextMenuPanToCursor: "Panorera hit",
  contextMenuToggleOtherSeries: "V\xE4xla andra serier",
  contextMenuToggleSeriesVisibility: "V\xE4xla synlighet",
  contextMenuZoomToCursor: "Zooma hit",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Datum och pris",
  dialogHeaderDateRange: "Datumintervall",
  dialogHeaderFibonacciRange: "Fib \xC5terh\xE4mtning",
  dialogHeaderLine: "Linje",
  dialogHeaderPriceRange: "Prisklass",
  dialogHeaderText: "Text",
  dialogInputAlign: "Justering",
  dialogInputColorPicker: "F\xE4rg",
  dialogInputColorPickerAltText: "Textf\xE4rg",
  dialogInputExtendAbove: "F\xF6rl\xE4ng ovan",
  dialogInputExtendBelow: "F\xF6rl\xE4ng nedanf\xF6r",
  dialogInputExtendChannelEnd: "F\xF6rl\xE4ng kanalens slut",
  dialogInputExtendChannelStart: "Ut\xF6ka kanalstart",
  dialogInputExtendLeft: "F\xF6rl\xE4ng \xE5t v\xE4nster",
  dialogInputExtendLineEnd: "F\xF6rl\xE4ng linjens slut",
  dialogInputExtendLineStart: "F\xF6rl\xE4ng linjens start",
  dialogInputExtendRight: "Str\xE4ck ut \xE5t h\xF6ger",
  dialogInputFibonacciBands: "Bander",
  dialogInputFibonacciBandsAltText: "Fibonacci-band",
  dialogInputFillColorPicker: "Fyll",
  dialogInputFillColorPickerAltText: "Fyllnadsf\xE4rg",
  dialogInputFontSize: "Storlek",
  dialogInputFontSizeAltText: "Teckenstorlek",
  dialogInputLineStyle: "Streck",
  dialogInputPosition: "Position",
  dialogInputReverse: "Omv\xE4nd",
  dialogInputShowFill: "Visa fyllning",
  dialogInputStrokeWidth: "Vikt",
  dialogInputStrokeWidthAltText: "Linjens vikt",
  iconAltTextAlignCenter: "Centrera",
  iconAltTextAlignLeft: "V\xE4nster",
  iconAltTextAlignRight: "H\xF6ger",
  iconAltTextClose: "St\xE4ng",
  iconAltTextLineStyleDashed: "L\xE5ngstreckad",
  iconAltTextLineStyleDotted: "Kortstreckad",
  iconAltTextLineStyleSolid: "Solid",
  iconAltTextPositionBottom: "Botten",
  iconAltTextPositionCenter: "Center",
  iconAltTextPositionTop: "Topp",
  inputTextareaPlaceholder: "L\xE4gg till text",
  measurerDateRangeBars: "${value}[number] staplar",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Laddar data...",
  overlayNoData: "Inga data att visa",
  overlayNoVisibleSeries: "Inga synliga serier",
  overlayUnsupportedBrowser: "Inkompatibel webbl\xE4sarversion. Var god uppgradera din webbl\xE4sare.",
  seriesHistogramTooltipCount: "${yName} (antal)",
  seriesHistogramTooltipFrequency: "Frekvens",
  seriesHistogramTooltipMean: "${yName} (medelv\xE4rde)",
  seriesHistogramTooltipSum: "${yName} (summa)",
  toolbarAnnotationsArrow: "Pil",
  toolbarAnnotationsArrowDown: "Pilen ned",
  toolbarAnnotationsArrowUp: "Pil Upp",
  toolbarAnnotationsCallout: "Anm\xE4rkning",
  toolbarAnnotationsClearAll: "Rensa alla",
  toolbarAnnotationsComment: "Kommentar",
  toolbarAnnotationsDatePriceRange: "Datum och pris",
  toolbarAnnotationsDateRange: "Datumintervall",
  toolbarAnnotationsDelete: "Ta bort",
  toolbarAnnotationsDisjointChannel: "Oberoende Kanal",
  toolbarAnnotationsDragHandle: "Dra Verktygsf\xE4lt",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib-retracement",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib baserat p\xE5 trend",
  toolbarAnnotationsFillColor: "Fyllnadsf\xE4rg",
  toolbarAnnotationsHorizontalLine: "Horisontell linje",
  toolbarAnnotationsLineAnnotations: "Trendlinjer",
  toolbarAnnotationsLineColor: "Linjef\xE4rg",
  toolbarAnnotationsLineStrokeWidth: "Linjens tjocklek",
  toolbarAnnotationsLineStyle: "Linjestil",
  toolbarAnnotationsLock: "L\xE5s",
  toolbarAnnotationsMeasurerAnnotations: "M\xE4tverktyg",
  toolbarAnnotationsNote: "Notering",
  toolbarAnnotationsParallelChannel: "Parallell kanal",
  toolbarAnnotationsPriceRange: "Prisspann",
  toolbarAnnotationsQuickDatePriceRange: "M\xE4ta",
  toolbarAnnotationsSettings: "Inst\xE4llningar",
  toolbarAnnotationsShapeAnnotations: "Pilar",
  toolbarAnnotationsText: "Text",
  toolbarAnnotationsTextAnnotations: "Textnoteringar",
  toolbarAnnotationsTextColor: "Textf\xE4rg",
  toolbarAnnotationsTextSize: "Textstorlek",
  toolbarAnnotationsTrendLine: "Trendlinje",
  toolbarAnnotationsUnlock: "L\xE5s upp",
  toolbarAnnotationsVerticalLine: "Vertikal linje",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 m\xE5nad",
  toolbarRange1Year: "1\xC5",
  toolbarRange1YearAria: "1 \xE5r",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 m\xE5nader",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 m\xE5nader",
  toolbarRangeAll: "Alla",
  toolbarRangeAllAria: "Alla",
  toolbarRangeYearToDate: "\xC5TD",
  toolbarRangeYearToDateAria: "\xC5r till idag",
  toolbarSeriesTypeCandles: "Ljus",
  toolbarSeriesTypeDropdown: "Diagramtyp",
  toolbarSeriesTypeHighLow: "H\xF6g L\xE5g",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Hollow Candles",
  toolbarSeriesTypeLine: "Linje",
  toolbarSeriesTypeLineWithMarkers: "Linje med mark\xF6rer",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Steg Linje",
  toolbarZoomPanEnd: "Panorera till slutet",
  toolbarZoomPanLeft: "Panorera v\xE4nster",
  toolbarZoomPanRight: "Panorera h\xF6ger",
  toolbarZoomPanStart: "Panorera till b\xF6rjan",
  toolbarZoomReset: "\xC5terst\xE4ll zoom",
  toolbarZoomZoomIn: "Zooma in",
  toolbarZoomZoomOut: "Zooma ut",
  tooltipPaginationStatus: "${index}[number] av ${count}[number]"
};
var AG_CHARTS_LOCALE_TR_TR = {
  ariaAnnounceChart: "grafik, ${seriesCount}[number] seri",
  ariaAnnounceFlowProportionLink: "ba\u011Flant\u0131 ${index} / ${count}, ${from} - ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "d\xFC\u011F\xFCm ${index} / ${count}, ${description}",
  ariaAnnounceGaugeChart: "g\xF6sterge grafik, ${caption}",
  ariaAnnounceHierarchyChart: "hiyerar\u015Fi grafi\u011Fi, ${caption}",
  ariaAnnounceHierarchyDatum: "seviye ${level}[number], ${count}[number] \xE7ocuk, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "G\xF6r\xFCn\xFCrl\xFC\u011F\xFC de\u011Fi\u015Ftirmek i\xE7in Bo\u015Fluk veya Enter tu\u015Funa bas\u0131n",
  ariaLabelAddHorizontalLine: "Yatay \xC7izgi Ekle",
  ariaLabelAnnotationOptionsToolbar: "Ek A\xE7\u0131klama Se\xE7enekleri",
  ariaLabelAnnotationSettingsDialog: "Ek A\xE7\u0131klama Ayarlar\u0131",
  ariaLabelColorPicker: "Renk se\xE7ici",
  ariaLabelFinancialCharts: "Finansal Grafikler",
  ariaLabelLegend: "Efsane",
  ariaLabelLegendItem: "${label}, Lejant \xF6\u011Fesi ${index}[number] of ${count}[number]",
  ariaLabelLegendItemUnknown: "Bilinmeyen efsane \xF6\u011Fesi",
  ariaLabelLegendPageNext: "Sonraki Efsane Sayfas\u0131",
  ariaLabelLegendPagePrevious: "\xD6nceki Efsane Sayfas\u0131",
  ariaLabelLegendPagination: "Efsane Sayfalama",
  ariaLabelNavigator: "Gezgin",
  ariaLabelNavigatorMaximum: "Maksimum",
  ariaLabelNavigatorMinimum: "Minimum",
  ariaLabelNavigatorRange: "Aral\u0131k",
  ariaLabelRangesToolbar: "Aral\u0131klar",
  ariaLabelSettingsTabBar: "Ayarlar",
  ariaLabelZoomToolbar: "Yak\u0131nla\u015Ft\u0131r",
  ariaValuePanRange: "${min}[percent0to2dp] ile ${max}[percent0to2dp] aras\u0131",
  contextMenuDownload: "\u0130ndir",
  contextMenuPanToCursor: "Buraya kayd\u0131r",
  contextMenuToggleOtherSeries: "Di\u011Fer Serileri De\u011Fi\u015Ftir",
  contextMenuToggleSeriesVisibility: "G\xF6r\xFCn\xFCrl\xFC\u011F\xFC De\u011Fi\u015Ftir",
  contextMenuZoomToCursor: "Buraya yak\u0131nla\u015Ft\u0131r",
  dialogHeaderChannel: "Kanal",
  dialogHeaderDatePriceRange: "Tarih ve Fiyat",
  dialogHeaderDateRange: "Tarih Aral\u0131\u011F\u0131",
  dialogHeaderFibonacciRange: "Fib Geri \xC7ekilme",
  dialogHeaderLine: "\xC7izgi",
  dialogHeaderPriceRange: "Fiyat Aral\u0131\u011F\u0131",
  dialogHeaderText: "Metin",
  dialogInputAlign: "Hizala",
  dialogInputColorPicker: "Renk",
  dialogInputColorPickerAltText: "Metin Rengi",
  dialogInputExtendAbove: "\xDCst\xFCne geni\u015Flet",
  dialogInputExtendBelow: "A\u015Fa\u011F\u0131ya geni\u015Flet",
  dialogInputExtendChannelEnd: "Kanal sonunu uzat",
  dialogInputExtendChannelStart: "Kanal ba\u015Flang\u0131c\u0131n\u0131 uzat",
  dialogInputExtendLeft: "Sola uzat",
  dialogInputExtendLineEnd: "\xC7izgi ucunu uzat",
  dialogInputExtendLineStart: "\xC7izgi ba\u015Flang\u0131c\u0131n\u0131 uzat",
  dialogInputExtendRight: "Sa\u011Fa geni\u015Flet",
  dialogInputFibonacciBands: "Bantlar",
  dialogInputFibonacciBandsAltText: "Fibonacci Bantlar\u0131",
  dialogInputFillColorPicker: "Doldur",
  dialogInputFillColorPickerAltText: "Doldurma Rengi",
  dialogInputFontSize: "Yaz\u0131 tipi boyutu",
  dialogInputFontSizeAltText: "Yaz\u0131 Boyutu",
  dialogInputLineStyle: "Tire",
  dialogInputPosition: "Konum",
  dialogInputReverse: "Ters \xC7evir",
  dialogInputShowFill: "Dolguyu G\xF6ster",
  dialogInputStrokeWidth: "\xC7izgi Kal\u0131nl\u0131\u011F\u0131",
  dialogInputStrokeWidthAltText: "\xC7izgi A\u011F\u0131rl\u0131\u011F\u0131",
  iconAltTextAlignCenter: "Ortala",
  iconAltTextAlignLeft: "Sola",
  iconAltTextAlignRight: "Sa\u011Fa",
  iconAltTextClose: "Kapat",
  iconAltTextLineStyleDashed: "Uzun tireli",
  iconAltTextLineStyleDotted: "K\u0131sa \xE7izgili",
  iconAltTextLineStyleSolid: "D\xFCz",
  iconAltTextPositionBottom: "Alt",
  iconAltTextPositionCenter: "Merkez",
  iconAltTextPositionTop: "\xDCst",
  inputTextareaPlaceholder: "Metin Ekle",
  measurerDateRangeBars: "${value}[number] \xE7ubuk",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Hacim ${value}",
  overlayLoadingData: "Veriler y\xFCkleniyor...",
  overlayNoData: "G\xF6sterilecek veri yok",
  overlayNoVisibleSeries: "G\xF6r\xFCnen seri yok",
  overlayUnsupportedBrowser: "Uyumsuz taray\u0131c\u0131 s\xFCr\xFCm\xFC. L\xFCtfen taray\u0131c\u0131n\u0131z\u0131 y\xFCkseltin.",
  seriesHistogramTooltipCount: "${yName} (say\u0131m)",
  seriesHistogramTooltipFrequency: "Frekans",
  seriesHistogramTooltipMean: "${yName} (ortalama)",
  seriesHistogramTooltipSum: "${yName} (toplam)",
  toolbarAnnotationsArrow: "Ok",
  toolbarAnnotationsArrowDown: "A\u015Fa\u011F\u0131 Ok",
  toolbarAnnotationsArrowUp: "Yukar\u0131 Ok",
  toolbarAnnotationsCallout: "Balon",
  toolbarAnnotationsClearAll: "Hepsini Temizle",
  toolbarAnnotationsComment: "Yorum",
  toolbarAnnotationsDatePriceRange: "Tarih ve Fiyat",
  toolbarAnnotationsDateRange: "Tarih Aral\u0131\u011F\u0131",
  toolbarAnnotationsDelete: "Sil",
  toolbarAnnotationsDisjointChannel: "Ayr\u0131k Kanal",
  toolbarAnnotationsDragHandle: "Ara\xE7 \xC7ubu\u011Funu S\xFCr\xFCkle",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib D\xFCzeltme",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Fib Trend Tabanl\u0131",
  toolbarAnnotationsFillColor: "Doldurma Rengi",
  toolbarAnnotationsHorizontalLine: "Yatay \xC7izgi",
  toolbarAnnotationsLineAnnotations: "Trend \xC7izgileri",
  toolbarAnnotationsLineColor: "\xC7izgi Rengi",
  toolbarAnnotationsLineStrokeWidth: "\xC7izgi Kal\u0131nl\u0131\u011F\u0131",
  toolbarAnnotationsLineStyle: "\xC7izgi Stili",
  toolbarAnnotationsLock: "Kilitle",
  toolbarAnnotationsMeasurerAnnotations: "\xD6l\xE7\xFCmc\xFCler",
  toolbarAnnotationsNote: "Not",
  toolbarAnnotationsParallelChannel: "Paralel Kanal",
  toolbarAnnotationsPriceRange: "Fiyat Aral\u0131\u011F\u0131",
  toolbarAnnotationsQuickDatePriceRange: "\xD6l\xE7\xFC",
  toolbarAnnotationsSettings: "Ayarlar",
  toolbarAnnotationsShapeAnnotations: "Oklar",
  toolbarAnnotationsText: "Metin",
  toolbarAnnotationsTextAnnotations: "Metin A\xE7\u0131klamalar\u0131",
  toolbarAnnotationsTextColor: "Metin Rengi",
  toolbarAnnotationsTextSize: "Yaz\u0131 Boyutu",
  toolbarAnnotationsTrendLine: "Trend \xC7izgisi",
  toolbarAnnotationsUnlock: "Kilidi A\xE7",
  toolbarAnnotationsVerticalLine: "Dikey \xC7izgi",
  toolbarRange1Month: "1A",
  toolbarRange1MonthAria: "1 ay",
  toolbarRange1Year: "1Y",
  toolbarRange1YearAria: "1 y\u0131l",
  toolbarRange3Months: "3A",
  toolbarRange3MonthsAria: "3 ay",
  toolbarRange6Months: "6A",
  toolbarRange6MonthsAria: "6 ay",
  toolbarRangeAll: "T\xFCm\xFC",
  toolbarRangeAllAria: "T\xFCm\xFC",
  toolbarRangeYearToDate: "YTD'ye Kadar",
  toolbarRangeYearToDateAria: "Y\u0131l ba\u015F\u0131ndan bu yana",
  toolbarSeriesTypeCandles: "Mumlar",
  toolbarSeriesTypeDropdown: "Grafik T\xFCr\xFC",
  toolbarSeriesTypeHighLow: "Y\xFCksek D\xFC\u015F\xFCk",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Bo\u015F Mumlar",
  toolbarSeriesTypeLine: "\xC7izgi",
  toolbarSeriesTypeLineWithMarkers: "\u0130\u015Faretlerle \xC7izgi",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "Basamak \xC7izgisi",
  toolbarZoomPanEnd: "En sona kayd\u0131r",
  toolbarZoomPanLeft: "Sola kayd\u0131r",
  toolbarZoomPanRight: "Sa\u011Fa kayd\u0131r",
  toolbarZoomPanStart: "Ba\u015Flang\u0131ca kayd\u0131r",
  toolbarZoomReset: "Yak\u0131nla\u015Ft\u0131rmay\u0131 s\u0131f\u0131rla",
  toolbarZoomZoomIn: "Yak\u0131nla\u015Ft\u0131r",
  toolbarZoomZoomOut: "Uzakla\u015Ft\u0131r",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
var AG_CHARTS_LOCALE_UK_UA = {
  ariaAnnounceChart: "\u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0430, ${seriesCount}[number] \u0441\u0435\u0440\u0456\u0439",
  ariaAnnounceFlowProportionLink: "\u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F ${index} \u0437 ${count}, \u0432\u0456\u0434 ${from} \u0434\u043E ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u0432\u0443\u0437\u043E\u043B ${index} \u0437 ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0430 \u0446\u0438\u0444\u0435\u0440\u0431\u043B\u0430\u0442\u0430, ${caption}",
  ariaAnnounceHierarchyChart: "\u0456\u0454\u0440\u0430\u0440\u0445\u0456\u0447\u043D\u0430 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0430, ${caption}",
  ariaAnnounceHierarchyDatum: "\u0440\u0456\u0432\u0435\u043D\u044C ${level}[number], ${count}[number] \u0434\u043E\u0447\u0456\u0440\u043D\u0456, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u041D\u0430\u0442\u0438\u0441\u043D\u0456\u0442\u044C \u043F\u0440\u043E\u0431\u0456\u043B \u0430\u0431\u043E Enter, \u0449\u043E\u0431 \u043F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u0432\u0438\u0434\u0438\u043C\u0456\u0441\u0442\u044C",
  ariaLabelAddHorizontalLine: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0433\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0443 \u043B\u0456\u043D\u0456\u044E",
  ariaLabelAnnotationOptionsToolbar: "\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438 \u0430\u043D\u043E\u0442\u0430\u0446\u0456\u0439",
  ariaLabelAnnotationSettingsDialog: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0430\u043D\u043E\u0442\u0430\u0446\u0456\u0439",
  ariaLabelColorPicker: "\u0412\u0438\u0431\u0456\u0440 \u043A\u043E\u043B\u044C\u043E\u0440\u0443",
  ariaLabelFinancialCharts: "\u0424\u0456\u043D\u0430\u043D\u0441\u043E\u0432\u0456 \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438",
  ariaLabelLegend: "\u041B\u0435\u0433\u0435\u043D\u0434\u0430",
  ariaLabelLegendItem: "${label}, \u0415\u043B\u0435\u043C\u0435\u043D\u0442 \u043B\u0435\u0433\u0435\u043D\u0434\u0438 ${index}[number] \u0437 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 \u0435\u043B\u0435\u043C\u0435\u043D\u0442 \u043B\u0435\u0433\u0435\u043D\u0434\u0438",
  ariaLabelLegendPageNext: "\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0430 \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043B\u0435\u0433\u0435\u043D\u0434\u0438",
  ariaLabelLegendPagePrevious: "\u041F\u043E\u043F\u0435\u0440\u0435\u0434\u043D\u044F \u0441\u0442\u043E\u0440\u0456\u043D\u043A\u0430 \u043B\u0435\u0433\u0435\u043D\u0434\u0438",
  ariaLabelLegendPagination: "\u041F\u0430\u0433\u0456\u043D\u0430\u0446\u0456\u044F \u043B\u0435\u0433\u0435\u043D\u0434\u0438",
  ariaLabelNavigator: "\u041D\u0430\u0432\u0456\u0433\u0430\u0442\u043E\u0440",
  ariaLabelNavigatorMaximum: "\u041C\u0430\u043A\u0441\u0438\u043C\u0443\u043C",
  ariaLabelNavigatorMinimum: "\u041C\u0456\u043D\u0456\u043C\u0443\u043C",
  ariaLabelNavigatorRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D",
  ariaLabelRangesToolbar: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D\u0438",
  ariaLabelSettingsTabBar: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
  ariaLabelZoomToolbar: "\u041C\u0430\u0441\u0448\u0442\u0430\u0431",
  ariaValuePanRange: "${min}[percent0to2dp] \u0434\u043E ${max}[percent0to2dp]",
  contextMenuDownload: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438",
  contextMenuPanToCursor: "\u041F\u0440\u043E\u043A\u0440\u0443\u0442\u0438\u0442\u0438 \u0441\u044E\u0434\u0438",
  contextMenuToggleOtherSeries: "\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u0438 \u0456\u043D\u0448\u0456 \u0441\u0435\u0440\u0456\u0457",
  contextMenuToggleSeriesVisibility: "\u041F\u0435\u0440\u0435\u043C\u043A\u043D\u0443\u0442\u0438 \u0432\u0438\u0434\u0438\u043C\u0456\u0441\u0442\u044C",
  contextMenuZoomToCursor: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438 \u0441\u044E\u0434\u0438",
  dialogHeaderChannel: "\u041A\u0430\u043D\u0430\u043B",
  dialogHeaderDatePriceRange: "\u0414\u0430\u0442\u0430 \u0456 \u0446\u0456\u043D\u0430",
  dialogHeaderDateRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442",
  dialogHeaderFibonacciRange: "\u0420\u0456\u0432\u043D\u0456 \u0424\u0456\u0431\u043E\u043D\u0430\u0447\u0447\u0456",
  dialogHeaderLine: "\u041B\u0456\u043D\u0456\u044F",
  dialogHeaderPriceRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D \u0446\u0456\u043D",
  dialogHeaderText: "\u0422\u0435\u043A\u0441\u0442",
  dialogInputAlign: "\u0412\u0438\u0440\u0456\u0432\u043D\u044F\u0442\u0438",
  dialogInputColorPicker: "\u041A\u043E\u043B\u0456\u0440",
  dialogInputColorPickerAltText: "\u041A\u043E\u043B\u0456\u0440 \u0442\u0435\u043A\u0441\u0442\u0443",
  dialogInputExtendAbove: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u0432\u0438\u0449\u0435",
  dialogInputExtendBelow: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043D\u0438\u0436\u0447\u0435",
  dialogInputExtendChannelEnd: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043A\u0456\u043D\u0435\u0446\u044C \u043A\u0430\u043D\u0430\u043B\u0443",
  dialogInputExtendChannelStart: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043F\u043E\u0447\u0430\u0442\u043E\u043A \u043A\u0430\u043D\u0430\u043B\u0443",
  dialogInputExtendLeft: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u043B\u0456\u0432\u043E\u0440\u0443\u0447",
  dialogInputExtendLineEnd: "\u041F\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043A\u0456\u043D\u0435\u0446\u044C \u043B\u0456\u043D\u0456\u0457",
  dialogInputExtendLineStart: "\u041F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438 \u043F\u043E\u0447\u0430\u0442\u043E\u043A \u043B\u0456\u043D\u0456\u0457",
  dialogInputExtendRight: "\u0420\u043E\u0437\u0448\u0438\u0440\u0438\u0442\u0438 \u0432\u043F\u0440\u0430\u0432\u043E",
  dialogInputFibonacciBands: "\u0421\u043C\u0443\u0433\u0438",
  dialogInputFibonacciBandsAltText: "\u0421\u043C\u0443\u0433\u0438 \u0424\u0456\u0431\u043E\u043D\u0430\u0447\u0447\u0456",
  dialogInputFillColorPicker: "\u0417\u0430\u043B\u0438\u0432\u043A\u0430",
  dialogInputFillColorPickerAltText: "\u041A\u043E\u043B\u0456\u0440 \u0437\u0430\u043B\u0438\u0432\u043A\u0438",
  dialogInputFontSize: "\u0420\u043E\u0437\u043C\u0456\u0440",
  dialogInputFontSizeAltText: "\u0420\u043E\u0437\u043C\u0456\u0440 \u0448\u0440\u0438\u0444\u0442\u0443",
  dialogInputLineStyle: "\u041F\u0443\u043D\u043A\u0442\u0438\u0440",
  dialogInputPosition: "\u041F\u043E\u0437\u0438\u0446\u0456\u044F",
  dialogInputReverse: "\u0417\u0432\u043E\u0440\u043E\u0442\u043D\u0456\u0439",
  dialogInputShowFill: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043D\u044F",
  dialogInputStrokeWidth: "\u0412\u0430\u0433\u0430",
  dialogInputStrokeWidthAltText: "\u0412\u0430\u0433\u0430 \u043B\u0456\u043D\u0456\u0457",
  iconAltTextAlignCenter: "\u0426\u0435\u043D\u0442\u0440",
  iconAltTextAlignLeft: "\u041B\u0456\u0432\u043E\u0440\u0443\u0447",
  iconAltTextAlignRight: "\u041F\u0440\u0430\u0432\u043E\u0440\u0443\u0447",
  iconAltTextClose: "\u0417\u0430\u043A\u0440\u0438\u0442\u0438",
  iconAltTextLineStyleDashed: "\u0414\u043E\u0432\u0433\u0438\u0439-\u0442\u0456\u0440\u0435",
  iconAltTextLineStyleDotted: "\u041A\u043E\u0440\u043E\u0442\u043A\u0430 \u0448\u0442\u0440\u0438\u0445\u043E\u0432\u0430",
  iconAltTextLineStyleSolid: "\u0421\u0443\u0446\u0456\u043B\u044C\u043D\u0430",
  iconAltTextPositionBottom: "\u041D\u0438\u0437",
  iconAltTextPositionCenter: "\u0426\u0435\u043D\u0442\u0440",
  iconAltTextPositionTop: "\u0412\u0435\u0440\u0445",
  inputTextareaPlaceholder: "\u0414\u043E\u0434\u0430\u0442\u0438 \u0442\u0435\u043A\u0441\u0442",
  measurerDateRangeBars: "${value}[number] \u0441\u0442\u043E\u0432\u043F\u0446\u0456\u0432",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u041E\u0431\u0441\u044F\u0433 ${value}",
  overlayLoadingData: "\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0430\u043D\u0438\u0445...",
  overlayNoData: "\u041D\u0435\u043C\u0430\u0454 \u0434\u0430\u043D\u0438\u0445 \u0434\u043B\u044F \u0432\u0456\u0434\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F",
  overlayNoVisibleSeries: "\u041D\u0435\u043C\u0430\u0454 \u0432\u0438\u0434\u0438\u043C\u0438\u0445 \u0441\u0435\u0440\u0456\u0439",
  overlayUnsupportedBrowser: "\u041D\u0435\u0441\u0443\u043C\u0456\u0441\u043D\u0430 \u0432\u0435\u0440\u0441\u0456\u044F \u0431\u0440\u0430\u0443\u0437\u0435\u0440\u0430. \u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043E\u043D\u043E\u0432\u0456\u0442\u044C \u0432\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440.",
  seriesHistogramTooltipCount: "${yName} (\u043A\u0456\u043B\u044C\u043A\u0456\u0441\u0442\u044C)",
  seriesHistogramTooltipFrequency: "\u0427\u0430\u0441\u0442\u043E\u0442\u0430",
  seriesHistogramTooltipMean: "${yName} (\u0441\u0435\u0440\u0435\u0434\u043D\u0454)",
  seriesHistogramTooltipSum: "${yName} (\u0441\u0443\u043C\u0430)",
  toolbarAnnotationsArrow: "\u0421\u0442\u0440\u0456\u043B\u043A\u0430",
  toolbarAnnotationsArrowDown: "\u0421\u0442\u0440\u0456\u043B\u043A\u0430 \u0432\u043D\u0438\u0437",
  toolbarAnnotationsArrowUp: "\u0421\u0442\u0440\u0456\u043B\u043A\u0430 \u0432\u0433\u043E\u0440\u0443",
  toolbarAnnotationsCallout: "\u0412\u0438\u043D\u043E\u0441\u043A\u0430",
  toolbarAnnotationsClearAll: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u0438 \u0432\u0441\u0435",
  toolbarAnnotationsComment: "\u041A\u043E\u043C\u0435\u043D\u0442\u0430\u0440",
  toolbarAnnotationsDatePriceRange: "\u0414\u0430\u0442\u0430 \u0442\u0430 \u0446\u0456\u043D\u0430",
  toolbarAnnotationsDateRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442",
  toolbarAnnotationsDelete: "\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438",
  toolbarAnnotationsDisjointChannel: "\xAB\u0420\u043E\u0437\u0434\u0456\u043B\u0435\u043D\u0438\u0439 \u043A\u0430\u043D\u0430\u043B\xBB",
  toolbarAnnotationsDragHandle: "\u041F\u0435\u0440\u0435\u0442\u044F\u0433\u043D\u0443\u0442\u0438 \u043F\u0430\u043D\u0435\u043B\u044C \u0456\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0456\u0432",
  toolbarAnnotationsFibonacciAnnotations: "\u0424\u0456\u0431\u043E\u043D\u0430\u0447\u0447\u0456",
  toolbarAnnotationsFibonacciRetracement: "\u0424\u0456\u0431\u043E\u043D\u0430\u0447\u0447\u0456 \u041A\u043E\u0440\u0435\u043A\u0446\u0456\u044F",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0424\u0456\u0431 \u0422\u0440\u0435\u043D\u0434 \u0411\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u0439",
  toolbarAnnotationsFillColor: "\u041A\u043E\u043B\u0456\u0440 \u0437\u0430\u043F\u043E\u0432\u043D\u0435\u043D\u043D\u044F",
  toolbarAnnotationsHorizontalLine: "\u0413\u043E\u0440\u0438\u0437\u043E\u043D\u0442\u0430\u043B\u044C\u043D\u0430 \u043B\u0456\u043D\u0456\u044F",
  toolbarAnnotationsLineAnnotations: "\u0422\u0440\u0435\u043D\u0434\u043E\u0432\u0456 \u043B\u0456\u043D\u0456\u0457",
  toolbarAnnotationsLineColor: "\u041A\u043E\u043B\u0456\u0440 \u043B\u0456\u043D\u0456\u0457",
  toolbarAnnotationsLineStrokeWidth: "\u0422\u043E\u0432\u0449\u0438\u043D\u0430 \u043B\u0456\u043D\u0456\u0457",
  toolbarAnnotationsLineStyle: "\u0421\u0442\u0438\u043B\u044C \u043B\u0456\u043D\u0456\u0457",
  toolbarAnnotationsLock: "\u0417\u0430\u0431\u043B\u043E\u043A\u0443\u0432\u0430\u0442\u0438",
  toolbarAnnotationsMeasurerAnnotations: "\u0412\u0438\u043C\u0456\u0440\u044E\u0432\u0430\u0447\u0456",
  toolbarAnnotationsNote: "\u041D\u043E\u0442\u0430\u0442\u043A\u0430",
  toolbarAnnotationsParallelChannel: "\u041F\u0430\u0440\u0430\u043B\u0435\u043B\u044C\u043D\u0438\u0439 \u043A\u0430\u043D\u0430\u043B",
  toolbarAnnotationsPriceRange: "\u0414\u0456\u0430\u043F\u0430\u0437\u043E\u043D \u0446\u0456\u043D",
  toolbarAnnotationsQuickDatePriceRange: "\u0412\u0438\u043C\u0456\u0440\u044F\u0442\u0438",
  toolbarAnnotationsSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
  toolbarAnnotationsShapeAnnotations: "\u0421\u0442\u0440\u0456\u043B\u043A\u0438",
  toolbarAnnotationsText: "\u0422\u0435\u043A\u0441\u0442",
  toolbarAnnotationsTextAnnotations: "\u0422\u0435\u043A\u0441\u0442\u043E\u0432\u0456 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0438",
  toolbarAnnotationsTextColor: "\u041A\u043E\u043B\u0456\u0440 \u0442\u0435\u043A\u0441\u0442\u0443",
  toolbarAnnotationsTextSize: "\u0420\u043E\u0437\u043C\u0456\u0440 \u0442\u0435\u043A\u0441\u0442\u0443",
  toolbarAnnotationsTrendLine: "\u0422\u0440\u0435\u043D\u0434\u043E\u0432\u0430 \u043B\u0456\u043D\u0456\u044F",
  toolbarAnnotationsUnlock: "\u0420\u043E\u0437\u0431\u043B\u043E\u043A\u0443\u0432\u0430\u0442\u0438",
  toolbarAnnotationsVerticalLine: "\u0412\u0435\u0440\u0442\u0438\u043A\u0430\u043B\u044C\u043D\u0430 \u043B\u0456\u043D\u0456\u044F",
  toolbarRange1Month: "1\u041C",
  toolbarRange1MonthAria: "1 \u043C\u0456\u0441\u044F\u0446\u044C",
  toolbarRange1Year: "1\u0440",
  toolbarRange1YearAria: "1 \u0440\u0456\u043A",
  toolbarRange3Months: "3\u041C",
  toolbarRange3MonthsAria: "3 \u043C\u0456\u0441\u044F\u0446\u0456",
  toolbarRange6Months: "6\u041C",
  toolbarRange6MonthsAria: "6 \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
  toolbarRangeAll: "\u0412\u0441\u0456",
  toolbarRangeAllAria: "\u0412\u0441\u0456",
  toolbarRangeYearToDate: "\u0417 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0440\u043E\u043A\u0443",
  toolbarRangeYearToDateAria: "\u0417 \u043F\u043E\u0447\u0430\u0442\u043A\u0443 \u0440\u043E\u043A\u0443",
  toolbarSeriesTypeCandles: "\u0421\u0432\u0456\u0447\u043A\u0438",
  toolbarSeriesTypeDropdown: "\u0422\u0438\u043F \u0434\u0456\u0430\u0433\u0440\u0430\u043C\u0438",
  toolbarSeriesTypeHighLow: "\u0412\u0438\u0441\u043E\u043A\u0438\u0439 \u041D\u0438\u0437\u044C\u043A\u0438\u0439",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u041F\u043E\u0440\u043E\u0436\u043D\u0438\u0441\u0442\u0456 \u0441\u0432\u0456\u0447\u043A\u0438",
  toolbarSeriesTypeLine: "\u041B\u0456\u043D\u0456\u044F",
  toolbarSeriesTypeLineWithMarkers: "\u041B\u0456\u043D\u0456\u044F \u0437 \u043C\u0430\u0440\u043A\u0435\u0440\u0430\u043C\u0438",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u041A\u0440\u043E\u043A\u043E\u0432\u0430 \u041B\u0456\u043D\u0456\u044F",
  toolbarZoomPanEnd: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0434\u043E \u043A\u0456\u043D\u0446\u044F",
  toolbarZoomPanLeft: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u0430 \u0432\u043B\u0456\u0432\u043E",
  toolbarZoomPanRight: "\u041F\u0435\u0440\u0435\u043C\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043F\u0440\u0430\u0432\u043E",
  toolbarZoomPanStart: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u0443\u0432\u0430\u0442\u0438 \u043D\u0430 \u043F\u043E\u0447\u0430\u0442\u043E\u043A",
  toolbarZoomReset: "\u0421\u043A\u0438\u043D\u0443\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0443\u0432\u0430\u043D\u043D\u044F",
  toolbarZoomZoomIn: "\u0417\u0431\u0456\u043B\u044C\u0448\u0438\u0442\u0438",
  toolbarZoomZoomOut: "\u0417\u043C\u0435\u043D\u0448\u0438\u0442\u0438 \u043C\u0430\u0441\u0448\u0442\u0430\u0431",
  tooltipPaginationStatus: "${index}[number] \u0437 ${count}[number]"
};
var AG_CHARTS_LOCALE_UR_PK = {
  ariaAnnounceChart: "\u0686\u0627\u0631\u0679\u060C ${seriesCount}[number] \u0633\u06CC\u0631\u06CC\u0632",
  ariaAnnounceFlowProportionLink: "\u0644\u0646\u06A9 ${index} \u06A9\u0627 ${count} \u0645\u06CC\u06BA \u0633\u06D2\u060C ${from} \u0633\u06D2 ${to} \u062A\u06A9\u060C ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u0646\u0648\u0688 ${index} \u06A9\u0627 ${count}\u060C ${description}",
  ariaAnnounceGaugeChart: "\u06AF\u06CC\u062C \u0686\u0627\u0631\u0679, ${caption}",
  ariaAnnounceHierarchyChart: "\u062F\u0631\u062C\u06C1 \u0628\u0646\u062F\u06CC \u0686\u0627\u0631\u0679\u060C ${caption}",
  ariaAnnounceHierarchyDatum: "\u0633\u0637\u062D ${level}[number], ${count}[number] \u0628\u0686\u06D2, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u062F\u06CC\u06A9\u06BE\u0646\u06D2 \u06A9\u06D2 \u0644\u06CC\u06D2 \u0627\u0633 \u06A9\u0627\u067E\u06CC \u067E\u0631 \u0627\u0633\u067E\u06CC\u0633 \u06CC\u0627 \u0627\u0646\u0679\u0631 \u062F\u0628\u0627\u0626\u06CC\u06BA",
  ariaLabelAddHorizontalLine: "\u0627\u0641\u0642\u06CC \u0644\u0627\u0626\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u06CC\u06BA",
  ariaLabelAnnotationOptionsToolbar: "\u062A\u0634\u0631\u06CC\u062D \u06A9\u06D2 \u0627\u062E\u062A\u06CC\u0627\u0631\u0627\u062A",
  ariaLabelAnnotationSettingsDialog: "\u062A\u0634\u0631\u06CC\u062D \u06A9\u06CC \u062A\u0631\u062A\u06CC\u0628\u0627\u062A",
  ariaLabelColorPicker: "\u0631\u0646\u06AF \u0686\u0646\u0646\u06D2 \u0648\u0627\u0644\u0627",
  ariaLabelFinancialCharts: "\u0645\u0627\u0644\u06CC \u0686\u0627\u0631\u0679",
  ariaLabelLegend: "\u0639\u0644\u0627\u0645\u0627\u062A",
  ariaLabelLegendItem: "${label}, \u0644\u06CC\u062C\u0646\u0688 \u0622\u0626\u0679\u0645 ${index}[number] \u0645\u06CC\u06BA \u0633\u06D2 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u0646\u0627\u0645\u0639\u0644\u0648\u0645 \u0639\u0644\u0627\u0645\u0627\u062A \u06A9\u06CC \u0634\u06D2",
  ariaLabelLegendPageNext: "\u0627\u06AF\u0644\u0627 \u0644\u06CC\u062C\u0646\u0688 \u0635\u0641\u062D\u06C1",
  ariaLabelLegendPagePrevious: "\u067E\u0686\u06BE\u0644\u0627 \u0644\u06CC\u062C\u0646\u0688 \u0635\u0641\u062D\u06C1",
  ariaLabelLegendPagination: "\u0644\u06CC\u062C\u0646\u0688 \u067E\u06CC\u062C\u06CC\u0646\u06CC\u0634\u0646",
  ariaLabelNavigator: "\u0646\u06CC\u0648\u06CC\u06AF\u06CC\u0679\u0631",
  ariaLabelNavigatorMaximum: "\u0632\u06CC\u0627\u062F\u06C1 \u0633\u06D2 \u0632\u06CC\u0627\u062F\u06C1",
  ariaLabelNavigatorMinimum: "\u06A9\u0645 \u0627\u0632 \u06A9\u0645",
  ariaLabelNavigatorRange: "\u062D\u062F",
  ariaLabelRangesToolbar: "\u062D\u062F\u0648\u062F",
  ariaLabelSettingsTabBar: "\u062A\u0631\u062A\u06CC\u0628\u0627\u062A",
  ariaLabelZoomToolbar: "\u0632\u0648\u0645",
  ariaValuePanRange: "${min}[percent0to2dp] \u0633\u06D2 ${max}[percent0to2dp]",
  contextMenuDownload: "\u0688\u0627\u0624\u0646 \u0644\u0648\u0688 \u06A9\u0631\u06CC\u06BA",
  contextMenuPanToCursor: "\u06CC\u06C1\u0627\u06BA \u062A\u06A9 \u06AF\u06BE\u0645\u0627\u0626\u06CC\u06BA",
  contextMenuToggleOtherSeries: "\u062F\u06CC\u06AF\u0631 \u0633\u06CC\u0631\u06CC\u0632 \u06A9\u0648 \u0679\u0648\u06AF\u0644 \u06A9\u0631\u06CC\u06BA",
  contextMenuToggleSeriesVisibility: "\u0645\u0631\u0626\u06CC \u06C1\u0648\u0646\u06D2 \u06A9\u0648 \u0679\u0648\u06AF\u0644 \u06A9\u0631\u06CC\u06BA",
  contextMenuZoomToCursor: "\u06CC\u06C1\u0627\u06BA \u0632\u0648\u0645 \u06A9\u0631\u06CC\u06BA",
  dialogHeaderChannel: "\u0686\u06CC\u0646\u0644",
  dialogHeaderDatePriceRange: "\u062A\u0627\u0631\u06CC\u062E \u0627\u0648\u0631 \u0642\u06CC\u0645\u062A",
  dialogHeaderDateRange: "\u062A\u0627\u0631\u06CC\u062E \u06A9\u06CC \u062D\u062F",
  dialogHeaderFibonacciRange: "\u0641\u0628 \u0631\u06CC\u0679\u0631\u06CC\u0633\u0645\u0646\u0679",
  dialogHeaderLine: "\u0644\u0627\u0626\u0646",
  dialogHeaderPriceRange: "\u0642\u06CC\u0645\u062A \u06A9\u06CC \u062D\u062F",
  dialogHeaderText: "\u0645\u062A\u0646",
  dialogInputAlign: "\u062A\u0631\u062A\u06CC\u0628 \u062F\u06CC\u06BA",
  dialogInputColorPicker: "\u0631\u0646\u06AF",
  dialogInputColorPickerAltText: "\u0645\u062A\u0646 \u06A9\u0627 \u0631\u0646\u06AF",
  dialogInputExtendAbove: "\u0627\u0648\u067E\u0631 \u062A\u06A9 \u0628\u0691\u06BE\u0627\u0626\u06CC\u06BA",
  dialogInputExtendBelow: "\u0646\u06CC\u0686\u06D2 \u0648\u0633\u0639\u062A \u062F\u06CC\u06BA",
  dialogInputExtendChannelEnd: "\u0686\u06CC\u0646\u0644 \u06A9\u06D2 \u0622\u062E\u0631 \u06A9\u0648 \u0628\u0691\u06BE\u0627\u0626\u06CC\u06BA",
  dialogInputExtendChannelStart: "\u0686\u06CC\u0646\u0644 \u0634\u0631\u0648\u0639 \u06A9\u0631\u06CC\u06BA",
  dialogInputExtendLeft: "\u0628\u0627\u0626\u06CC\u06BA \u062C\u0627\u0646\u0628 \u062A\u0648\u0633\u06CC\u0639 \u06A9\u0631\u06CC\u06BA",
  dialogInputExtendLineEnd: "\u0644\u0627\u0626\u0646 \u06A9\u06D2 \u0622\u062E\u0631 \u06A9\u0648 \u0628\u0691\u06BE\u0627\u0624",
  dialogInputExtendLineStart: "\u0644\u0627\u0626\u06CC\u0646 \u06A9\u0627 \u0633\u0641\u0631 \u0628\u0691\u06BE\u0627\u0626\u06CC\u06BA",
  dialogInputExtendRight: "\u062F\u0627\u0626\u06CC\u06BA \u0628\u0691\u06BE\u0627\u0626\u06CC\u06BA",
  dialogInputFibonacciBands: "\u0628\u06CC\u0646\u0688\u0632",
  dialogInputFibonacciBandsAltText: "\u0641\u06CC\u0628\u0648\u0646\u0627\u0686\u06CC \u0628\u06CC\u0646\u0688\u0632",
  dialogInputFillColorPicker: "\u0631\u0646\u06AF \u0628\u06BE\u0631\u06CC\u06BA",
  dialogInputFillColorPickerAltText: "\u0628\u06BE\u0631\u0646\u06D2 \u06A9\u0627 \u0631\u0646\u06AF",
  dialogInputFontSize: "\u0633\u0627\u0626\u0632",
  dialogInputFontSizeAltText: "\u0641\u0648\u0646\u0679 \u0633\u0627\u0626\u0632",
  dialogInputLineStyle: "\u0688\u06CC\u0634",
  dialogInputPosition: "\u0645\u0642\u0627\u0645",
  dialogInputReverse: "\u0627\u0644\u0679",
  dialogInputShowFill: "\u0641\u0650\u0644 \u062F\u06A9\u06BE\u0627\u0626\u06CC\u06BA",
  dialogInputStrokeWidth: "\u0648\u0632\u0646",
  dialogInputStrokeWidthAltText: "\u0644\u0627\u0626\u0646 \u06A9\u0627 \u0648\u0632\u0646",
  iconAltTextAlignCenter: "\u0645\u0631\u06A9\u0632",
  iconAltTextAlignLeft: "\u0628\u0627\u0626\u06CC\u06BA \u062C\u0627\u0646\u0628",
  iconAltTextAlignRight: "\u062F\u0627\u0626\u06CC\u06BA",
  iconAltTextClose: "\u0628\u0646\u062F \u06A9\u0631\u06CC\u06BA",
  iconAltTextLineStyleDashed: "\u0644\u0645\u0628\u06CC \u0644\u06A9\u06CC\u0631 \u0648\u0627\u0644\u0627",
  iconAltTextLineStyleDotted: "\u0645\u062E\u062A\u0635\u0631-\u0688\u06CC\u0634",
  iconAltTextLineStyleSolid: "\u0679\u06BE\u0648\u0633",
  iconAltTextPositionBottom: "\u0646\u06CC\u0686\u06D2",
  iconAltTextPositionCenter: "\u062F\u0631\u0645\u06CC\u0627\u0646",
  iconAltTextPositionTop: "\u0627\u0648\u067E\u0631",
  inputTextareaPlaceholder: "\u0645\u062A\u0646 \u0634\u0627\u0645\u0644 \u06A9\u0631\u06CC\u06BA",
  measurerDateRangeBars: "${value}[number] \u0628\u0627\u0631\u0632",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u062D\u062C\u0645 ${value}",
  overlayLoadingData: "\u0688\u06CC\u0679\u0627 \u0644\u0648\u0688 \u06C1\u0648 \u0631\u06C1\u0627 \u06C1\u06D2...",
  overlayNoData: "\u0627\u0638\u06C1\u0627\u0631 \u06A9\u06D2 \u0644\u0626\u06D2 \u06A9\u0648\u0626\u06CC \u0688\u06CC\u0679\u0627 \u0646\u06C1\u06CC\u06BA",
  overlayNoVisibleSeries: "\u06A9\u0648\u0626\u06CC \u0646\u0638\u0631 \u0622\u0646\u06D2 \u0648\u0627\u0644\u06CC \u0633\u06CC\u0631\u06CC\u0632 \u0646\u06C1\u06CC\u06BA",
  overlayUnsupportedBrowser: "\u0646\u0627 \u0645\u0648\u0627\u0641\u0642 \u0628\u0631\u0627\u0624\u0632\u0631 \u0648\u0631\u0698\u0646\u06D4 \u0628\u0631\u0627\u06C1 \u06A9\u0631\u0645 \u0627\u067E\u0646\u06D2 \u0628\u0631\u0627\u0624\u0632\u0631 \u06A9\u0648 \u0627\u067E \u06AF\u0631\u06CC\u0688 \u06A9\u0631\u06CC\u06BA\u06D4",
  seriesHistogramTooltipCount: "${yName} (\u062A\u0639\u062F\u0627\u062F)",
  seriesHistogramTooltipFrequency: "\u062A\u0639\u062F\u062F",
  seriesHistogramTooltipMean: "${yName} (\u0627\u0648\u0633\u0637)",
  seriesHistogramTooltipSum: "${yName} (\u0645\u062C\u0645\u0648\u0639\u06C1)",
  toolbarAnnotationsArrow: "\u062A\u06CC\u0631",
  toolbarAnnotationsArrowDown: "\u062A\u06CC\u0631 \u0646\u06CC\u0686\u06D2",
  toolbarAnnotationsArrowUp: "\u0627\u0648\u067E\u0631 \u06A9\u06CC \u0637\u0631\u0641 \u062A\u06CC\u0631",
  toolbarAnnotationsCallout: "\u06A9\u0627\u0644 \u0622\u0624\u0679",
  toolbarAnnotationsClearAll: "\u0633\u0628 \u0635\u0627\u0641 \u06A9\u0631\u06CC\u06BA",
  toolbarAnnotationsComment: "\u062A\u0628\u0635\u0631\u06C1",
  toolbarAnnotationsDatePriceRange: "\u062A\u0627\u0631\u06CC\u062E \u0627\u0648\u0631 \u0642\u06CC\u0645\u062A",
  toolbarAnnotationsDateRange: "\u062A\u0627\u0631\u06CC\u062E \u06A9\u06CC \u062D\u062F",
  toolbarAnnotationsDelete: "\u062D\u0630\u0641 \u06A9\u0631\u06CC\u06BA",
  toolbarAnnotationsDisjointChannel: "\u0645\u0646\u0642\u0637\u0639 \u0686\u06CC\u0646\u0644",
  toolbarAnnotationsDragHandle: "\u0679\u0648\u0644 \u0628\u0627\u0631 \u06A9\u0648 \u06AF\u06BE\u0633\u06CC\u0679\u06CC\u06BA",
  toolbarAnnotationsFibonacciAnnotations: "\u0641\u06CC\u0628\u0648\u0646\u0627\u0686\u06CC",
  toolbarAnnotationsFibonacciRetracement: "\u0641\u0628\u0648\u0646\u06CC\u06A9\u06CC \u0631\u06CC\u0679\u0631\u06CC\u0633\u0645\u0646\u0679",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0641\u0628 \u0679\u0631\u06CC\u0646\u0688 \u067E\u0631 \u0645\u0628\u0646\u06CC",
  toolbarAnnotationsFillColor: "\u0631\u0646\u06AF \u0628\u06BE\u0631\u06CC\u06BA",
  toolbarAnnotationsHorizontalLine: "\u0627\u0641\u0642\u06CC \u0644\u06A9\u06CC\u0631",
  toolbarAnnotationsLineAnnotations: "\u0631\u062C\u062D\u0627\u0646 \u0644\u0627\u0626\u0646\u06CC\u06BA",
  toolbarAnnotationsLineColor: "\u0644\u0627\u0626\u0646 \u06A9\u0627 \u0631\u0646\u06AF",
  toolbarAnnotationsLineStrokeWidth: "\u0644\u0627\u0626\u0646 \u06A9\u06CC \u0686\u0648\u0691\u0627\u0626\u06CC",
  toolbarAnnotationsLineStyle: "\u0644\u0627\u0626\u0646 \u06A9\u0627 \u0627\u0646\u062F\u0627\u0632",
  toolbarAnnotationsLock: "\u0644\u0627\u06A9",
  toolbarAnnotationsMeasurerAnnotations: "\u067E\u06CC\u0645\u0627\u0626\u0634 \u06A9\u0631\u0646\u06D2 \u0648\u0627\u0644\u06D2",
  toolbarAnnotationsNote: "\u0646\u0648\u0679",
  toolbarAnnotationsParallelChannel: "\u0645\u062A\u0648\u0627\u0632\u06CC \u0686\u06CC\u0646\u0644",
  toolbarAnnotationsPriceRange: "\u0642\u06CC\u0645\u062A \u06A9\u06CC \u062D\u062F",
  toolbarAnnotationsQuickDatePriceRange: "\u067E\u06CC\u0645\u0627\u0626\u0634",
  toolbarAnnotationsSettings: "\u062A\u0631\u062A\u06CC\u0628\u0627\u062A",
  toolbarAnnotationsShapeAnnotations: "\u062A\u06CC\u0631",
  toolbarAnnotationsText: "\u0645\u062A\u0646",
  toolbarAnnotationsTextAnnotations: "\u0645\u062A\u0646 \u06A9\u06D2 \u062A\u0634\u0631\u06CC\u062D\u0627\u062A",
  toolbarAnnotationsTextColor: "\u0645\u062A\u0646 \u06A9\u0627 \u0631\u0646\u06AF",
  toolbarAnnotationsTextSize: "\u0645\u062A\u0646 \u06A9\u0627 \u0633\u0627\u0626\u0632",
  toolbarAnnotationsTrendLine: "\u0631\u062C\u062D\u0627\u0646 \u0644\u0627\u0626\u0646",
  toolbarAnnotationsUnlock: "\u0627\u0646 \u0644\u0627\u06A9 \u06A9\u0631\u06CC\u06BA",
  toolbarAnnotationsVerticalLine: "\u0639\u0645\u0648\u062F\u06CC \u0644\u06A9\u06CC\u0631",
  toolbarRange1Month: "1 \u0645\u0627\u06C1",
  toolbarRange1MonthAria: "1 \u0645\u06C1\u06CC\u0646\u06C1",
  toolbarRange1Year: "1 \u0633\u0627\u0644",
  toolbarRange1YearAria: "1 \u0633\u0627\u0644",
  toolbarRange3Months: "3\u0645\u0627\u06C1",
  toolbarRange3MonthsAria: "3 \u0645\u0627\u06C1",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 \u0645\u0627\u06C1",
  toolbarRangeAll: "\u0633\u0628",
  toolbarRangeAllAria: "\u0633\u0628",
  toolbarRangeYearToDate: "\u0633\u0627\u0644 \u06A9\u06CC \u0627\u0628\u062A\u062F\u0627 \u0633\u06D2",
  toolbarRangeYearToDateAria: "\u0633\u0627\u0644 \u062A\u0627 \u062D\u0627\u0644",
  toolbarSeriesTypeCandles: "\u0645\u0648\u0645 \u0628\u062A\u06CC\u0627\u06BA",
  toolbarSeriesTypeDropdown: "\u0686\u0627\u0631\u0679 \u06A9\u06CC \u0642\u0633\u0645",
  toolbarSeriesTypeHighLow: "\u0627\u0639\u0644\u06CC \u0646\u06CC\u0686",
  toolbarSeriesTypeHLC: "\u0627\u06CC\u0686 \u0627\u06CC\u0644 \u0633\u06CC",
  toolbarSeriesTypeHollowCandles: "\u06C1\u0648\u0644\u0648 \u06A9\u06CC\u0646\u0688\u0644\u0632",
  toolbarSeriesTypeLine: "\u0644\u0627\u0626\u0646",
  toolbarSeriesTypeLineWithMarkers: "\u0645\u0627\u0631\u06A9\u0631\u0632 \u06A9\u06D2 \u0633\u0627\u062A\u06BE \u0644\u0627\u0626\u0646",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u0642\u062F\u0645 \u0644\u0627\u0626\u0646",
  toolbarZoomPanEnd: "\u0622\u062E\u0631 \u062A\u06A9 \u067E\u06CC\u0646 \u06A9\u0631\u06CC\u06BA",
  toolbarZoomPanLeft: "\u0628\u0627\u0626\u06CC\u06BA \u0637\u0631\u0641 \u0645\u0646\u062A\u0642\u0644 \u06A9\u0631\u06CC\u06BA",
  toolbarZoomPanRight: "\u062F\u0627\u0626\u06CC\u06BA \u0637\u0631\u0641 \u06AF\u06BE\u0645\u0627\u0626\u06CC\u06BA",
  toolbarZoomPanStart: "\u0622\u063A\u0627\u0632 \u06A9\u06CC \u0637\u0631\u0641 \u067E\u06CC\u0646 \u06A9\u0631\u06CC\u06BA",
  toolbarZoomReset: "\u0632\u0648\u0645 \u0631\u06CC \u0633\u06CC\u0679 \u06A9\u0631\u06CC\u06BA",
  toolbarZoomZoomIn: "\u0632\u0648\u0645 \u0627\u0646",
  toolbarZoomZoomOut: "\u0632\u0648\u0645 \u0622\u0624\u0679",
  tooltipPaginationStatus: "${index}[number] \u0645\u06CC\u06BA \u0633\u06D2 ${count}[number]"
};
var AG_CHARTS_LOCALE_VI_VN = {
  ariaAnnounceChart: "bi\u1EC3u \u0111\u1ED3, ${seriesCount}[number] chu\u1ED7i",
  ariaAnnounceFlowProportionLink: "li\xEAn k\u1EBFt ${index} c\u1EE7a ${count}, t\u1EEB ${from} \u0111\u1EBFn ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "n\xFAt ${index} c\u1EE7a ${count}, ${description}",
  ariaAnnounceGaugeChart: "bi\u1EC3u \u0111\u1ED3 \u0111\u1ED3ng h\u1ED3 \u0111o, ${caption}",
  ariaAnnounceHierarchyChart: "bi\u1EC3u \u0111\u1ED3 ph\xE2n c\u1EA5p, ${caption}",
  ariaAnnounceHierarchyDatum: "c\u1EA5p \u0111\u1ED9 ${level}[number], ${count}[number] con, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Nh\u1EA5n Ph\xEDm C\xE1ch ho\u1EB7c Enter \u0111\u1EC3 chuy\u1EC3n \u0111\u1ED5i ch\u1EBF \u0111\u1ED9 hi\u1EC3n th\u1ECB",
  ariaLabelAddHorizontalLine: "Th\xEAm \u0110\u01B0\u1EDDng Ngang",
  ariaLabelAnnotationOptionsToolbar: "T\xF9y ch\u1ECDn Ch\xFA th\xEDch",
  ariaLabelAnnotationSettingsDialog: "C\xE0i \u0111\u1EB7t Ch\xFA th\xEDch",
  ariaLabelColorPicker: "Tr\xECnh ch\u1ECDn m\xE0u",
  ariaLabelFinancialCharts: "Bi\u1EC3u \u0111\u1ED3 t\xE0i ch\xEDnh",
  ariaLabelLegend: "Ch\xFA gi\u1EA3i",
  ariaLabelLegendItem: "${label}, M\u1EE5c ch\xFA gi\u1EA3i ${index}[number] c\u1EE7a ${count}[number]",
  ariaLabelLegendItemUnknown: "M\u1EE5c ch\xFA gi\u1EA3i kh\xF4ng x\xE1c \u0111\u1ECBnh",
  ariaLabelLegendPageNext: "Trang Ch\xFA Gi\u1EA3i Ti\u1EBFp Theo",
  ariaLabelLegendPagePrevious: "Trang Huy\u1EC1n Tho\u1EA1i Tr\u01B0\u1EDBc",
  ariaLabelLegendPagination: "Ph\xE2n trang Ch\xFA gi\u1EA3i",
  ariaLabelNavigator: "Tr\xECnh \u0111i\u1EC1u h\u01B0\u1EDBng",
  ariaLabelNavigatorMaximum: "T\u1ED1i \u0111a",
  ariaLabelNavigatorMinimum: "T\u1ED1i thi\u1EC3u",
  ariaLabelNavigatorRange: "Ph\u1EA1m vi",
  ariaLabelRangesToolbar: "Ph\u1EA1m vi",
  ariaLabelSettingsTabBar: "C\xE0i \u0111\u1EB7t",
  ariaLabelZoomToolbar: "Thu ph\xF3ng",
  ariaValuePanRange: "${min}[percent0to2dp] \u0111\u1EBFn ${max}[percent0to2dp]",
  contextMenuDownload: "T\u1EA3i v\u1EC1",
  contextMenuPanToCursor: "Chuy\u1EC3n \u0111\u1EBFn \u0111\xE2y",
  contextMenuToggleOtherSeries: "Chuy\u1EC3n \u0111\u1ED5i c\xE1c d\xF2ng kh\xE1c",
  contextMenuToggleSeriesVisibility: "Chuy\u1EC3n \u0111\u1ED5i Hi\u1EC3n th\u1ECB",
  contextMenuZoomToCursor: "Thu ph\xF3ng t\u1EDBi \u0111\xE2y",
  dialogHeaderChannel: "K\xEAnh",
  dialogHeaderDatePriceRange: "Ng\xE0y v\xE0 Gi\xE1",
  dialogHeaderDateRange: "Kho\u1EA3ng th\u1EDDi gian",
  dialogHeaderFibonacciRange: "Fib H\u1ED3i Quy",
  dialogHeaderLine: "\u0110\u01B0\u1EDDng k\u1EBB",
  dialogHeaderPriceRange: "Kho\u1EA3ng Gi\xE1",
  dialogHeaderText: "V\u0103n b\u1EA3n",
  dialogInputAlign: "C\u0103n ch\u1EC9nh",
  dialogInputColorPicker: "M\xE0u s\u1EAFc",
  dialogInputColorPickerAltText: "M\xE0u ch\u1EEF",
  dialogInputExtendAbove: "M\u1EDF r\u1ED9ng l\xEAn tr\xEAn",
  dialogInputExtendBelow: "M\u1EDF r\u1ED9ng xu\u1ED1ng d\u01B0\u1EDBi",
  dialogInputExtendChannelEnd: "K\xE9o d\xE0i cu\u1ED1i k\xEAnh",
  dialogInputExtendChannelStart: "M\u1EDF r\u1ED9ng k\xEAnh b\u1EAFt \u0111\u1EA7u",
  dialogInputExtendLeft: "K\xE9o d\xE0i sang tr\xE1i",
  dialogInputExtendLineEnd: "M\u1EDF r\u1ED9ng cu\u1ED1i d\xF2ng",
  dialogInputExtendLineStart: "K\xE9o d\xE0i \u0111i\u1EC3m b\u1EAFt \u0111\u1EA7u \u0111\u01B0\u1EDDng th\u1EB3ng",
  dialogInputExtendRight: "M\u1EDF r\u1ED9ng sang ph\u1EA3i",
  dialogInputFibonacciBands: "D\u1EA3i",
  dialogInputFibonacciBandsAltText: "D\u1EA3i Fibonacci",
  dialogInputFillColorPicker: "T\xF4 m\xE0u",
  dialogInputFillColorPickerAltText: "M\xE0u t\xF4",
  dialogInputFontSize: "K\xEDch th\u01B0\u1EDBc",
  dialogInputFontSizeAltText: "K\xEDch Th\u01B0\u1EDBc Ch\u1EEF",
  dialogInputLineStyle: "G\u1EA1ch n\u1ED1i",
  dialogInputPosition: "V\u1ECB tr\xED",
  dialogInputReverse: "\u0110\u1EA3o ng\u01B0\u1EE3c",
  dialogInputShowFill: "Hi\u1EC7n \u0110i\u1EC1n",
  dialogInputStrokeWidth: "\u0110\u1ED9 d\xE0y",
  dialogInputStrokeWidthAltText: "\u0110\u1ED9 d\xE0y \u0111\u01B0\u1EDDng k\u1EBB",
  iconAltTextAlignCenter: "C\u0103n gi\u1EEFa",
  iconAltTextAlignLeft: "Tr\xE1i",
  iconAltTextAlignRight: "Ph\u1EA3i",
  iconAltTextClose: "\u0110\xF3ng",
  iconAltTextLineStyleDashed: "G\u1EA1ch ngang d\xE0i",
  iconAltTextLineStyleDotted: "G\u1EA1ch ng\u1EAFn",
  iconAltTextLineStyleSolid: "Li\u1EC1n m\u1EA1ch",
  iconAltTextPositionBottom: "D\u01B0\u1EDBi c\xF9ng",
  iconAltTextPositionCenter: "Gi\u1EEFa",
  iconAltTextPositionTop: "Tr\xEAn c\xF9ng",
  inputTextareaPlaceholder: "Th\xEAm V\u0103n B\u1EA3n",
  measurerDateRangeBars: "${value}[number] thanh",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Th\u1EC3 t\xEDch ${value}",
  overlayLoadingData: "\u0110ang t\u1EA3i d\u1EEF li\u1EC7u...",
  overlayNoData: "Kh\xF4ng c\xF3 d\u1EEF li\u1EC7u \u0111\u1EC3 hi\u1EC3n th\u1ECB",
  overlayNoVisibleSeries: "Kh\xF4ng c\xF3 d\xE3y s\u1ED1 hi\u1EC3n th\u1ECB",
  overlayUnsupportedBrowser: "Phi\xEAn b\u1EA3n tr\xECnh duy\u1EC7t kh\xF4ng t\u01B0\u01A1ng th\xEDch. Vui l\xF2ng n\xE2ng c\u1EA5p tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n.",
  seriesHistogramTooltipCount: "${yName} (s\u1ED1 \u0111\u1EBFm)",
  seriesHistogramTooltipFrequency: "T\u1EA7n su\u1EA5t",
  seriesHistogramTooltipMean: "${yName} (trung b\xECnh)",
  seriesHistogramTooltipSum: "${yName} (t\u1ED5ng)",
  toolbarAnnotationsArrow: "M\u0169i t\xEAn",
  toolbarAnnotationsArrowDown: "M\u0169i t\xEAn xu\u1ED1ng",
  toolbarAnnotationsArrowUp: "M\u0169i t\xEAn l\xEAn",
  toolbarAnnotationsCallout: "Ch\xFA th\xEDch",
  toolbarAnnotationsClearAll: "X\xF3a t\u1EA5t c\u1EA3",
  toolbarAnnotationsComment: "B\xECnh lu\u1EADn",
  toolbarAnnotationsDatePriceRange: "Ng\xE0y v\xE0 Gi\xE1",
  toolbarAnnotationsDateRange: "Kho\u1EA3ng th\u1EDDi gian",
  toolbarAnnotationsDelete: "X\xF3a",
  toolbarAnnotationsDisjointChannel: "K\xEAnh kh\xF4ng li\xEAn t\u1EE5c",
  toolbarAnnotationsDragHandle: "K\xE9o Thanh C\xF4ng C\u1EE5",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Fib Ph\u1EE5c h\u1ED3i",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u0110\u01B0\u1EDDng xu h\u01B0\u1EDBng d\u1EF1a tr\xEAn Fibonacci",
  toolbarAnnotationsFillColor: "M\xE0u n\u1EC1n",
  toolbarAnnotationsHorizontalLine: "\u0110\u01B0\u1EDDng Ngang",
  toolbarAnnotationsLineAnnotations: "\u0110\u01B0\u1EDDng Xu H\u01B0\u1EDBng",
  toolbarAnnotationsLineColor: "M\xE0u \u0110\u01B0\u1EDDng",
  toolbarAnnotationsLineStrokeWidth: "\u0110\u1ED9 r\u1ED9ng n\xE9t v\u1EBD",
  toolbarAnnotationsLineStyle: "Ki\u1EC3u \u0110\u01B0\u1EDDng",
  toolbarAnnotationsLock: "Kh\xF3a",
  toolbarAnnotationsMeasurerAnnotations: "C\xF4ng c\u1EE5 \u0111o l\u01B0\u1EDDng",
  toolbarAnnotationsNote: "Ghi ch\xFA",
  toolbarAnnotationsParallelChannel: "K\xEAnh Song Song",
  toolbarAnnotationsPriceRange: "Kho\u1EA3ng Gi\xE1",
  toolbarAnnotationsQuickDatePriceRange: "\u0110o l\u01B0\u1EDDng",
  toolbarAnnotationsSettings: "C\xE0i \u0111\u1EB7t",
  toolbarAnnotationsShapeAnnotations: "M\u0169i t\xEAn",
  toolbarAnnotationsText: "V\u0103n b\u1EA3n",
  toolbarAnnotationsTextAnnotations: "Ch\xFA th\xEDch v\u0103n b\u1EA3n",
  toolbarAnnotationsTextColor: "M\xE0u ch\u1EEF",
  toolbarAnnotationsTextSize: "K\xEDch Th\u01B0\u1EDBc V\u0103n B\u1EA3n",
  toolbarAnnotationsTrendLine: "\u0110\u01B0\u1EDDng xu h\u01B0\u1EDBng",
  toolbarAnnotationsUnlock: "M\u1EDF kh\xF3a",
  toolbarAnnotationsVerticalLine: "\u0110\u01B0\u1EDDng th\u1EB3ng \u0111\u1EE9ng",
  toolbarRange1Month: "1T",
  toolbarRange1MonthAria: "1 th\xE1ng",
  toolbarRange1Year: "1N",
  toolbarRange1YearAria: "1 n\u0103m",
  toolbarRange3Months: "3 Th\xE1ng",
  toolbarRange3MonthsAria: "3 th\xE1ng",
  toolbarRange6Months: "6T",
  toolbarRange6MonthsAria: "6 th\xE1ng",
  toolbarRangeAll: "T\u1EA5t c\u1EA3",
  toolbarRangeAllAria: "T\u1EA5t c\u1EA3",
  toolbarRangeYearToDate: "T\u1EEB \u0111\u1EA7u n\u0103m \u0111\u1EBFn nay",
  toolbarRangeYearToDateAria: "T\u1EEB \u0111\u1EA7u n\u0103m \u0111\u1EBFn nay",
  toolbarSeriesTypeCandles: "N\u1EBFn",
  toolbarSeriesTypeDropdown: "Lo\u1EA1i Bi\u1EC3u \u0110\u1ED3",
  toolbarSeriesTypeHighLow: "Cao Th\u1EA5p",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "N\u1EBFn R\u1ED7ng",
  toolbarSeriesTypeLine: "\u0110\u01B0\u1EDDng",
  toolbarSeriesTypeLineWithMarkers: "\u0110\u01B0\u1EDDng c\xF3 \u0111i\u1EC3m \u0111\xE1nh d\u1EA5u",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u0110\u01B0\u1EDDng b\u1EADc thang",
  toolbarZoomPanEnd: "Di chuy\u1EC3n \u0111\u1EBFn cu\u1ED1i",
  toolbarZoomPanLeft: "Di chuy\u1EC3n sang tr\xE1i",
  toolbarZoomPanRight: "Di chuy\u1EC3n sang ph\u1EA3i",
  toolbarZoomPanStart: "Di chuy\u1EC3n ngang tr\u1EDF l\u1EA1i \u0111\u1EA7u trang",
  toolbarZoomReset: "\u0110\u1EB7t l\u1EA1i thu ph\xF3ng",
  toolbarZoomZoomIn: "Thu nh\u1ECF",
  toolbarZoomZoomOut: "Thu nh\u1ECF",
  tooltipPaginationStatus: "${index}[number] trong s\u1ED1 ${count}[number]"
};
var AG_CHARTS_LOCALE_ZH_CN = {
  ariaAnnounceChart: "\u56FE\u8868\uFF0C\u5171\u6709${seriesCount}[number]\u4E2A\u7CFB\u5217",
  ariaAnnounceFlowProportionLink: "\u94FE\u63A5 ${index} \u603B\u5171 ${count}\uFF0C\u4ECE ${from} \u5230 ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u8282\u70B9 ${index} \u4E4B ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u4EEA\u8868\u76D8\u56FE\u8868, ${caption}",
  ariaAnnounceHierarchyChart: "\u5C42\u6B21\u56FE\u8868, ${caption}",
  ariaAnnounceHierarchyDatum: "\u7EA7\u522B ${level}[number], ${count}[number] \u5B50\u9879, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u6309\u7A7A\u683C\u952E\u6216\u56DE\u8F66\u952E\u5207\u6362\u53EF\u89C1\u6027",
  ariaLabelAddHorizontalLine: "\u6DFB\u52A0\u6C34\u5E73\u7EBF",
  ariaLabelAnnotationOptionsToolbar: "\u6CE8\u91CA\u9009\u9879",
  ariaLabelAnnotationSettingsDialog: "\u6CE8\u91CA\u8BBE\u7F6E",
  ariaLabelColorPicker: "\u989C\u8272\u9009\u62E9\u5668",
  ariaLabelFinancialCharts: "\u8D22\u52A1\u56FE\u8868",
  ariaLabelLegend: "\u56FE\u4F8B",
  ariaLabelLegendItem: "${label}, \u56FE\u4F8B\u9879 ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\u672A\u77E5\u56FE\u4F8B\u9879\u76EE",
  ariaLabelLegendPageNext: "\u4E0B\u4E00\u9875\u56FE\u4F8B",
  ariaLabelLegendPagePrevious: "\u4E0A\u4E00\u4F20\u5947\u9875\u9762",
  ariaLabelLegendPagination: "\u56FE\u4F8B\u5206\u9875",
  ariaLabelNavigator: "\u5BFC\u822A\u5668",
  ariaLabelNavigatorMaximum: "\u6700\u5927\u503C",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F\u503C",
  ariaLabelNavigatorRange: "\u8303\u56F4",
  ariaLabelRangesToolbar: "\u8303\u56F4",
  ariaLabelSettingsTabBar: "\u8BBE\u7F6E",
  ariaLabelZoomToolbar: "\u7F29\u653E",
  ariaValuePanRange: "${min}[percent0to2dp] \u81F3 ${max}[percent0to2dp]",
  contextMenuDownload: "\u4E0B\u8F7D",
  contextMenuPanToCursor: "\u5E73\u79FB\u5230\u6B64\u5904",
  contextMenuToggleOtherSeries: "\u5207\u6362\u5176\u4ED6\u7CFB\u5217",
  contextMenuToggleSeriesVisibility: "\u5207\u6362\u53EF\u89C1\u6027",
  contextMenuZoomToCursor: "\u7F29\u653E\u5230\u6B64\u5904",
  dialogHeaderChannel: "\u9891\u9053",
  dialogHeaderDatePriceRange: "\u65E5\u671F\u548C\u4EF7\u683C",
  dialogHeaderDateRange: "\u65E5\u671F\u8303\u56F4",
  dialogHeaderFibonacciRange: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  dialogHeaderLine: "\u7EBF",
  dialogHeaderPriceRange: "\u4EF7\u683C\u8303\u56F4",
  dialogHeaderText: "\u6587\u5B57",
  dialogInputAlign: "\u5BF9\u9F50",
  dialogInputColorPicker: "\u989C\u8272",
  dialogInputColorPickerAltText: "\u6587\u5B57\u989C\u8272",
  dialogInputExtendAbove: "\u6269\u5C55\u4EE5\u4E0A",
  dialogInputExtendBelow: "\u5411\u4E0B\u6269\u5C55",
  dialogInputExtendChannelEnd: "\u6269\u5C55\u901A\u9053\u7EC8\u70B9",
  dialogInputExtendChannelStart: "\u5EF6\u957F\u901A\u9053\u5F00\u59CB",
  dialogInputExtendLeft: "\u5411\u5DE6\u5EF6\u4F38",
  dialogInputExtendLineEnd: "\u5EF6\u957F\u7EBF\u7AEF",
  dialogInputExtendLineStart: "\u5EF6\u957F\u7EBF\u8D77\u70B9",
  dialogInputExtendRight: "\u5411\u53F3\u5EF6\u4F38",
  dialogInputFibonacciBands: "\u6CE2\u6BB5",
  dialogInputFibonacciBandsAltText: "\u6590\u6CE2\u90A3\u5951\u6CE2\u6BB5",
  dialogInputFillColorPicker: "\u586B\u5145",
  dialogInputFillColorPickerAltText: "\u586B\u5145\u989C\u8272",
  dialogInputFontSize: "\u5927\u5C0F",
  dialogInputFontSizeAltText: "\u5B57\u4F53\u5927\u5C0F",
  dialogInputLineStyle: "\u865A\u7EBF",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u8F6C",
  dialogInputShowFill: "\u663E\u793A\u586B\u5145",
  dialogInputStrokeWidth: "\u2018\u7C97\u7EC6\u2019",
  dialogInputStrokeWidthAltText: "\u2018\u7EBF\u6761\u7C97\u7EC6\u2019",
  iconAltTextAlignCenter: "\u5C45\u4E2D",
  iconAltTextAlignLeft: "\u5C45\u5DE6",
  iconAltTextAlignRight: "\u53F3\u5BF9\u9F50",
  iconAltTextClose: "\u2018\u5173\u95ED\u2019",
  iconAltTextLineStyleDashed: "\u957F\u865A\u7EBF",
  iconAltTextLineStyleDotted: "\u77ED\u865A\u7EBF",
  iconAltTextLineStyleSolid: "\u5B9E\u7EBF",
  iconAltTextPositionBottom: "\u5E95\u90E8",
  iconAltTextPositionCenter: "\u5C45\u4E2D",
  iconAltTextPositionTop: "\u9876\u90E8",
  inputTextareaPlaceholder: "\u6DFB\u52A0\u6587\u5B57",
  measurerDateRangeBars: "${value}[number] \u6761",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u4F53\u79EF ${value}",
  overlayLoadingData: "\u6B63\u5728\u52A0\u8F7D\u6570\u636E...",
  overlayNoData: "\u6CA1\u6709\u6570\u636E\u663E\u793A",
  overlayNoVisibleSeries: "\u6CA1\u6709\u53EF\u89C1\u7684\u7CFB\u5217",
  overlayUnsupportedBrowser: "\u4E0D\u517C\u5BB9\u7684\u6D4F\u89C8\u5668\u7248\u672C\u3002\u8BF7\u5347\u7EA7\u60A8\u7684\u6D4F\u89C8\u5668\u3002",
  seriesHistogramTooltipCount: "${yName} (\u8BA1\u6570)",
  seriesHistogramTooltipFrequency: "\u9891\u7387",
  seriesHistogramTooltipMean: "${yName} (\u5E73\u5747\u503C)",
  seriesHistogramTooltipSum: "${yName} (\u603B\u548C)",
  toolbarAnnotationsArrow: "\u7BAD\u5934",
  toolbarAnnotationsArrowDown: "\u7BAD\u5934\u5411\u4E0B",
  toolbarAnnotationsArrowUp: "\u5411\u4E0A\u7BAD\u5934",
  toolbarAnnotationsCallout: "\u6807\u6CE8",
  toolbarAnnotationsClearAll: "\u6E05\u9664\u6240\u6709",
  toolbarAnnotationsComment: "\u8BC4\u8BBA",
  toolbarAnnotationsDatePriceRange: "\u65E5\u671F\u548C\u4EF7\u683C",
  toolbarAnnotationsDateRange: "\u65E5\u671F\u8303\u56F4",
  toolbarAnnotationsDelete: "\u5220\u9664",
  toolbarAnnotationsDisjointChannel: "\u72EC\u7ACB\u901A\u9053",
  toolbarAnnotationsDragHandle: "\u201C\u62D6\u52A8\u5DE5\u5177\u680F\u201D",
  toolbarAnnotationsFibonacciAnnotations: "\u6590\u6CE2\u90A3\u5951",
  toolbarAnnotationsFibonacciRetracement: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u57FA\u4E8E\u8D8B\u52BF\u7684\u6590\u6CE2\u7EB3\u5951",
  toolbarAnnotationsFillColor: "\u586B\u5145\u989C\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7EBF",
  toolbarAnnotationsLineAnnotations: "\u8D8B\u52BF\u7EBF",
  toolbarAnnotationsLineColor: "\u7EBF\u6761\u989C\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7EBF\u6761\u5BBD\u5EA6",
  toolbarAnnotationsLineStyle: "\u7EBF\u6761\u6837\u5F0F",
  toolbarAnnotationsLock: "\u9501\u5B9A",
  toolbarAnnotationsMeasurerAnnotations: "\u6D4B\u91CF\u5DE5\u5177",
  toolbarAnnotationsNote: "\u6CE8\u91CA",
  toolbarAnnotationsParallelChannel: "\u5E73\u884C\u901A\u9053",
  toolbarAnnotationsPriceRange: "\u4EF7\u683C\u8303\u56F4",
  toolbarAnnotationsQuickDatePriceRange: "\u6D4B\u91CF",
  toolbarAnnotationsSettings: "\u8BBE\u7F6E",
  toolbarAnnotationsShapeAnnotations: "\u7BAD\u5934",
  toolbarAnnotationsText: "\u6587\u672C",
  toolbarAnnotationsTextAnnotations: "\u6587\u672C\u6807\u6CE8",
  toolbarAnnotationsTextColor: "\u5B57\u4F53\u989C\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u5927\u5C0F",
  toolbarAnnotationsTrendLine: "\u8D8B\u52BF\u7EBF",
  toolbarAnnotationsUnlock: "\u89E3\u9501",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7EBF",
  toolbarRange1Month: "1\u4E2A\u6708",
  toolbarRange1MonthAria: "1\u4E2A\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u4E2A\u6708",
  toolbarRange3MonthsAria: "3\u4E2A\u6708",
  toolbarRange6Months: "6\u6708",
  toolbarRange6MonthsAria: "6\u4E2A\u6708",
  toolbarRangeAll: "\u5168\u90E8",
  toolbarRangeAllAria: "\u5168\u90E8",
  toolbarRangeYearToDate: "\u5E74\u521D\u81F3\u4ECA",
  toolbarRangeYearToDateAria: "\u5E74\u521D\u81F3\u4ECA",
  toolbarSeriesTypeCandles: "\u8721\u70DB\u56FE",
  toolbarSeriesTypeDropdown: "\u56FE\u8868\u7C7B\u578B",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u5FC3\u8721\u70DB",
  toolbarSeriesTypeLine: "\u7EBF",
  toolbarSeriesTypeLineWithMarkers: "\u5E26\u6807\u8BB0\u7684\u6298\u7EBF\u56FE",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u9636\u68AF\u7EBF",
  toolbarZoomPanEnd: "\u79FB\u81F3\u7ED3\u5C3E",
  toolbarZoomPanLeft: "\u5411\u5DE6\u79FB\u52A8",
  toolbarZoomPanRight: "\u5411\u53F3\u5E73\u79FB",
  toolbarZoomPanStart: "\u5E73\u79FB\u5230\u5F00\u59CB\u4F4D\u7F6E",
  toolbarZoomReset: "\u91CD\u7F6E\u7F29\u653E",
  toolbarZoomZoomIn: "\u653E\u5927",
  toolbarZoomZoomOut: "\u7F29\u5C0F",
  tooltipPaginationStatus: "${index}[number] / ${count}[number]"
};
var AG_CHARTS_LOCALE_ZH_HK = {
  ariaAnnounceChart: "\u5716\u8868\uFF0C${seriesCount}[number] \u7CFB\u5217",
  ariaAnnounceFlowProportionLink: "\u9023\u7D50 ${index} \u7684 ${count}\uFF0C\u5F9E ${from} \u5230 ${to}\uFF0C${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u7BC0\u9EDE ${index} \u5728 ${count} \u4E2D, ${description}",
  ariaAnnounceGaugeChart: "\u5100\u8868\u5716, ${caption}",
  ariaAnnounceHierarchyChart: "\u5C64\u6B21\u5716, ${caption}",
  ariaAnnounceHierarchyDatum: "\u5C64\u7D1A ${level}[number]\uFF0C${count}[number] \u500B\u5B50\u9805\uFF0C${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u6309\u7A7A\u683C\u6216 Enter \u9375\u5207\u63DB\u53EF\u898B\u6027",
  ariaLabelAddHorizontalLine: "\u6DFB\u52A0\u6C34\u5E73\u7DDA",
  ariaLabelAnnotationOptionsToolbar: "\u8A3B\u89E3\u9078\u9805",
  ariaLabelAnnotationSettingsDialog: "\u8A3B\u91CB\u8A2D\u7F6E",
  ariaLabelColorPicker: "\u984F\u8272\u9078\u64C7\u5668",
  ariaLabelFinancialCharts: "\u8CA1\u52D9\u5716\u8868",
  ariaLabelLegend: "\u5716\u4F8B",
  ariaLabelLegendItem: "${label}, \u5716\u4F8B\u9805\u76EE\u7B2C ${index}[number] / ${count}[number]",
  ariaLabelLegendItemUnknown: "\u672A\u77E5\u7684\u5716\u4F8B\u9805\u76EE",
  ariaLabelLegendPageNext: "\u4E0B\u4E00\u9801\u5716\u4F8B",
  ariaLabelLegendPagePrevious: "\u4E0A\u4E00\u9801\u5716\u4F8B",
  ariaLabelLegendPagination: "\u5716\u4F8B\u5206\u9801",
  ariaLabelNavigator: "\u5C0E\u822A\u5668",
  ariaLabelNavigatorMaximum: "\u6700\u5927",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F\u503C",
  ariaLabelNavigatorRange: "\u7BC4\u570D",
  ariaLabelRangesToolbar: "\u7BC4\u570D",
  ariaLabelSettingsTabBar: "\u8A2D\u5B9A",
  ariaLabelZoomToolbar: "\u7E2E\u653E",
  ariaValuePanRange: "${min}[percent0to2dp] \u81F3 ${max}[percent0to2dp]",
  contextMenuDownload: "\u4E0B\u8F09",
  contextMenuPanToCursor: "\u5E73\u79FB\u5230\u9019\u88E1",
  contextMenuToggleOtherSeries: "\u5207\u63DB\u5176\u4ED6\u7CFB\u5217",
  contextMenuToggleSeriesVisibility: "\u5207\u63DB\u986F\u793A",
  contextMenuZoomToCursor: "\u653E\u5927\u81F3\u6B64\u8655",
  dialogHeaderChannel: "\u983B\u9053",
  dialogHeaderDatePriceRange: "\u65E5\u671F\u53CA\u50F9\u683C",
  dialogHeaderDateRange: "\u65E5\u671F\u7BC4\u570D",
  dialogHeaderFibonacciRange: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  dialogHeaderLine: "\u7DDA",
  dialogHeaderPriceRange: "\u50F9\u683C\u7BC4\u570D",
  dialogHeaderText: "\u6587\u5B57",
  dialogInputAlign: "\u5C0D\u9F4A",
  dialogInputColorPicker: "\u984F\u8272",
  dialogInputColorPickerAltText: "\u6587\u5B57\u984F\u8272",
  dialogInputExtendAbove: "\u64F4\u5C55\u81F3\u4E0A\u65B9",
  dialogInputExtendBelow: "\u5411\u4E0B\u5EF6\u5C55",
  dialogInputExtendChannelEnd: "\u64F4\u5C55\u901A\u9053\u7D50\u675F",
  dialogInputExtendChannelStart: "\u5EF6\u9577\u901A\u9053\u8D77\u9EDE",
  dialogInputExtendLeft: "\u5411\u5DE6\u6269\u5C55",
  dialogInputExtendLineEnd: "\u5EF6\u9577\u7DDA\u672B\u7AEF",
  dialogInputExtendLineStart: "\u5EF6\u9577\u7DDA\u7684\u8D77\u9EDE",
  dialogInputExtendRight: "\u5411\u53F3\u5EF6\u4F38",
  dialogInputFibonacciBands: "\u6CE2\u6BB5",
  dialogInputFibonacciBandsAltText: "\u6590\u6CE2\u90A3\u5951\u6CE2\u6BB5",
  dialogInputFillColorPicker: "\u586B\u6EFF",
  dialogInputFillColorPickerAltText: "\u586B\u5145\u984F\u8272",
  dialogInputFontSize: "\u5927\u5C0F",
  dialogInputFontSizeAltText: "\u5B57\u578B\u5927\u5C0F",
  dialogInputLineStyle: "\u865B\u7DDA",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u8F49",
  dialogInputShowFill: "\u986F\u793A\u586B\u5145",
  dialogInputStrokeWidth: "\u7DDA\u5BEC",
  dialogInputStrokeWidthAltText: "\u7DDA\u689D\u7C97\u7D30",
  iconAltTextAlignCenter: "\u300C\u7F6E\u4E2D\u300D",
  iconAltTextAlignLeft: "\u5DE6",
  iconAltTextAlignRight: "\u53F3",
  iconAltTextClose: "\u95DC\u9589",
  iconAltTextLineStyleDashed: "\u9577\u865B\u7DDA",
  iconAltTextLineStyleDotted: "\u77ED\u865B\u7DDA",
  iconAltTextLineStyleSolid: "\u5BE6\u7DDA",
  iconAltTextPositionBottom: "\u4E0B\u65B9",
  iconAltTextPositionCenter: "\u4E2D\u9593",
  iconAltTextPositionTop: "\u9802\u90E8",
  inputTextareaPlaceholder: "\u6DFB\u52A0\u6587\u5B57",
  measurerDateRangeBars: "${value}[number] \u689D",
  measurerPriceRangePercent: "${value}[percent]\u9999\u6E2F",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u9AD4\u7A4D ${value}",
  overlayLoadingData: "\u6B63\u5728\u8F09\u5165\u6578\u64DA...",
  overlayNoData: "\u6C92\u6709\u8CC7\u6599\u5C55\u793A",
  overlayNoVisibleSeries: "\u6C92\u6709\u53EF\u898B\u7684\u7CFB\u5217",
  overlayUnsupportedBrowser: "\u700F\u89BD\u5668\u7248\u672C\u4E0D\u517C\u5BB9\u3002 \u8ACB\u5347\u7D1A\u60A8\u7684\u700F\u89BD\u5668\u3002",
  seriesHistogramTooltipCount: "${yName}\uFF08\u8A08\u6578\uFF09",
  seriesHistogramTooltipFrequency: "\u983B\u7387",
  seriesHistogramTooltipMean: "${yName}\uFF08\u5E73\u5747\uFF09",
  seriesHistogramTooltipSum: "${yName}\uFF08\u7E3D\u548C\uFF09",
  toolbarAnnotationsArrow: "\u7BAD\u5480",
  toolbarAnnotationsArrowDown: "\u5411\u4E0B\u7BAD\u982D",
  toolbarAnnotationsArrowUp: "\u4E0A\u7BAD\u982D",
  toolbarAnnotationsCallout: "\u6A19\u6CE8",
  toolbarAnnotationsClearAll: "\u6E05\u9664\u5168\u90E8",
  toolbarAnnotationsComment: "\u8A55\u8AD6",
  toolbarAnnotationsDatePriceRange: "\u65E5\u671F\u548C\u50F9\u683C",
  toolbarAnnotationsDateRange: "\u65E5\u671F\u7BC4\u570D",
  toolbarAnnotationsDelete: "\u522A\u9664",
  toolbarAnnotationsDisjointChannel: "\u7368\u7ACB\u983B\u9053",
  toolbarAnnotationsDragHandle: "\u62D6\u52D5\u5DE5\u5177\u6B04",
  toolbarAnnotationsFibonacciAnnotations: "\u6590\u6CE2\u90A3\u5951",
  toolbarAnnotationsFibonacciRetracement: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u6590\u6CE2\u90A3\u5951\u8DA8\u52E2\u57FA\u65BC",
  toolbarAnnotationsFillColor: "\u586B\u5145\u984F\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7DDA",
  toolbarAnnotationsLineAnnotations: "\u8DA8\u52E2\u7DDA",
  toolbarAnnotationsLineColor: "\u7DDA\u689D\u984F\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7DDA\u689D\u5BEC\u5EA6",
  toolbarAnnotationsLineStyle: "\u7DDA\u689D\u6A23\u5F0F",
  toolbarAnnotationsLock: "\u9396\u5B9A",
  toolbarAnnotationsMeasurerAnnotations: "\u6E2C\u91CF\u5DE5\u5177",
  toolbarAnnotationsNote: "\u8A3B\u91CB",
  toolbarAnnotationsParallelChannel: "\u5E73\u884C\u901A\u9053",
  toolbarAnnotationsPriceRange: "\u50F9\u683C\u7BC4\u570D",
  toolbarAnnotationsQuickDatePriceRange: "\u6E2C\u91CF",
  toolbarAnnotationsSettings: "\u8A2D\u7F6E",
  toolbarAnnotationsShapeAnnotations: "\u7BAD\u5480",
  toolbarAnnotationsText: "\u6587\u5B57",
  toolbarAnnotationsTextAnnotations: "\u6587\u5B57\u6A19\u8A3B",
  toolbarAnnotationsTextColor: "\u6587\u5B57\u984F\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u5927\u5C0F",
  toolbarAnnotationsTrendLine: "\u8DA8\u52E2\u7DDA",
  toolbarAnnotationsUnlock: "\u89E3\u9396",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7DDA",
  toolbarRange1Month: "1\u500B\u6708",
  toolbarRange1MonthAria: "1\u500B\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u500B\u6708",
  toolbarRange3MonthsAria: "3 \u500B\u6708",
  toolbarRange6Months: "6\u500B\u6708",
  toolbarRange6MonthsAria: "6\u500B\u6708",
  toolbarRangeAll: "\u5168\u90E8",
  toolbarRangeAllAria: "\u5168\u90E8",
  toolbarRangeYearToDate: "\u5E74\u521D\u81F3\u4ECA",
  toolbarRangeYearToDateAria: "\u5E74\u521D\u81F3\u4ECA",
  toolbarSeriesTypeCandles: "\u881F\u71ED",
  toolbarSeriesTypeDropdown: "\u5716\u8868\u7A2E\u985E",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "\u9AD8\u4F4E\u6536",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u5FC3\u881F\u71ED",
  toolbarSeriesTypeLine: "\u7DDA\u5716",
  toolbarSeriesTypeLineWithMarkers: "\u5E36\u6A19\u8A18\u7684\u6298\u7DDA\u5716",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u968E\u68AF\u7DDA",
  toolbarZoomPanEnd: "\u5E73\u79FB\u81F3\u7D50\u5C3E",
  toolbarZoomPanLeft: "\u5411\u5DE6\u5E73\u79FB",
  toolbarZoomPanRight: "\u5411\u53F3\u5E73\u79FB",
  toolbarZoomPanStart: "\u79FB\u5230\u8D77\u9EDE",
  toolbarZoomReset: "\u91CD\u8A2D\u7E2E\u653E",
  toolbarZoomZoomIn: "\u653E\u5927",
  toolbarZoomZoomOut: "\u7E2E\u5C0F",
  tooltipPaginationStatus: "${index}[number] \u7684 ${count}[number]"
};
var AG_CHARTS_LOCALE_ZH_TW = {
  ariaAnnounceChart: "\u5716\u8868\uFF0C${seriesCount}[number] \u500B\u7CFB\u5217",
  ariaAnnounceFlowProportionLink: "\u9023\u7D50 ${index} / ${count}\uFF0C\u5F9E ${from} \u5230 ${to}\uFF0C${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "\u7BC0\u9EDE ${index} \u4E4B ${count}, ${description}",
  ariaAnnounceGaugeChart: "\u5100\u8868\u677F\u5716\u8868, ${caption}",
  ariaAnnounceHierarchyChart: "\u968E\u5C64\u5716\u8868, ${caption}",
  ariaAnnounceHierarchyDatum: "\u5C64\u7D1A ${level}[number]\uFF0C${count}[number] \u500B\u5B50\u9805\u76EE\uFF0C${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "\u6309\u7A7A\u683C\u9375\u6216\u56DE\u8ECA\u9375\u5207\u63DB\u53EF\u898B\u6027",
  ariaLabelAddHorizontalLine: "\u6DFB\u52A0\u6C34\u5E73\u7DDA\u689D",
  ariaLabelAnnotationOptionsToolbar: "\u8A3B\u89E3\u9078\u9805",
  ariaLabelAnnotationSettingsDialog: "\u8A3B\u89E3\u8A2D\u5B9A",
  ariaLabelColorPicker: "\u984F\u8272\u9078\u64C7\u5668",
  ariaLabelFinancialCharts: "\u8CA1\u52D9\u5716\u8868",
  ariaLabelLegend: "\u5716\u4F8B",
  ariaLabelLegendItem: "${label}, \u5716\u4F8B\u9805\u76EE ${index}[number]\uFF0C\u7E3D\u5171 ${count}[number]",
  ariaLabelLegendItemUnknown: "\u672A\u77E5\u7684\u5716\u4F8B\u9805\u76EE",
  ariaLabelLegendPageNext: "\u4E0B\u4E00\u9801\u5716\u4F8B",
  ariaLabelLegendPagePrevious: "\u524D\u4E00\u5716\u4F8B\u9801\u9762",
  ariaLabelLegendPagination: "\u5716\u4F8B\u5206\u9801",
  ariaLabelNavigator: "\u5C0E\u822A\u5668",
  ariaLabelNavigatorMaximum: "\u6700\u5927\u503C",
  ariaLabelNavigatorMinimum: "\u6700\u5C0F",
  ariaLabelNavigatorRange: "\u7BC4\u570D",
  ariaLabelRangesToolbar: "\u7BC4\u570D",
  ariaLabelSettingsTabBar: "\u8A2D\u5B9A",
  ariaLabelZoomToolbar: "\u7E2E\u653E",
  ariaValuePanRange: "${min}[percent0to2dp] \u5230 ${max}[percent0to2dp]",
  contextMenuDownload: "\u4E0B\u8F7D",
  contextMenuPanToCursor: "\u5E73\u79FB\u5230\u6B64\u8655",
  contextMenuToggleOtherSeries: "\u5207\u63DB\u5176\u4ED6\u7CFB\u5217",
  contextMenuToggleSeriesVisibility: "\u5207\u63DB\u53EF\u898B\u6027",
  contextMenuZoomToCursor: "\u7E2E\u653E\u81F3\u6B64",
  dialogHeaderChannel: "\u983B\u9053",
  dialogHeaderDatePriceRange: "\u65E5\u671F\u548C\u50F9\u683C",
  dialogHeaderDateRange: "\u65E5\u671F\u7BC4\u570D",
  dialogHeaderFibonacciRange: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  dialogHeaderLine: "\u7DDA\u689D",
  dialogHeaderPriceRange: "\u50F9\u683C\u7BC4\u570D",
  dialogHeaderText: "\u6587\u5B57",
  dialogInputAlign: "\u5C0D\u9F4A",
  dialogInputColorPicker: "\u984F\u8272",
  dialogInputColorPickerAltText: "\u6587\u5B57\u984F\u8272",
  dialogInputExtendAbove: "\u5411\u4E0A\u64F4\u5C55",
  dialogInputExtendBelow: "\u64F4\u5C55\u81F3\u4E0B\u65B9",
  dialogInputExtendChannelEnd: "\u5EF6\u4F38\u901A\u9053\u672B\u7AEF",
  dialogInputExtendChannelStart: "\u5EF6\u4F38\u901A\u9053\u8D77\u9EDE",
  dialogInputExtendLeft: "\u5411\u5DE6\u5EF6\u4F38",
  dialogInputExtendLineEnd: "\u5EF6\u4F38\u7DDA\u6BB5\u672B\u7AEF",
  dialogInputExtendLineStart: "\u5EF6\u4F38\u7DDA\u689D\u8D77\u9EDE",
  dialogInputExtendRight: "\u5EF6\u4F38\u81F3\u53F3\u908A",
  dialogInputFibonacciBands: "\u983B\u5E36",
  dialogInputFibonacciBandsAltText: "\u6590\u6CE2\u90A3\u5951\u983B\u5E36",
  dialogInputFillColorPicker: "\u586B\u5145",
  dialogInputFillColorPickerAltText: "\u586B\u5145\u984F\u8272",
  dialogInputFontSize: "\u5927\u5C0F",
  dialogInputFontSizeAltText: "\u5B57\u9AD4\u5927\u5C0F",
  dialogInputLineStyle: "\u865B\u7DDA",
  dialogInputPosition: "\u4F4D\u7F6E",
  dialogInputReverse: "\u53CD\u5411",
  dialogInputShowFill: "\u986F\u793A\u586B\u5145",
  dialogInputStrokeWidth: "\u7C97\u7D30",
  dialogInputStrokeWidthAltText: "\u7DDA\u689D\u7C97\u7D30",
  iconAltTextAlignCenter: "\u7F6E\u4E2D",
  iconAltTextAlignLeft: "\u5DE6",
  iconAltTextAlignRight: "\u53F3",
  iconAltTextClose: "\u95DC\u9589",
  iconAltTextLineStyleDashed: "\u9577\u865B\u7DDA",
  iconAltTextLineStyleDotted: "\u77ED\u865B\u7DDA",
  iconAltTextLineStyleSolid: "\u5BE6\u7DDA",
  iconAltTextPositionBottom: "\u5E95\u90E8",
  iconAltTextPositionCenter: "\u4E2D\u5FC3",
  iconAltTextPositionTop: "\u9802\u7AEF",
  inputTextareaPlaceholder: "\u6DFB\u52A0\u6587\u5B57",
  measurerDateRangeBars: "${value}[number] \u6839\u689D",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "\u9AD4\u7A4D ${value}",
  overlayLoadingData: "\u6B63\u5728\u8F09\u5165\u6578\u64DA...",
  overlayNoData: "\u6C92\u6709\u8CC7\u6599\u53EF\u986F\u793A",
  overlayNoVisibleSeries: "\u6C92\u6709\u53EF\u898B\u7684\u7CFB\u5217",
  overlayUnsupportedBrowser: "\u700F\u89BD\u5668\u7248\u672C\u4E0D\u76F8\u5BB9\u3002\u8ACB\u5347\u7D1A\u60A8\u7684\u700F\u89BD\u5668\u3002",
  seriesHistogramTooltipCount: "${yName} (\u8A08\u6578)",
  seriesHistogramTooltipFrequency: "\u983B\u7387",
  seriesHistogramTooltipMean: "${yName} (\u5E73\u5747\u503C)",
  seriesHistogramTooltipSum: "${yName} (\u7E3D\u548C)",
  toolbarAnnotationsArrow: "\u7BAD\u982D",
  toolbarAnnotationsArrowDown: "\u4E0B\u7BAD\u982D",
  toolbarAnnotationsArrowUp: "\u5411\u4E0A\u7BAD\u982D",
  toolbarAnnotationsCallout: "\u6CE8\u91CB",
  toolbarAnnotationsClearAll: "\u5168\u90E8\u6E05\u9664",
  toolbarAnnotationsComment: "\u8A3B\u89E3",
  toolbarAnnotationsDatePriceRange: "\u65E5\u671F\u548C\u50F9\u683C",
  toolbarAnnotationsDateRange: "\u65E5\u671F\u7BC4\u570D",
  toolbarAnnotationsDelete: "\u522A\u9664",
  toolbarAnnotationsDisjointChannel: "\u975E\u9023\u7E8C\u901A\u9053",
  toolbarAnnotationsDragHandle: "\u5DE5\u5177\u6B04\u62D6\u66F3",
  toolbarAnnotationsFibonacciAnnotations: "\u6590\u6CE2\u90A3\u5951",
  toolbarAnnotationsFibonacciRetracement: "\u6590\u6CE2\u90A3\u5951\u56DE\u64A4",
  toolbarAnnotationsFibonacciRetracementTrendBased: "\u6590\u6CE2\u90A3\u5951\u8DA8\u52E2\u57FA\u7DDA",
  toolbarAnnotationsFillColor: "\u586B\u5145\u984F\u8272",
  toolbarAnnotationsHorizontalLine: "\u6C34\u5E73\u7DDA",
  toolbarAnnotationsLineAnnotations: "\u8DA8\u52E2\u7DDA",
  toolbarAnnotationsLineColor: "\u7DDA\u689D\u984F\u8272",
  toolbarAnnotationsLineStrokeWidth: "\u7DDA\u689D\u7C97\u7D30",
  toolbarAnnotationsLineStyle: "\u7DDA\u689D\u6A23\u5F0F",
  toolbarAnnotationsLock: "\u9396\u5B9A",
  toolbarAnnotationsMeasurerAnnotations: "\u6E2C\u91CF\u5DE5\u5177",
  toolbarAnnotationsNote: "\u8A3B\u89E3",
  toolbarAnnotationsParallelChannel: "\u5E73\u884C\u901A\u9053",
  toolbarAnnotationsPriceRange: "\u50F9\u683C\u7BC4\u570D",
  toolbarAnnotationsQuickDatePriceRange: "\u6E2C\u91CF",
  toolbarAnnotationsSettings: "\u8A2D\u5B9A",
  toolbarAnnotationsShapeAnnotations: "\u7BAD\u982D",
  toolbarAnnotationsText: "\u6587\u5B57",
  toolbarAnnotationsTextAnnotations: "\u6587\u5B57\u8A3B\u89E3",
  toolbarAnnotationsTextColor: "\u6587\u5B57\u984F\u8272",
  toolbarAnnotationsTextSize: "\u6587\u5B57\u5927\u5C0F",
  toolbarAnnotationsTrendLine: "\u8DA8\u52E2\u7DDA",
  toolbarAnnotationsUnlock: "\u89E3\u9396",
  toolbarAnnotationsVerticalLine: "\u5782\u76F4\u7DDA",
  toolbarRange1Month: "1\u6708",
  toolbarRange1MonthAria: "1\u500B\u6708",
  toolbarRange1Year: "1\u5E74",
  toolbarRange1YearAria: "1\u5E74",
  toolbarRange3Months: "3\u500B\u6708",
  toolbarRange3MonthsAria: "3\u500B\u6708",
  toolbarRange6Months: "6\u500B\u6708",
  toolbarRange6MonthsAria: "6\u500B\u6708",
  toolbarRangeAll: "\u5168\u90E8",
  toolbarRangeAllAria: "\u5168\u90E8",
  toolbarRangeYearToDate: "\u5E74\u521D\u81F3\u4ECA",
  toolbarRangeYearToDateAria: "\u4ECA\u5E74\u8FC4\u4ECA",
  toolbarSeriesTypeCandles: "\u881F\u71ED\u5716",
  toolbarSeriesTypeDropdown: "\u5716\u8868\u985E\u578B",
  toolbarSeriesTypeHighLow: "\u9AD8\u4F4E",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "\u7A7A\u5FC3\u881F\u71ED",
  toolbarSeriesTypeLine: "\u6298\u7DDA\u5716",
  toolbarSeriesTypeLineWithMarkers: "\u5E36\u6A19\u8A18\u7684\u6298\u7DDA\u5716",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "\u968E\u68AF\u7DDA",
  toolbarZoomPanEnd: "\u79FB\u52D5\u5230\u7D50\u5C3E",
  toolbarZoomPanLeft: "\u5411\u5DE6\u5E73\u79FB",
  toolbarZoomPanRight: "\u5411\u53F3\u5E73\u79FB",
  toolbarZoomPanStart: "\u79FB\u52D5\u5230\u8D77\u9EDE",
  toolbarZoomReset: "\u91CD\u8A2D\u7E2E\u653E",
  toolbarZoomZoomIn: "\u653E\u5927",
  toolbarZoomZoomOut: "\u7E2E\u5C0F",
  tooltipPaginationStatus: "${index}[number]\u4E2D\u7684${count}[number]"
};
if (typeof module.exports == "object" && typeof exports == "object") {
  var __cp = (to, from, except, desc) => {
    if ((from && typeof from === "object") || typeof from === "function") {
      for (let key of Object.getOwnPropertyNames(from)) {
        if (!Object.prototype.hasOwnProperty.call(to, key) && key !== except)
        Object.defineProperty(to, key, {
          get: () => from[key],
          enumerable: !(desc = Object.getOwnPropertyDescriptor(from, key)) || desc.enumerable,
        });
      }
    }
    return to;
  };
  module.exports = __cp(module.exports, exports);
}
return module.exports;
}))
//# sourceMappingURL=ag-charts-locale.js.map
